(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[203],{

/***/ 68656:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Q2": function() { return /* binding */ ContentBlockName; },
  "Dv": function() { return /* binding */ ContentLayout; },
  "S7": function() { return /* binding */ parseBasicPageContent; },
  "Og": function() { return /* binding */ parseSeoMetadata; }
});

// UNUSED EXPORTS: BasicContent, getBasicPageContentServerProps

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./src/utils/logger.ts
var utils_logger = __webpack_require__(31611);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/enrichedTextSection/EnrichedTextSection.bs.js + 4 modules
var EnrichedTextSection_bs = __webpack_require__(94135);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@emotion/css/dist/emotion-css.esm.js
var emotion_css_esm = __webpack_require__(97133);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/personal/RichText/RichText.gen.tsx
var RichText_gen = __webpack_require__(6555);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/business/FeatureBlock/FeatureBlock.gen.tsx + 1 modules
var FeatureBlock_gen = __webpack_require__(63865);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/business/FeatureBlock/FeatureBlock__Title.gen.tsx + 1 modules
var FeatureBlock_Title_gen = __webpack_require__(16900);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/business/FeatureBlock/FeatureBlock__Description.gen.tsx + 1 modules
var FeatureBlock_Description_gen = __webpack_require__(78017);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/business/FeatureBlock/FeatureBlock__CardContainer.gen.tsx + 1 modules
var FeatureBlock_CardContainer_gen = __webpack_require__(61326);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/common/IconCard/IconCard__Grid.gen.tsx + 1 modules
var IconCard_Grid_gen = __webpack_require__(58722);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/theme/Theme__Responsive.bs.js
var Theme_Responsive_bs = __webpack_require__(70965);
// EXTERNAL MODULE: ./src/components/iconCardBlock/CardBuilder.bs.js
var CardBuilder_bs = __webpack_require__(90906);
// EXTERNAL MODULE: ./src/components/pages/index/IndexStyles.bs.js
var IndexStyles_bs = __webpack_require__(28848);
// EXTERNAL MODULE: ./src/hooks/useSmartLink.tsx
var useSmartLink = __webpack_require__(12427);
// EXTERNAL MODULE: ./src/utils/Regex.tsx
var Regex = __webpack_require__(38612);
;// CONCATENATED MODULE: ./src/components/iconCardBlock/FeatureBlockSection.tsx















var classes = {
    featureBlock: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("& > div{", IndexStyles_bs/* section */.qi, "}"),
    title: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("h1{font-size:50px;line-height:63px;@media ", Theme_Responsive_bs/* tabletSm */.FV, "{font-size:50px;line-height:40px;}}h2{font-size:40px;line-height:50px;@media ", Theme_Responsive_bs/* tabletSm */.FV, "{font-size:32px;line-height:40px;}}h3{font-size:36px;line-height:46px;@media ", Theme_Responsive_bs/* tabletSm */.FV, "{font-size:32px;line-height:42px;}}h4{font-size:32px;line-height:42px;@media ", Theme_Responsive_bs/* tabletSm */.FV, "{font-size:28px;line-height:38px;}}"),
    description: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("width:100% !important;*{text-align:center;line-height:40px;margin-top:0;margin-bottom:17px;font-weight:300;@media ", Theme_Responsive_bs/* tablet */.Mq, "{margin-bottom:24px;}}")
};
var FeatureBlockSection = function(param) {
    var block = param.block;
    var title = block.title, description = block.description, icon_cards = block.icon_cards, smartLink = block.smartLink;
    var spotlightProps = (0,useSmartLink/* default */.Z)(smartLink);
    var isTitle = title.replace(new RegExp(Regex/* htmlTag */.k1, "g"), "") !== "";
    var isDescription = description.replace(new RegExp(Regex/* htmlTag */.k1, "g"), "") !== "";
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, spotlightProps), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(FeatureBlock_gen/* make */.S, {
            classname: classes.featureBlock,
            children: [
                isTitle ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(FeatureBlock_Title_gen/* make */.S, {
                    className: classes.title,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(RichText_gen/* make */.S, {
                        children: title
                    })
                }) : null,
                isDescription ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(FeatureBlock_Description_gen/* make */.S, {
                    className: classes.description,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(RichText_gen/* make */.S, {
                        children: description
                    })
                }) : null,
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(FeatureBlock_CardContainer_gen/* make */.S, {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(IconCard_Grid_gen/* make */.S, {
                        amountOfTiles: icon_cards.length,
                        perRowOnTablet: "Two",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(CardBuilder_bs/* make */.Sy, {
                            iconCards: icon_cards
                        })
                    })
                })
            ]
        })
    }));
};
/* harmony default export */ var iconCardBlock_FeatureBlockSection = (FeatureBlockSection);

// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/common/SectionHeading/SectionHeading.bs.js
var SectionHeading_bs = __webpack_require__(12387);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/business/SectionHeading/SectionHeading__Theme__Business.bs.js
var SectionHeading_Theme_Business_bs = __webpack_require__(85795);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/common/IconCard/IconCard__Theme.bs.js
var IconCard_Theme_bs = __webpack_require__(4436);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/theme/Theme__Color.bs.js
var Theme_Color_bs = __webpack_require__(17845);
// EXTERNAL MODULE: ./src/common/utils/string.ts
var string = __webpack_require__(53782);
// EXTERNAL MODULE: ./src/css/theme.ts
var theme = __webpack_require__(55374);
;// CONCATENATED MODULE: ./src/components/iconCardBlock/HowItWorksSection.tsx


















var SectionHeading = (0,SectionHeading_bs/* Component */.w)(SectionHeading_Theme_Business_bs/* Theme */.Q).make;
var HowItWorksSection_classes = {
    wrapper: function(bgColor) {
        return /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("background-color:", bgColor === string/* EMPTY_STRING */.v6 ? string/* EMPTY_STRING */.v6 : bgColor, ";");
    },
    section: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("padding-top:56px;padding-bottom:42px;@media ", Theme_Responsive_bs/* desktop */.gv, "{padding-top:82px;padding-bottom:82px;}@media ", Theme_Responsive_bs/* tablet */.Mq, "{padding-top:56px;padding-bottom:41px;}"),
    heading: function(isDescription) {
        return /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("h1,h2,h3,h4{font-weight:600;text-align:center;color:#", Theme_Color_bs/* Business.secondary.VAL */.e.secondary.VAL, ";margin-top:0;", isDescription ? "\n        margin-bottom: 17px;\n\n        @media ".concat(Theme_Responsive_bs/* tablet */.Mq, " {\n          margin-bottom: 24px;\n        }\n        ") : "\n        margin-bottom: 17px;\n\n        @media ".concat(Theme_Responsive_bs/* desktop */.gv, " {\n          margin-bottom: 67px;\n        }\n\n        @media ").concat(Theme_Responsive_bs/* tablet */.Mq, " {\n          margin-bottom: 24px;\n        }\n      "), "}h1{font-size:50px;line-height:63px;@media ", Theme_Responsive_bs/* tabletSm */.FV, "{font-size:50px;line-height:40px;}}h2{font-size:40px;line-height:50px;@media ", Theme_Responsive_bs/* tabletSm */.FV, "{font-size:32px;line-height:40px;}}h3{font-size:36px;line-height:46px;@media ", Theme_Responsive_bs/* tabletSm */.FV, "{font-size:32px;line-height:42px;}}h4{font-size:32px;line-height:42px;@media ", Theme_Responsive_bs/* tabletSm */.FV, "{font-size:28px;line-height:38px;}}");
    },
    description: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("width:100% !important;*{text-align:center;color:", theme/* Color.Gray600 */.Il.Gray600, " !important;line-height:40px;margin-top:0;margin-bottom:17px;font-weight:300;@media ", Theme_Responsive_bs/* tablet */.Mq, "{margin-bottom:24px;}}")
};
var HowItWorksSection = function(param) {
    var block = param.block;
    var title = block.title, description = block.description, icon_cards = block.icon_cards, background_colour = block.background_colour, smartLink = block.smartLink;
    var spotlightProps = (0,useSmartLink/* default */.Z)(smartLink);
    var isTitle = title.replace(new RegExp(Regex/* htmlTag */.k1, "g"), "") !== "";
    var isDescription = description.replace(new RegExp(Regex/* htmlTag */.k1, "g"), "") !== "";
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: HowItWorksSection_classes.wrapper(background_colour)
    }, spotlightProps), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
            className: (0,emotion_css_esm.cx)([
                IndexStyles_bs/* section */.qi,
                HowItWorksSection_classes.section
            ]),
            children: [
                isTitle ? // @ts-ignore
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(SectionHeading, {
                    className: HowItWorksSection_classes.heading(isDescription),
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(RichText_gen/* make */.S, {
                        children: title
                    })
                }) : null,
                isDescription ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(FeatureBlock_Description_gen/* make */.S, {
                    className: HowItWorksSection_classes.description,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(RichText_gen/* make */.S, {
                        children: description
                    })
                }) : null,
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(IconCard_Grid_gen/* make */.S, {
                    amountOfTiles: icon_cards.length,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(CardBuilder_bs/* make */.Sy, {
                        iconCards: icon_cards,
                        themeType: (0,IconCard_Theme_bs.t)()
                    })
                })
            ]
        })
    }));
};
/* harmony default export */ var iconCardBlock_HowItWorksSection = (HowItWorksSection);

;// CONCATENATED MODULE: ./src/components/pages/business/IconCardBlockSection.tsx



var thematicBlocks = {
    light: function(block) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(iconCardBlock_HowItWorksSection, {
            block: block
        });
    },
    dark: function(block) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(iconCardBlock_FeatureBlockSection, {
            block: block
        });
    }
};
var IconCardBlockSection = function(param) {
    var block = param.block;
    return thematicBlocks[block.theme](block);
};
/* harmony default export */ var business_IconCardBlockSection = (IconCardBlockSection);

// EXTERNAL MODULE: ./node_modules/bs-css-emotion/src/Css.bs.js + 7 modules
var Css_bs = __webpack_require__(90289);
// EXTERNAL MODULE: ./src/bindings/BsCss.bs.js + 1 modules
var BsCss_bs = __webpack_require__(71863);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/curry.js
var curry = __webpack_require__(92592);
// EXTERNAL MODULE: ./src/components/CmsImage.bs.js
var CmsImage_bs = __webpack_require__(34442);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/belt_Array.js
var belt_Array = __webpack_require__(96533);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/belt_Option.js
var belt_Option = __webpack_require__(72491);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/personal/Button/Button.bs.js + 1 modules
var Button_bs = __webpack_require__(10573);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/bindings/Fresnel/Fresnel.bs.js + 1 modules
var Fresnel_bs = __webpack_require__(17847);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/personal/Kontent/Kontent.bs.js
var Kontent_bs = __webpack_require__(72721);
// EXTERNAL MODULE: ./src/components/pages/index/KontentContextProvider.bs.js
var KontentContextProvider_bs = __webpack_require__(26396);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/personal/RichText/RichText.bs.js
var RichText_bs = __webpack_require__(78078);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/business/InnovativeWayToGift/InnovativeWayToGift.bs.js
var InnovativeWayToGift_bs = __webpack_require__(40863);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/business/InnovativeWayToGift/InnovativeWayToGift__CTA.bs.js
var InnovativeWayToGift_CTA_bs = __webpack_require__(98151);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/business/InnovativeWayToGift/InnovativeWayToGift__Heading.bs.js
var InnovativeWayToGift_Heading_bs = __webpack_require__(70360);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/business/InnovativeWayToGift/InnovativeWayToGift__BodyText.bs.js
var InnovativeWayToGift_BodyText_bs = __webpack_require__(73289);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/business/InnovativeWayToGift/InnovativeWayToGift__TextContainer.bs.js
var InnovativeWayToGift_TextContainer_bs = __webpack_require__(12053);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/business/InnovativeWayToGift/InnovativeWayToGift__ImageContainer.bs.js
var InnovativeWayToGift_ImageContainer_bs = __webpack_require__(17462);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/business/InnovativeWayToGift/InnovativeWayToGift__BackgroundImage.bs.js
var InnovativeWayToGift_BackgroundImage_bs = __webpack_require__(37585);
;// CONCATENATED MODULE: ./src/components/pages/business/InnovativeWayToGiftSection.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE























var InnovativeWayToGiftSection_bs_button = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* marginLeft */.oIA(BsCss_bs.px(12)),
    tl: {
        hd: BsCss_bs/* marginTop */.E9m(BsCss_bs.px(12)),
        tl: /* [] */ 0
    }
});
var backgroundImg = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* width */.bf$(BsCss_bs/* pct */.hdZ(100)),
    tl: /* [] */ 0
});
var cmsImg = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* media */.BC2(Theme_Responsive_bs/* smallScreenOrMobile */.HH, {
        hd: BsCss_bs/* maxWidth */.kkr(BsCss_bs.px(600)),
        tl: {
            hd: BsCss_bs/* marginRight */.wzR("auto"),
            tl: {
                hd: BsCss_bs/* marginLeft */.oIA("auto"),
                tl: /* [] */ 0
            }
        }
    }),
    tl: /* [] */ 0
});
var Styles = {
    button: InnovativeWayToGiftSection_bs_button,
    backgroundImg: backgroundImg,
    cmsImg: cmsImg
};
function InnovativeWayToGiftSection(props) {
    var block = props.block;
    var smartLink = block.smartLink;
    var defaultBackgroundColour = curry._1(BsCss_bs/* style */.oBv, {
        hd: BsCss_bs/* backgroundColor */.Czw(Theme_Color_bs/* Common.peach */.Gn.peach),
        tl: /* [] */ 0
    });
    var bgDesktop = belt_Option/* mapWithDefault */.k7(block.desktop_background, null, function(param) {
        return jsx_runtime.jsx(CmsImage_bs/* make */.S, {
            src: param.url,
            alt: param.description,
            width: param.width,
            height: param.height,
            className: cmsImg,
            sizes: "45vw"
        });
    });
    var bgTablet = belt_Option/* mapWithDefault */.k7(block.tablet_background, null, function(param) {
        return jsx_runtime.jsx(CmsImage_bs/* make */.S, {
            src: param.url,
            alt: param.description,
            width: param.width,
            height: param.height,
            className: cmsImg,
            sizes: "45vw"
        });
    });
    var bgMobile = belt_Option/* mapWithDefault */.k7(block.mobile_background, null, function(param) {
        return jsx_runtime.jsx(CmsImage_bs/* make */.S, {
            src: param.url,
            alt: param.description,
            width: param.width,
            height: param.height,
            className: cmsImg,
            sizes: "" + Theme_Responsive_bs/* tabletSm */.FV + " 100vw, 600px"
        });
    });
    var bgColourStyle = belt_Option/* mapWithDefault */.k7(block.background_colour, defaultBackgroundColour, function(bg) {
        return curry._1(Css_bs/* style */.oBv, {
            hd: Css_bs/* unsafe */.K47("backgroundColor", bg),
            tl: /* [] */ 0
        });
    });
    var bg = jsx_runtime.jsxs(jsx_runtime.Fragment, {
        children: [
            jsx_runtime.jsx(Fresnel_bs/* Media.make */.pU.make, {
                greaterThanOrEqual: "rbDesktop",
                children: bgDesktop
            }),
            jsx_runtime.jsx(Fresnel_bs/* Media.make */.pU.make, {
                at: "rbSmallScreen",
                children: bgTablet
            }),
            jsx_runtime.jsx(Fresnel_bs/* Media.make */.pU.make, {
                lessThan: "rbSmallScreen",
                children: bgMobile
            })
        ]
    });
    var background = jsx_runtime.jsx(InnovativeWayToGift_BackgroundImage_bs/* make */.S, {
        children: bg,
        className: backgroundImg
    });
    var heading = jsx_runtime.jsx(InnovativeWayToGift_Heading_bs/* make */.S, {
        children: jsx_runtime.jsx(RichText_bs.make, {
            children: block.title
        })
    });
    var bodyText = jsx_runtime.jsx(InnovativeWayToGift_BodyText_bs/* make */.S, {
        children: jsx_runtime.jsx(RichText_bs.make, {
            children: block.description
        })
    });
    var ctaButtons = belt_Array/* mapWithIndex */.Su(block.buttons, function(index, ctaButton) {
        var smartLink = ctaButton.smartLink;
        var target = ctaButton.open_in_new_window ? "_blank" : "";
        return jsx_runtime.jsx(Button_bs.make, {
            children: jsx_runtime.jsx((link_default()), {
                href: ctaButton.cta_url,
                prefetch: false,
                children: jsx_runtime.jsx("a", {
                    children: jsx_runtime.jsx(KontentContextProvider_bs/* make */.S, {
                        children: jsx_runtime.jsx(Kontent_bs/* Consumer.make */.$.make, {
                            children: jsx_runtime.jsx("button", {
                                children: ctaButton.cta_text
                            })
                        }),
                        itemId: smartLink.itemId,
                        elementCodename: smartLink.codename
                    }),
                    target: target
                })
            }),
            colour: /* BusinessPurple */ 3,
            variant: /* Small */ 1,
            className: InnovativeWayToGiftSection_bs_button
        }, index.toString());
    });
    var ctaLine = jsx_runtime.jsx(InnovativeWayToGift_CTA_bs/* make */.S, {
        children: ctaButtons
    });
    return jsx_runtime.jsx(KontentContextProvider_bs/* make */.S, {
        children: jsx_runtime.jsx(Kontent_bs/* Consumer.make */.$.make, {
            children: jsx_runtime.jsx("div", {
                children: jsx_runtime.jsxs(InnovativeWayToGift_bs/* make */.S, {
                    children: [
                        jsx_runtime.jsx(InnovativeWayToGift_ImageContainer_bs/* make */.S, {
                            children: background
                        }),
                        jsx_runtime.jsxs(InnovativeWayToGift_TextContainer_bs/* make */.S, {
                            children: [
                                heading,
                                bodyText,
                                ctaLine
                            ]
                        })
                    ],
                    classname: IndexStyles_bs/* section */.qi
                }),
                className: bgColourStyle
            })
        }),
        itemId: smartLink.itemId,
        elementCodename: smartLink.codename
    });
}
var InnovativeWayToGift;
var BackgroundImage;
var ImageContainer;
var TextContainer;
var Heading;
var BodyText;
var ButtonContainer;
var RichText;
var Link$1;
var KontentContextConsumer;
var make = InnovativeWayToGiftSection;
 /* button Not a pure module */ 

// EXTERNAL MODULE: ./src/components/pages/index/CategoryTilesSection.tsx
var CategoryTilesSection = __webpack_require__(36631);
// EXTERNAL MODULE: ./src/components/pages/index/UniqueSellingPointsSection.bs.js
var UniqueSellingPointsSection_bs = __webpack_require__(52659);
// EXTERNAL MODULE: ./src/components/pages/business/FAQSection.bs.js
var FAQSection_bs = __webpack_require__(41653);
// EXTERNAL MODULE: ./src/components/pages/index/FullWidthTextSection.bs.js
var FullWidthTextSection_bs = __webpack_require__(89307);
// EXTERNAL MODULE: ./src/bindings/Segment.bs.js + 1 modules
var Segment_bs = __webpack_require__(73840);
// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(67814);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/business/TheGiftExperience/TheGiftExperience.bs.js
var TheGiftExperience_bs = __webpack_require__(92626);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/business/TheGiftExperience/TheGiftExperience__CTA.bs.js
var TheGiftExperience_CTA_bs = __webpack_require__(71066);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/business/TheGiftExperience/TheGiftExperience__List.bs.js
var TheGiftExperience_List_bs = __webpack_require__(75761);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/business/TheGiftExperience/TheGiftExperience__Heading.bs.js
var TheGiftExperience_Heading_bs = __webpack_require__(91265);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/business/TheGiftExperience/TheGiftExperience__ListItem.bs.js
var TheGiftExperience_ListItem_bs = __webpack_require__(89586);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/business/TheGiftExperience/TheGiftExperience__ListItemIcon.bs.js
var TheGiftExperience_ListItemIcon_bs = __webpack_require__(77715);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/business/TheGiftExperience/TheGiftExperience__ListItemText.bs.js
var TheGiftExperience_ListItemText_bs = __webpack_require__(240);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/business/TheGiftExperience/TheGiftExperience__TextContainer.bs.js
var TheGiftExperience_TextContainer_bs = __webpack_require__(14556);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/business/TheGiftExperience/TheGiftExperience__ImageContainer.bs.js
var TheGiftExperience_ImageContainer_bs = __webpack_require__(21999);
;// CONCATENATED MODULE: ./src/components/pages/business/GiftExperienceSection.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE
























var uniqueSellingPointWrapper = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* marginBottom */.yl7(BsCss_bs.px(26)),
    tl: /* [] */ 0
});
var GiftExperienceSection_bs_Styles = {
    uniqueSellingPointWrapper: uniqueSellingPointWrapper
};
function segmentTrackBookDemoClick(param) {
    Segment_bs/* customElementInteraction */.pA({
        element: "book_a_demo_cta",
        journey: "pb_home_page"
    });
}
function GiftExperienceSection(props) {
    var block = props.block;
    var smartLink = block.smartLink;
    var heading = jsx_runtime.jsx(RichText_bs.make, {
        children: block.title
    });
    var image = belt_Option/* mapWithDefault */.k7(block.promo_image, null, function(param) {
        return jsx_runtime.jsx(CmsImage_bs/* make */.S, {
            src: param.url,
            alt: param.description,
            width: param.width,
            height: param.height,
            sizes: "" + Theme_Responsive_bs/* tabletSm */.FV + " 100vw, " + Theme_Responsive_bs/* tabletSmUp */.Uv + " 50vw, $(desktop) 544px"
        });
    });
    var theGiftExperienceItems = belt_Array/* mapWithIndex */.Su(block.list_items, function(i, item) {
        var listItemSmartLink = item.smartLink;
        var match = item.icon;
        var listIcon = match !== undefined ? jsx_runtime.jsx(index_es.FontAwesomeIcon, {
            icon: [
                match.style,
                match.icon
            ]
        }) : null;
        var descriptionText = jsx_runtime.jsx(RichText_bs.make, {
            children: item.description
        });
        return jsx_runtime.jsx(KontentContextProvider_bs/* make */.S, {
            children: jsx_runtime.jsx(Kontent_bs/* Consumer.make */.$.make, {
                children: jsx_runtime.jsx("div", {
                    children: jsx_runtime.jsxs(TheGiftExperience_ListItem_bs/* make */.Sy, {
                        children: [
                            jsx_runtime.jsx(TheGiftExperience_ListItemIcon_bs/* make */.S, {
                                children: listIcon
                            }),
                            jsx_runtime.jsx(TheGiftExperience_ListItemText_bs/* make */.S, {
                                children: jsx_runtime.jsx("span", {
                                    children: descriptionText
                                })
                            })
                        ]
                    }),
                    className: uniqueSellingPointWrapper
                }, String(i))
            }),
            itemId: listItemSmartLink.itemId,
            elementCodename: listItemSmartLink.codename
        });
    });
    var ctaItems = belt_Array/* mapWithIndex */.Su(block.buttons, function(i, item) {
        var target = item.open_in_new_window ? "_blank" : "";
        var match = item.smartLink;
        var cta_text = item.cta_text;
        return jsx_runtime.jsx(KontentContextProvider_bs/* make */.S, {
            children: jsx_runtime.jsx(Kontent_bs/* Consumer.make */.$.make, {
                children: jsx_runtime.jsx("div", {
                    children: jsx_runtime.jsx(Button_bs.make, {
                        children: jsx_runtime.jsx((link_default()), {
                            href: item.cta_url,
                            prefetch: false,
                            children: jsx_runtime.jsx("a", {
                                children: jsx_runtime.jsx("button", {
                                    children: cta_text
                                }),
                                target: target
                            })
                        }),
                        fill: item.fill,
                        colour: item.colour,
                        variant: item.variant
                    }, String(i)),
                    onClick: function onClick(param) {
                        if (cta_text === "Book a demo") {
                            return segmentTrackBookDemoClick(undefined);
                        }
                    }
                })
            }),
            itemId: match.itemId,
            elementCodename: match.codename
        }, String(i));
    });
    return jsx_runtime.jsx(KontentContextProvider_bs/* make */.S, {
        children: jsx_runtime.jsx(Kontent_bs/* Consumer.make */.$.make, {
            children: jsx_runtime.jsx("div", {
                children: jsx_runtime.jsxs(TheGiftExperience_bs/* make */.Sy, {
                    children: [
                        jsx_runtime.jsxs(TheGiftExperience_TextContainer_bs/* make */.S, {
                            children: [
                                jsx_runtime.jsx(TheGiftExperience_Heading_bs/* make */.S, {
                                    children: heading
                                }),
                                jsx_runtime.jsx(TheGiftExperience_List_bs/* make */.Sy, {
                                    children: theGiftExperienceItems
                                }),
                                jsx_runtime.jsx(TheGiftExperience_CTA_bs/* make */.S, {
                                    children: ctaItems
                                })
                            ]
                        }),
                        jsx_runtime.jsx(TheGiftExperience_ImageContainer_bs/* make */.S, {
                            children: image
                        })
                    ],
                    classname: IndexStyles_bs/* section */.qi
                })
            })
        }),
        itemId: smartLink.itemId,
        elementCodename: smartLink.codename
    });
}
var TheGiftExperience;
var GiftExperienceSection_bs_Heading;
var List;
var ListItem;
var ListItemIcon;
var ListItemText;
var GiftExperienceSection_bs_ImageContainer;
var GiftExperienceSection_bs_TextContainer;
var CTALine;
var GiftExperienceSection_bs_KontentContextConsumer;
var GiftExperienceSection_bs_RichText;
var CardIcon;
var GiftExperienceSection_bs_make = GiftExperienceSection;
 /* uniqueSellingPointWrapper Not a pure module */ 

// EXTERNAL MODULE: ./src/components/pages/index/DownloadAppsSection.bs.js
var DownloadAppsSection_bs = __webpack_require__(45305);
// EXTERNAL MODULE: ./src/components/pages/index/NewsletterSection.bs.js
var NewsletterSection_bs = __webpack_require__(86072);
// EXTERNAL MODULE: ./src/components/pages/index/HeroTileSection.bs.js
var HeroTileSection_bs = __webpack_require__(21735);
// EXTERNAL MODULE: ./src/components/pages/index/PromoSection.bs.js
var PromoSection_bs = __webpack_require__(92330);
// EXTERNAL MODULE: ./src/components/pages/index/StatsTilesSection.bs.js
var StatsTilesSection_bs = __webpack_require__(66860);
// EXTERNAL MODULE: ./src/components/pages/index/VideoTextPromoSection.bs.js
var VideoTextPromoSection_bs = __webpack_require__(61201);
// EXTERNAL MODULE: ./src/components/pages/about/MeetTheTeam.bs.js
var MeetTheTeam_bs = __webpack_require__(3336);
// EXTERNAL MODULE: ./node_modules/rescript-classnames/src/Cn.bs.js
var Cn_bs = __webpack_require__(20859);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/caml_option.js
var caml_option = __webpack_require__(25400);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/personal/Modal/Modal.bs.js
var Modal_bs = __webpack_require__(50952);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/bindings/Vimeo.bs.js
var Vimeo_bs = __webpack_require__(51741);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/personal/Modal/Modal__Close.bs.js
var Modal_Close_bs = __webpack_require__(78804);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/common/FullWidthHero/FullWidthHero.bs.js
var FullWidthHero_bs = __webpack_require__(70138);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/personal/Modal/Modal__Trigger.bs.js
var Modal_Trigger_bs = __webpack_require__(20946);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/common/TextTransition/TextTransition.bs.js + 5 modules
var TextTransition_bs = __webpack_require__(75184);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/common/DeviceSizeImage/DeviceSizeImage.bs.js
var DeviceSizeImage_bs = __webpack_require__(81343);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/personal/Modal/Modal__Container.bs.js + 1 modules
var Modal_Container_bs = __webpack_require__(95157);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/personal/RichText/InjectableRichText.bs.js
var InjectableRichText_bs = __webpack_require__(49507);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/personal/VimeoPlayer/VimeoPlayer__Video.bs.js
var VimeoPlayer_Video_bs = __webpack_require__(99956);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/personal/VimeoPlayer/VimeoPlayer__Player.bs.js + 1 modules
var VimeoPlayer_Player_bs = __webpack_require__(64797);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/common/FullWidthHero/FullWidthHero__Image.bs.js
var FullWidthHero_Image_bs = __webpack_require__(24460);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/common/FullWidthHero/FullWidthHero__CtaLine.bs.js
var FullWidthHero_CtaLine_bs = __webpack_require__(58978);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/common/FullWidthHero/FullWidthHero__Heading.bs.js
var FullWidthHero_Heading_bs = __webpack_require__(52096);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/common/FullWidthHero/FullWidthHero__BodyText.bs.js
var FullWidthHero_BodyText_bs = __webpack_require__(12497);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/common/FullWidthHero/FullWidthHero__CtaLineVideo.bs.js
var FullWidthHero_CtaLineVideo_bs = __webpack_require__(18330);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/common/FullWidthHero/FullWidthHero__TextContainer.bs.js
var FullWidthHero_TextContainer_bs = __webpack_require__(21225);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/common/FullWidthHero/FullWidthHero__ImageContainer.bs.js
var FullWidthHero_ImageContainer_bs = __webpack_require__(7742);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/business/FullWidthHero/FullWidthHero__CtaLineVideo__Theme__Business.bs.js
var FullWidthHero_CtaLineVideo_Theme_Business_bs = __webpack_require__(89627);
;// CONCATENATED MODULE: ./src/components/pages/business/BusinessFullWidthHeroSection.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE






































var CtaLineVideo = FullWidthHero_CtaLineVideo_bs/* Component */.w(FullWidthHero_CtaLineVideo_Theme_Business_bs/* Theme */.Q);
var BusinessFullWidthHeroSection_bs_SectionHeading = SectionHeading_bs/* Component */.w(SectionHeading_Theme_Business_bs/* Theme */.Q);
var heroImage = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* selector */.nZE(".fresnel-container", {
        hd: BsCss_bs/* height */.Cb8(BsCss_bs/* pct */.hdZ(100)),
        tl: /* [] */ 0
    }),
    tl: /* [] */ 0
});
var BusinessFullWidthHeroSection_bs_cmsImg = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* height */.Cb8("inherit_"),
    tl: /* [] */ 0
});
var tabletImg = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* height */.Cb8(BsCss_bs/* pct */.hdZ(100)),
    tl: /* [] */ 0
});
function vimeoIconButton(w) {
    return curry._1(BsCss_bs/* style */.oBv, {
        hd: BsCss_bs/* width */.bf$(BsCss_bs.px(w)),
        tl: /* [] */ 0
    });
}
var container = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* marginTop */.E9m(BsCss_bs.px(-67)),
    tl: /* [] */ 0
});
function scrollingTextCustomColor(colour) {
    if (colour === "") {
        return "";
    } else {
        return curry._1(BsCss_bs/* style */.oBv, {
            hd: BsCss_bs/* selector */.nZE("strong", {
                hd: BsCss_bs/* important */.efO(BsCss_bs/* unsafe */.K47("color", colour)),
                tl: /* [] */ 0
            }),
            tl: /* [] */ 0
        });
    }
}
var BusinessFullWidthHeroSection_bs_Styles = {
    heroImage: heroImage,
    cmsImg: BusinessFullWidthHeroSection_bs_cmsImg,
    tabletImg: tabletImg,
    vimeoIconButton: vimeoIconButton,
    container: container,
    scrollingTextCustomColor: scrollingTextCustomColor
};
function BusinessFullWidthHeroSection$VideoModal(props) {
    var match = react.useState(function() {
        return false;
    });
    var setModalOpen = match[1];
    var onRequestClose = function onRequestClose(param) {
        curry._1(setModalOpen, function(param) {
            return false;
        });
    };
    var openFunc = function openFunc(param) {
        curry._1(setModalOpen, function(param) {
            return true;
        });
    };
    var playerOptions = Vimeo_bs/* Player.options */.J.options(undefined, true, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, true, undefined, undefined, undefined, undefined, undefined, undefined);
    var content = jsx_runtime.jsx("div", {
        children: jsx_runtime.jsx(VimeoPlayer_Video_bs/* make */.S, {
            videoUrl: props.url,
            children: jsx_runtime.jsx(VimeoPlayer_Player_bs/* make */.Sy, {
                id: "video-modal-story",
                playerOptions: playerOptions
            })
        })
    });
    var iconImage = belt_Option/* mapWithDefault */.k7(props.icon, null, function(param) {
        var width = param.width;
        return jsx_runtime.jsx(CmsImage_bs/* make */.S, {
            src: param.url,
            alt: param.description,
            width: width,
            height: param.height,
            className: vimeoIconButton(width),
            priority: true
        });
    });
    return jsx_runtime.jsxs(Modal_bs.make, {
        children: [
            jsx_runtime.jsx(Modal_Trigger_bs/* make */.S, {
                children: jsx_runtime.jsxs(jsx_runtime.Fragment, {
                    children: [
                        iconImage,
                        props.text
                    ]
                }),
                openFunc: openFunc
            }),
            jsx_runtime.jsxs(Modal_Container_bs.make, {
                id: "modal-container",
                isOpen: match[0],
                onRequestClose: onRequestClose,
                children: [
                    jsx_runtime.jsx(Modal_Close_bs/* make */.S, {
                        closeFunc: onRequestClose
                    }),
                    content
                ],
                borderless: true
            })
        ]
    });
}
var VideoModal = {
    make: BusinessFullWidthHeroSection$VideoModal
};
function BusinessFullWidthHeroSection(props) {
    var block = props.block;
    var smartLink = block.smartLink;
    var video_button_url = block.video_button_url;
    var scrolling_text = block.scrolling_text;
    var title = block.title;
    var bgDesktop = belt_Option/* mapWithDefault */.k7(block.desktop_image, undefined, function(param) {
        return caml_option/* some */.G(jsx_runtime.jsx(CmsImage_bs/* make */.S, {
            src: param.url,
            alt: param.description,
            width: param.width,
            height: param.height,
            className: BusinessFullWidthHeroSection_bs_cmsImg,
            sizes: "" + Theme_Responsive_bs/* tabletOrMobile */.k$ + " 736px, 824px",
            priority: true
        }));
    });
    var bgTablet = belt_Option/* mapWithDefault */.k7(block.tablet_image, undefined, function(param) {
        return caml_option/* some */.G(jsx_runtime.jsx(CmsImage_bs/* make */.S, {
            src: param.url,
            alt: param.description,
            width: param.width,
            height: param.height,
            className: Cn_bs/* make */.S([
                BusinessFullWidthHeroSection_bs_cmsImg,
                tabletImg
            ]),
            sizes: "460px",
            priority: true
        }));
    });
    var bgMobile = belt_Option/* mapWithDefault */.k7(block.mobile_image, undefined, function(param) {
        return caml_option/* some */.G(jsx_runtime.jsx(CmsImage_bs/* make */.S, {
            src: param.url,
            alt: param.description,
            width: param.width,
            height: param.height,
            className: BusinessFullWidthHeroSection_bs_cmsImg,
            sizes: "100vw",
            priority: true
        }));
    });
    var bgImages = jsx_runtime.jsx(DeviceSizeImage_bs/* make */.S, {
        desktop: bgDesktop,
        smallScreen: undefined,
        tablet: bgTablet,
        mobile: bgMobile
    });
    var bgColourStyle = belt_Option/* mapWithDefault */.k7(block.background_colour, "", function(bg) {
        return curry._1(Css_bs/* style */.oBv, {
            hd: Css_bs/* unsafe */.K47("backgroundColor", bg),
            tl: /* [] */ 0
        });
    });
    var content;
    if (scrolling_text !== undefined) {
        var textArr = belt_Array/* map */.UI(scrolling_text.items, function(c) {
            return c.text;
        });
        var injectItem_1 = jsx_runtime.jsx(TextTransition_bs/* make */.S, {
            textArr: textArr,
            inline: true,
            noOverflow: true
        });
        var injectItem = [
            "strong",
            injectItem_1
        ];
        var injectArr = [
            injectItem
        ];
        content = jsx_runtime.jsx(InjectableRichText_bs/* make */.S, {
            children: title,
            injectArr: injectArr
        });
    } else {
        content = jsx_runtime.jsx(RichText_bs.make, {
            children: title
        });
    }
    var heading = jsx_runtime.jsx(FullWidthHero_Heading_bs/* make */.S, {
        children: jsx_runtime.jsx(BusinessFullWidthHeroSection_bs_SectionHeading.make, {
            children: content,
            className: scrollingTextCustomColor(block.scrolling_text_colour)
        })
    });
    var bodyText = jsx_runtime.jsx(FullWidthHero_BodyText_bs/* make */.S, {
        children: jsx_runtime.jsx(RichText_bs.make, {
            children: block.description
        })
    });
    var ctaButtons = belt_Array/* mapWithIndex */.Su(block.buttons, function(i, b) {
        var target = b.open_in_new_window ? "_blank" : "";
        var match = b.smartLink;
        return jsx_runtime.jsx(KontentContextProvider_bs/* make */.S, {
            children: jsx_runtime.jsx(Kontent_bs/* Consumer.make */.$.make, {
                children: jsx_runtime.jsx("div", {
                    children: jsx_runtime.jsx(Button_bs.make, {
                        children: jsx_runtime.jsx((link_default()), {
                            href: b.cta_url,
                            prefetch: false,
                            children: jsx_runtime.jsx("a", {
                                children: jsx_runtime.jsx("button", {
                                    children: b.cta_text
                                }),
                                target: target
                            })
                        }),
                        fill: b.fill,
                        colour: b.colour,
                        variant: b.variant
                    }, String(i))
                })
            }),
            itemId: match.itemId,
            elementCodename: match.codename
        }, String(i));
    });
    var ctaLine = jsx_runtime.jsx(FullWidthHero_CtaLine_bs/* make */.S, {
        children: ctaButtons
    });
    var ctaLineVideo = video_button_url === "" ? null : jsx_runtime.jsx(CtaLineVideo.make, {
        children: jsx_runtime.jsx(BusinessFullWidthHeroSection$VideoModal, {
            text: block.video_button_text,
            icon: block.video_button_icon,
            url: video_button_url
        })
    });
    return jsx_runtime.jsxs(FullWidthHero_bs/* make */.Sy, {
        classname: classnames_default()([
            container,
            bgColourStyle
        ]),
        children: [
            jsx_runtime.jsx(FullWidthHero_ImageContainer_bs/* make */.S, {
                children: jsx_runtime.jsx(FullWidthHero_Image_bs/* make */.S, {
                    children: bgImages,
                    className: heroImage
                })
            }),
            jsx_runtime.jsx(FullWidthHero_TextContainer_bs/* make */.S, {
                children: jsx_runtime.jsx(KontentContextProvider_bs/* make */.S, {
                    children: jsx_runtime.jsx(Kontent_bs/* Consumer.make */.$.make, {
                        children: jsx_runtime.jsxs("div", {
                            children: [
                                heading,
                                bodyText,
                                ctaLine,
                                ctaLineVideo
                            ]
                        })
                    }),
                    itemId: smartLink.itemId,
                    elementCodename: smartLink.codename
                })
            })
        ]
    });
}
var BusinessFullWidthHeroSection_bs_ImageContainer;
var HeroImage;
var BusinessFullWidthHeroSection_bs_TextContainer;
var BusinessFullWidthHeroSection_bs_Heading;
var BusinessFullWidthHeroSection_bs_BodyText;
var CtaLine;
var BusinessFullWidthHeroSection_bs_KontentContextConsumer;
var BusinessFullWidthHeroSection_bs_make = BusinessFullWidthHeroSection;
 /* CtaLineVideo Not a pure module */ 

// EXTERNAL MODULE: ./src/components/landingPage/LandingPage__FullWidthHero.bs.js
var LandingPage_FullWidthHero_bs = __webpack_require__(78621);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/business/AutomateSimplify/AutomateSimplify.bs.js
var AutomateSimplify_bs = __webpack_require__(47119);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/business/AutomateSimplify/AutomateSimplify__Heading.bs.js
var AutomateSimplify_Heading_bs = __webpack_require__(4412);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/business/AutomateSimplify/AutomateSimplify__BodyText.bs.js
var AutomateSimplify_BodyText_bs = __webpack_require__(94702);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/business/AutomateSimplify/AutomateSimplify__CTAContainer.bs.js
var AutomateSimplify_CTAContainer_bs = __webpack_require__(49611);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/business/AutomateSimplify/AutomateSimplify__TextContainer.bs.js
var AutomateSimplify_TextContainer_bs = __webpack_require__(59253);
;// CONCATENATED MODULE: ./src/components/pages/business/AutomateSimplifySection.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE















var AutomateSimplifySection_bs_button = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* marginLeft */.oIA(BsCss_bs.px(12)),
    tl: {
        hd: BsCss_bs/* marginTop */.E9m(BsCss_bs.px(12)),
        tl: {
            hd: BsCss_bs/* selector */.nZE("button", {
                hd: BsCss_bs/* width */.bf$(BsCss_bs.px(200)),
                tl: /* [] */ 0
            }),
            tl: /* [] */ 0
        }
    }
});
var ctaWrapper = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* marginLeft */.oIA(BsCss_bs.px(-12)),
    tl: {
        hd: BsCss_bs/* marginTop */.E9m(BsCss_bs.px(-12)),
        tl: /* [] */ 0
    }
});
var sectionWidth = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* children */.pIy(IndexStyles_bs/* section_ */.hW),
    tl: /* [] */ 0
});
var AutomateSimplifySection_bs_Styles = {
    button: AutomateSimplifySection_bs_button,
    ctaWrapper: ctaWrapper,
    sectionWidth: sectionWidth
};
function AutomateSimplifySection(props) {
    var block = props.block;
    var smartLink = block.smartLink;
    var title = jsx_runtime.jsx(AutomateSimplify_Heading_bs/* make */.S, {
        children: jsx_runtime.jsx(RichText_bs.make, {
            children: block.heading
        })
    });
    var bodyText = jsx_runtime.jsx(AutomateSimplify_BodyText_bs/* make */.S, {
        children: jsx_runtime.jsx(RichText_bs.make, {
            children: block.body_text
        })
    });
    var ctaButtons = belt_Array/* mapWithIndex */.Su(block.buttons, function(index, ctaButton) {
        var smartLink = ctaButton.smartLink;
        var cta_url = ctaButton.cta_url;
        var cta_text = ctaButton.cta_text;
        var target = ctaButton.open_in_new_window ? "_blank" : "";
        var buttonComponent = target === "" ? jsx_runtime.jsx((link_default()), {
            href: cta_url,
            prefetch: false,
            children: jsx_runtime.jsx("a", {
                children: jsx_runtime.jsx("button", {
                    children: cta_text
                }),
                target: target
            })
        }) : jsx_runtime.jsx("a", {
            children: jsx_runtime.jsx("button", {
                children: cta_text
            }),
            href: cta_url,
            target: target
        });
        return jsx_runtime.jsx(KontentContextProvider_bs/* make */.S, {
            children: jsx_runtime.jsx(Kontent_bs/* Consumer.make */.$.make, {
                children: jsx_runtime.jsx("div", {
                    children: jsx_runtime.jsx(Button_bs.make, {
                        children: buttonComponent,
                        colour: /* Red */ 0,
                        variant: /* Small */ 1,
                        className: AutomateSimplifySection_bs_button
                    })
                })
            }),
            itemId: smartLink.itemId,
            elementCodename: smartLink.codename
        }, index.toString());
    });
    return jsx_runtime.jsx(KontentContextProvider_bs/* make */.S, {
        children: jsx_runtime.jsx(Kontent_bs/* Consumer.make */.$.make, {
            children: jsx_runtime.jsx("div", {
                children: jsx_runtime.jsxs(AutomateSimplify_bs/* make */.S, {
                    children: [
                        jsx_runtime.jsxs(AutomateSimplify_TextContainer_bs/* make */.S, {
                            children: [
                                title,
                                bodyText
                            ]
                        }),
                        jsx_runtime.jsx(AutomateSimplify_CTAContainer_bs/* make */.S, {
                            children: ctaButtons,
                            classname: ctaWrapper
                        })
                    ],
                    classname: sectionWidth
                })
            })
        }),
        itemId: smartLink.itemId,
        elementCodename: smartLink.codename
    });
}
var AutomateSimplify;
var AutomateSimplifySection_bs_TextContainer;
var AutomateSimplifySection_bs_Heading;
var CTAContainer;
var AutomateSimplifySection_bs_BodyText;
var AutomateSimplifySection_bs_RichText;
var Button;
var AutomateSimplifySection_bs_KontentContextConsumer;
var AutomateSimplifySection_bs_make = AutomateSimplifySection;
 /* button Not a pure module */ 

// EXTERNAL MODULE: ./node_modules/swiper/swiper-react.mjs + 2 modules
var swiper_react = __webpack_require__(48929);
// EXTERNAL MODULE: ./src/components/pages/business/ImageCollectionUtil.bs.js
var ImageCollectionUtil_bs = __webpack_require__(5869);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/common/ImageGrid/ImageGrid.bs.js
var ImageGrid_bs = __webpack_require__(77428);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/common/FullWidthCarousel/FullWidthCarousel.bs.js + 2 modules
var FullWidthCarousel_bs = __webpack_require__(96020);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/common/FullWidthCarousel/FullWidthCarousel__Slide.bs.js
var FullWidthCarousel_Slide_bs = __webpack_require__(29261);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/common/FullWidthCarousel/FullWidthCarousel__SlideIcon.bs.js
var FullWidthCarousel_SlideIcon_bs = __webpack_require__(97613);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/common/FullWidthCarousel/FullWidthCarousel__SlideContent.bs.js
var FullWidthCarousel_SlideContent_bs = __webpack_require__(32426);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/common/FullWidthCarousel/FullWidthCarousel__SlideBackground.bs.js
var FullWidthCarousel_SlideBackground_bs = __webpack_require__(41690);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/common/FullWidthCarousel/FullWidthCarousel__SlideFooterText.bs.js
var FullWidthCarousel_SlideFooterText_bs = __webpack_require__(10673);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/common/FullWidthCarousel/FullWidthCarousel__SlideDescription.bs.js
var FullWidthCarousel_SlideDescription_bs = __webpack_require__(73917);
;// CONCATENATED MODULE: ./src/components/pages/business/TestimonialCarouselSection.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE





























var TestimonialCarouselSection_bs_SectionHeading = SectionHeading_bs/* Component */.w(SectionHeading_Theme_Business_bs/* Theme */.Q);
var wrapper = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* maxWidth */.kkr(BsCss_bs.px(1204)),
    tl: {
        hd: BsCss_bs/* paddingTop */.odA(BsCss_bs.px(72)),
        tl: {
            hd: BsCss_bs/* paddingBottom */.EtG(BsCss_bs.px(72)),
            tl: {
                hd: BsCss_bs/* marginLeft */.oIA("auto"),
                tl: {
                    hd: BsCss_bs/* marginRight */.wzR("auto"),
                    tl: /* [] */ 0
                }
            }
        }
    }
});
var heading = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* selector */.nZE("h1, h2, h3, h4, h5, h6", {
        hd: BsCss_bs/* fontSize */.JBY(BsCss_bs.px(32)),
        tl: {
            hd: BsCss_bs/* lineHeight */.Nv8(BsCss_bs.px(40)),
            tl: {
                hd: BsCss_bs/* textAlign */.ydu("center"),
                tl: {
                    hd: BsCss_bs/* maxWidth */.kkr(BsCss_bs.px(520)),
                    tl: {
                        hd: BsCss_bs/* margin2 */.h9x("zero", "auto"),
                        tl: {
                            hd: BsCss_bs/* media */.BC2(Theme_Responsive_bs/* desktop */.gv, {
                                hd: BsCss_bs/* fontSize */.JBY(BsCss_bs.px(42)),
                                tl: {
                                    hd: BsCss_bs/* lineHeight */.Nv8(BsCss_bs.px(58)),
                                    tl: {
                                        hd: BsCss_bs/* maxWidth */.kkr(BsCss_bs.px(790)),
                                        tl: /* [] */ 0
                                    }
                                }
                            }),
                            tl: /* [] */ 0
                        }
                    }
                }
            }
        }
    }),
    tl: /* [] */ 0
});
var grid = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* maxWidth */.kkr(BsCss_bs.px(970)),
    tl: {
        hd: BsCss_bs/* margin2 */.h9x(BsCss_bs.px(32), "auto"),
        tl: {
            hd: BsCss_bs/* media */.BC2(Theme_Responsive_bs/* desktop */.gv, {
                hd: BsCss_bs/* margin2 */.h9x(BsCss_bs.px(40), "auto"),
                tl: /* [] */ 0
            }),
            tl: {
                hd: BsCss_bs/* media */.BC2(Theme_Responsive_bs/* tabletSm */.FV, {
                    hd: BsCss_bs/* marginBottom */.yl7(BsCss_bs.px(30)),
                    tl: /* [] */ 0
                }),
                tl: /* [] */ 0
            }
        }
    }
});
var swiperSlide = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* important */.efO(BsCss_bs/* height */.Cb8("auto")),
    tl: /* [] */ 0
});
var slide = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* alignItems */.cq$("center"),
    tl: {
        hd: BsCss_bs/* display */.jfB("flex"),
        tl: /* [] */ 0
    }
});
var slideBg = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* backgroundColor */.Czw(Theme_Color_bs/* Business.stone */.e.stone),
    tl: {
        hd: BsCss_bs/* width */.bf$(BsCss_bs/* pct */.hdZ(100)),
        tl: {
            hd: BsCss_bs/* display */.jfB("flex"),
            tl: {
                hd: BsCss_bs/* height */.Cb8(BsCss_bs/* pct */.hdZ(100)),
                tl: /* [] */ 0
            }
        }
    }
});
var slideContent = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* flex3 */.L9u(0, 0, BsCss_bs/* pct */.hdZ(100)),
    tl: {
        hd: BsCss_bs/* maxWidth */.kkr(BsCss_bs/* pct */.hdZ(100)),
        tl: /* [] */ 0
    }
});
var TestimonialCarouselSection_bs_link = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* width */.bf$(BsCss_bs/* pct */.hdZ(100)),
    tl: {
        hd: BsCss_bs/* display */.jfB("flex"),
        tl: {
            hd: BsCss_bs/* height */.Cb8(BsCss_bs/* pct */.hdZ(100)),
            tl: /* [] */ 0
        }
    }
});
var carouselContainer = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* media */.BC2(Theme_Responsive_bs/* tabletOrDesktop */.ab, {
        hd: BsCss_bs/* paddingLeft */.rv2(BsCss_bs/* rem */.hOB(1.875)),
        tl: {
            hd: BsCss_bs/* paddingRight */.WLm(BsCss_bs/* rem */.hOB(1.875)),
            tl: /* [] */ 0
        }
    }),
    tl: /* [] */ 0
});
function TestimonialCarouselSection_bs_cmsImg(w, h) {
    return curry._1(BsCss_bs/* style */.oBv, {
        hd: BsCss_bs/* width */.bf$(BsCss_bs.px(w)),
        tl: {
            hd: BsCss_bs/* height */.Cb8(BsCss_bs.px(h)),
            tl: /* [] */ 0
        }
    });
}
var TestimonialCarouselSection_bs_Styles = {
    wrapper: wrapper,
    heading: heading,
    grid: grid,
    swiperSlide: swiperSlide,
    slide: slide,
    slideBg: slideBg,
    slideContent: slideContent,
    link: TestimonialCarouselSection_bs_link,
    carouselContainer: carouselContainer,
    cmsImg: TestimonialCarouselSection_bs_cmsImg
};
function getHeading(heading$1) {
    return jsx_runtime.jsx("div", {
        children: jsx_runtime.jsx(TestimonialCarouselSection_bs_SectionHeading.make, {
            children: jsx_runtime.jsx(RichText_bs.make, {
                children: heading$1
            }),
            className: heading
        })
    });
}
function getImage(images) {
    return belt_Array/* mapWithIndex */.Su(images, function(idx, img) {
        var key = String(idx);
        if (img.NAME === "DeviceSizeImage") {
            var _$images = img.VAL;
            var imageD = ImageCollectionUtil_bs/* Helpers.getAssetOption */.Z.getAssetOption(_$images.desktop_image);
            var imageT = ImageCollectionUtil_bs/* Helpers.getAssetOption */.Z.getAssetOption(_$images.tablet_image);
            var imageM = ImageCollectionUtil_bs/* Helpers.getAssetOption */.Z.getAssetOption(_$images.mobile_image);
            return jsx_runtime.jsx("div", {
                children: jsx_runtime.jsx(DeviceSizeImage_bs/* make */.S, {
                    desktop: imageD,
                    smallScreen: undefined,
                    tablet: imageT,
                    mobile: imageM
                })
            }, key);
        }
        var img$1 = img.VAL;
        return jsx_runtime.jsx("div", {
            children: jsx_runtime.jsx("img", {
                alt: img$1.description,
                height: String(img$1.height),
                src: img$1.url,
                width: String(img$1.width)
            })
        }, key);
    });
}
function getImageGrid(testimonial_image_grid) {
    return jsx_runtime.jsx(ImageGrid_bs/* make */.Sy, {
        children: ImageCollectionUtil_bs/* Helpers.getImages */.Z.getImages(testimonial_image_grid.images),
        className: grid,
        gap: testimonial_image_grid.gap_desktop,
        gapTablet: testimonial_image_grid.gap_tablet,
        gapMobile: testimonial_image_grid.gap_mobile,
        perRow: testimonial_image_grid.display_per_row_desktop,
        perRowTablet: testimonial_image_grid.display_per_row_tablet,
        perRowMobile: testimonial_image_grid.display_per_row_mobile
    });
}
function getCarousel(testimonial_carousel_items) {
    var carouselItems = belt_Array/* mapWithIndex */.Su(testimonial_carousel_items, function(idx, item) {
        var smartLink = item.smartLink;
        var url = item.url;
        var image = item.image;
        var key = String(idx);
        var bgD = ImageCollectionUtil_bs/* Helpers.getImageOption */.Z.getImageOption(item.background_image);
        var bgS = ImageCollectionUtil_bs/* Helpers.getImageOption */.Z.getImageOption(item.background_image_tablet);
        var bgM = ImageCollectionUtil_bs/* Helpers.getImageOption */.Z.getImageOption(item.background_image_mobile);
        var bgColourStyle = belt_Option/* mapWithDefault */.k7(item.background_colour, "", function(bg) {
            return curry._1(Css_bs/* style */.oBv, {
                hd: Css_bs/* unsafe */.K47("backgroundColor", bg),
                tl: /* [] */ 0
            });
        });
        var logo;
        if (image !== undefined) {
            var height = image.height;
            var width = image.width;
            logo = jsx_runtime.jsx(FullWidthCarousel_SlideIcon_bs/* make */.S, {
                children: jsx_runtime.jsx(CmsImage_bs/* make */.S, {
                    src: image.url,
                    alt: image.description,
                    width: width,
                    height: height,
                    className: TestimonialCarouselSection_bs_cmsImg(width, height),
                    sizes: "" + String(width) + "px"
                })
            });
        } else {
            logo = null;
        }
        var slideContent$1 = jsx_runtime.jsx(KontentContextProvider_bs/* make */.S, {
            children: jsx_runtime.jsx(Kontent_bs/* Consumer.make */.$.make, {
                children: jsx_runtime.jsx("div", {
                    children: jsx_runtime.jsxs(FullWidthCarousel_Slide_bs/* make */.Sy, {
                        children: [
                            jsx_runtime.jsx(FullWidthCarousel_SlideBackground_bs/* make */.S, {
                                children: jsx_runtime.jsx(DeviceSizeImage_bs/* make */.S, {
                                    desktop: bgD,
                                    smallScreen: bgS,
                                    tablet: undefined,
                                    mobile: bgM
                                })
                            }),
                            jsx_runtime.jsxs(FullWidthCarousel_SlideContent_bs/* make */.S, {
                                children: [
                                    logo,
                                    jsx_runtime.jsx(FullWidthCarousel_SlideDescription_bs/* make */.S, {
                                        children: item.quote
                                    }),
                                    jsx_runtime.jsx(FullWidthCarousel_SlideFooterText_bs/* make */.S, {
                                        children: jsx_runtime.jsx(RichText_bs.make, {
                                            children: item.author
                                        })
                                    })
                                ],
                                className: slideContent
                            })
                        ],
                        className: slide
                    }),
                    className: Cn_bs/* make */.S([
                        slideBg,
                        bgColourStyle
                    ])
                })
            }),
            itemId: smartLink.itemId,
            elementCodename: smartLink.codename
        });
        var slide$1;
        if (url !== undefined) {
            var href = url.url;
            slide$1 = url.open_in_new_window ? jsx_runtime.jsx("a", {
                children: slideContent$1,
                className: TestimonialCarouselSection_bs_link,
                href: href,
                target: "_blank"
            }) : jsx_runtime.jsx((link_default()), {
                href: href,
                prefetch: false,
                children: jsx_runtime.jsx("a", {
                    children: slideContent$1,
                    className: TestimonialCarouselSection_bs_link
                })
            });
        } else {
            slide$1 = jsx_runtime.jsx(jsx_runtime.Fragment, {
                children: caml_option/* some */.G(slideContent$1)
            });
        }
        return jsx_runtime.jsx(swiper_react/* SwiperSlide */.o5, {
            className: swiperSlide,
            children: slide$1
        }, key);
    });
    return jsx_runtime.jsx(FullWidthCarousel_bs/* make */.Sy, {
        children: carouselItems,
        showPagination: true,
        autoplay: true
    });
}
var Builder = {
    $$Image: undefined,
    getHeading: getHeading,
    getImage: getImage,
    getImageGrid: getImageGrid,
    getCarousel: getCarousel
};
function TestimonialCarouselSection(props) {
    var block = props.block;
    var smartLink = block.smartLink;
    var testimonial_image_grid = block.testimonial_image_grid;
    var imageGrid = testimonial_image_grid !== undefined ? getImageGrid(testimonial_image_grid) : null;
    var carousel = getCarousel(block.testimonial_carousel_items);
    return jsx_runtime.jsx(KontentContextProvider_bs/* make */.S, {
        children: jsx_runtime.jsx(Kontent_bs/* Consumer.make */.$.make, {
            children: jsx_runtime.jsxs("div", {
                children: [
                    jsx_runtime.jsxs("div", {
                        children: [
                            getHeading(block.title),
                            imageGrid
                        ],
                        className: IndexStyles_bs/* section */.qi
                    }),
                    jsx_runtime.jsx("div", {
                        children: carousel,
                        className: carouselContainer
                    })
                ],
                className: wrapper
            })
        }),
        itemId: smartLink.itemId,
        elementCodename: smartLink.codename
    });
}
var TestimonialCarouselSection_bs_KontentContextConsumer;
var TestimonialCarouselSection_bs_RichText;
var ImageGrid;
var Carousel;
var Slide;
var SlideBg;
var SlideContent;
var SlideIcon;
var SlideDescription;
var SlideFooter;
var DeviceSizeImage;
var TestimonialCarouselSection_bs_Link$1;
var ImageCollectionHelpers;
var TestimonialCarouselSection_bs_make = TestimonialCarouselSection;
 /* SectionHeading Not a pure module */ 

// EXTERNAL MODULE: ./src/bindings/Pino.bs.js
var Pino_bs = __webpack_require__(91574);
// EXTERNAL MODULE: ./src/utils/Regex.bs.js
var Regex_bs = __webpack_require__(7618);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/js_dict.js
var js_dict = __webpack_require__(43437);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/caml_obj.js
var caml_obj = __webpack_require__(84445);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/js_option.js
var js_option = __webpack_require__(30862);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/js_promise.js
var js_promise = __webpack_require__(27097);
// EXTERNAL MODULE: ./src/utils/FormHelpers.bs.js
var FormHelpers_bs = __webpack_require__(43243);
// EXTERNAL MODULE: ./src/bindings/ReactHookForm.bs.js
var ReactHookForm_bs = __webpack_require__(77103);
// EXTERNAL MODULE: ./node_modules/bs-css/src/Css_Legacy_Core.bs.js
var Css_Legacy_Core_bs = __webpack_require__(68364);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/personal/Text/Text.bs.js
var Text_bs = __webpack_require__(25519);
// EXTERNAL MODULE: ./src/api/PrezzeePublicClient.bs.js + 15 modules
var PrezzeePublicClient_bs = __webpack_require__(47861);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/personal/TextField/TextField.bs.js + 1 modules
var TextField_bs = __webpack_require__(98923);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/theme/Theme__Layout.bs.js
var Theme_Layout_bs = __webpack_require__(51222);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/theme/Theme__Typography.bs.js
var Theme_Typography_bs = __webpack_require__(32567);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-solid-svg-icons/faCheckCircle.js
var faCheckCircle = __webpack_require__(6811);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-solid-svg-icons/faExclamationCircle.js
var faExclamationCircle = __webpack_require__(20702);
;// CONCATENATED MODULE: ./src/components/pages/business/BusinessContactFormSection.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE



































var BusinessContactFormSection_bs_wrapper = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* display */.jfB("flex"),
    tl: {
        hd: BsCss_bs/* justifyContent */.KlP("spaceBetween"),
        tl: {
            hd: BsCss_bs/* paddingTop */.odA(BsCss_bs.px(70)),
            tl: {
                hd: BsCss_bs/* paddingBottom */.EtG(BsCss_bs.px(70)),
                tl: {
                    hd: BsCss_bs/* marginTop */.E9m(BsCss_bs.px(-30)),
                    tl: {
                        hd: BsCss_bs/* color */.$_Y(Theme_Color_bs/* Business.bodyTextGrey */.e.bodyTextGrey),
                        tl: {
                            hd: BsCss_bs/* media */.BC2(Theme_Responsive_bs/* tabletSm */.FV, {
                                hd: BsCss_bs/* flexDirection */.Me8("column"),
                                tl: {
                                    hd: BsCss_bs/* paddingTop */.odA(BsCss_bs.px(40)),
                                    tl: {
                                        hd: BsCss_bs/* paddingBottom */.EtG(BsCss_bs.px(40)),
                                        tl: /* [] */ 0
                                    }
                                }
                            }),
                            tl: {
                                hd: BsCss_bs/* media */.BC2(Theme_Responsive_bs/* desktop */.gv, {
                                    hd: BsCss_bs/* paddingTop */.odA(BsCss_bs.px(120)),
                                    tl: {
                                        hd: BsCss_bs/* paddingBottom */.EtG(BsCss_bs.px(120)),
                                        tl: /* [] */ 0
                                    }
                                }),
                                tl: {
                                    hd: BsCss_bs/* children */.pIy({
                                        hd: BsCss_bs/* marginTop */.E9m(BsCss_bs.px(30)),
                                        tl: {
                                            hd: BsCss_bs/* media */.BC2(Theme_Responsive_bs/* tabletSmUp */.Uv, {
                                                hd: BsCss_bs/* width */.bf$({
                                                    NAME: "calc",
                                                    VAL: [
                                                        "sub",
                                                        BsCss_bs/* pct */.hdZ(50),
                                                        BsCss_bs.px(30)
                                                    ]
                                                }),
                                                tl: /* [] */ 0
                                            }),
                                            tl: /* [] */ 0
                                        }
                                    }),
                                    tl: {
                                        hd: BsCss_bs/* selector */.nZE("h2", {
                                            hd: BsCss_bs/* marginBottom */.yl7(BsCss_bs.px(20)),
                                            tl: /* [] */ 0
                                        }),
                                        tl: /* [] */ 0
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
});
var formContainer = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* display */.jfB("flex"),
    tl: {
        hd: BsCss_bs/* alignItems */.cq$("center"),
        tl: {
            hd: BsCss_bs/* justifyContent */.KlP("center"),
            tl: {
                hd: BsCss_bs/* alignSelf */.uko("center"),
                tl: {
                    hd: BsCss_bs/* borderRadius */.E0l(Theme_Layout_bs/* Personal.borderRadius */.R.borderRadius),
                    tl: {
                        hd: BsCss_bs/* padding */.o3D(BsCss_bs.px(24)),
                        tl: {
                            hd: BsCss_bs/* boxShadow */.Wnp(Css_Legacy_Core_bs/* Shadow.box */.jXB.box(BsCss_bs.px(0), BsCss_bs.px(40), BsCss_bs.px(200), undefined, undefined, BsCss_bs/* rgba */.m4f(0, 0, 0, BsCss_bs/* pct */.hdZ(8)))),
                            tl: {
                                hd: BsCss_bs/* media */.BC2(Theme_Responsive_bs/* desktop */.gv, {
                                    hd: BsCss_bs/* padding */.o3D(BsCss_bs.px(40)),
                                    tl: /* [] */ 0
                                }),
                                tl: /* [] */ 0
                            }
                        }
                    }
                }
            }
        }
    }
});
var BusinessContactFormSection_bs_form = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* display */.jfB("flex"),
    tl: {
        hd: BsCss_bs/* flexWrap */.WOS("wrap"),
        tl: {
            hd: BsCss_bs/* marginTop */.E9m(BsCss_bs.px(-20)),
            tl: {
                hd: BsCss_bs/* margin4 */.X0Y(BsCss_bs.px(-20), BsCss_bs.px(-10), BsCss_bs/* zero */.bMI, BsCss_bs.px(-10)),
                tl: {
                    hd: BsCss_bs/* children */.pIy({
                        hd: BsCss_bs/* margin4 */.X0Y(BsCss_bs.px(20), BsCss_bs.px(10), BsCss_bs/* zero */.bMI, BsCss_bs.px(10)),
                        tl: {
                            hd: BsCss_bs/* width */.bf$(BsCss_bs/* pct */.hdZ(100)),
                            tl: /* [] */ 0
                        }
                    }),
                    tl: /* [] */ 0
                }
            }
        }
    }
});
var title = curry._1(BsCss_bs/* merge */.TSy, {
    hd: Theme_Typography_bs/* Styles.style1 */.z.style1,
    tl: {
        hd: curry._1(BsCss_bs/* style */.oBv, {
            hd: BsCss_bs/* important */.efO(BsCss_bs/* marginBottom */.yl7(BsCss_bs.px(20))),
            tl: {
                hd: BsCss_bs/* color */.$_Y(Theme_Color_bs/* Business.charcoal */.e.charcoal),
                tl: {
                    hd: BsCss_bs/* media */.BC2(Theme_Responsive_bs/* smallScreenOrMobile */.HH, {
                        hd: BsCss_bs/* important */.efO(BsCss_bs/* fontSize */.JBY(BsCss_bs.px(32))),
                        tl: {
                            hd: BsCss_bs/* important */.efO(BsCss_bs/* marginBottom */.yl7(BsCss_bs.px(10))),
                            tl: /* [] */ 0
                        }
                    }),
                    tl: /* [] */ 0
                }
            }
        }),
        tl: /* [] */ 0
    }
});
var linkContainer = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* display */.jfB("block"),
    tl: {
        hd: BsCss_bs/* fontWeight */.Ue2({
            NAME: "num",
            VAL: 500
        }),
        tl: {
            hd: BsCss_bs/* marginBottom */.yl7(BsCss_bs.px(15)),
            tl: /* [] */ 0
        }
    }
});
var success = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* color */.$_Y(Theme_Color_bs/* Business.prezzeePurple */.e.prezzeePurple),
    tl: /* [] */ 0
});
var error = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* color */.$_Y(BsCss_bs/* hex */.$v1("FF747C")),
    tl: /* [] */ 0
});
var postMessageContainer = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* maxWidth */.kkr(BsCss_bs.px(328)),
    tl: {
        hd: BsCss_bs/* textAlign */.ydu("center"),
        tl: {
            hd: BsCss_bs/* selector */.nZE("svg", {
                hd: BsCss_bs/* fontSize */.JBY(BsCss_bs.px(50)),
                tl: /* [] */ 0
            }),
            tl: {
                hd: BsCss_bs/* children */.pIy({
                    hd: BsCss_bs/* important */.efO(BsCss_bs/* marginBottom */.yl7(BsCss_bs.px(20))),
                    tl: {
                        hd: BsCss_bs/* lastChild */.QOo({
                            hd: BsCss_bs/* important */.efO(BsCss_bs/* marginBottom */.yl7(BsCss_bs/* zero */.bMI)),
                            tl: /* [] */ 0
                        }),
                        tl: /* [] */ 0
                    }
                }),
                tl: /* [] */ 0
            }
        }
    }
});
var ctaContainer = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* display */.jfB("flex"),
    tl: {
        hd: BsCss_bs/* flexWrap */.WOS("wrap"),
        tl: {
            hd: BsCss_bs/* margin2 */.h9x(BsCss_bs/* zero */.bMI, BsCss_bs.px(-10)),
            tl: {
                hd: BsCss_bs/* children */.pIy({
                    hd: BsCss_bs/* margin4 */.X0Y(BsCss_bs.px(20), BsCss_bs.px(10), BsCss_bs/* zero */.bMI, BsCss_bs.px(10)),
                    tl: /* [] */ 0
                }),
                tl: /* [] */ 0
            }
        }
    }
});
var emailIcon = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* transform */.vs({
        NAME: "translateY",
        VAL: BsCss_bs.px(3)
    }),
    tl: /* [] */ 0
});
var phoneIcon = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* transform */.vs({
        NAME: "translateY",
        VAL: BsCss_bs.px(2)
    }),
    tl: /* [] */ 0
});
var iconContainer = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* display */.jfB("inlineBlock"),
    tl: {
        hd: BsCss_bs/* marginRight */.wzR(BsCss_bs.px(12)),
        tl: {
            hd: BsCss_bs/* fontSize */.JBY(BsCss_bs.px(22)),
            tl: {
                hd: BsCss_bs/* child */.iUc("div")({
                    hd: BsCss_bs/* marginBottom */.yl7("zero"),
                    tl: /* [] */ 0
                }),
                tl: /* [] */ 0
            }
        }
    }
});
var BusinessContactFormSection_bs_Styles = {
    wrapper: BusinessContactFormSection_bs_wrapper,
    formContainer: formContainer,
    form: BusinessContactFormSection_bs_form,
    title: title,
    linkContainer: linkContainer,
    success: success,
    error: error,
    postMessageContainer: postMessageContainer,
    ctaContainer: ctaContainer,
    emailIcon: emailIcon,
    phoneIcon: phoneIcon,
    iconContainer: iconContainer
};
function textInput(message, required) {
    return {
        required: {
            value: required,
            message: message
        }
    };
}
function lastNameInput(message, required) {
    return {
        required: {
            value: required,
            message: message
        }
    };
}
function emailInput(message, required) {
    return {
        required: {
            value: required,
            message: message
        },
        pattern: {
            value: Regex_bs/* emailRegex */.HN,
            message: "Please enter a valid email address"
        }
    };
}
function phoneInput(message, required) {
    return {
        required: {
            value: required,
            message: message
        },
        validate: function validate(number) {
            if (number == null) {
                return false;
            }
            var cleanNumber = number.replace(/\s*/g, "");
            if (Regex_bs/* phoneNumberRegex.test */.Uo.test(cleanNumber)) {
                return true;
            } else if (required) {
                return false;
            } else {
                return number === "";
            }
        }
    };
}
function segmentTrackFormSubmitSuccess(formValues, isSuccessful) {
    return {
        business_name: formValues.company,
        email: formValues.email,
        first_name: formValues.firstname,
        last_name: formValues.lastname,
        lead_type: "contact us business home",
        phone: formValues.phone,
        store: "business",
        is_successful: isSuccessful
    };
}
function BusinessContactFormSection(props) {
    var block = props.block;
    var match = react.useState(function() {
        return false;
    });
    var setIsLoading = match[1];
    var match$1 = react.useState(function() {
        return false;
    });
    var setSuccess = match$1[1];
    var match$2 = react.useState(function() {
        return false;
    });
    var setError = match$2[1];
    var form$1 = ReactHookForm_bs/* useForm */.cI({
        mode: "onTouched"
    }, undefined);
    var onSubmit = react.useCallback(function(data) {
        curry._1(setIsLoading, function(param) {
            return true;
        });
        var formValues = curry._1(form$1.getValues, undefined);
        var requestFields = belt_Array/* map */.UI(Object.keys(data), function(field) {
            return js_dict/* fromList */.hy({
                hd: [
                    "name",
                    field
                ],
                tl: {
                    hd: [
                        "value",
                        js_option/* getWithDefault */.tj("", js_dict/* get */.U2(data, field))
                    ],
                    tl: /* [] */ 0
                }
            });
        });
        js_promise/* then_ */.k(function(result) {
            if (result.TAG === /* Ok */ 0) {
                curry._1(setIsLoading, function(param) {
                    return false;
                });
                Segment_bs/* businessLeadSubmitted */.Fb(segmentTrackFormSubmitSuccess(formValues, true));
                return Promise.resolve(curry._1(setSuccess, function(param) {
                    return true;
                }));
            }
            curry._1(setIsLoading, function(param) {
                return false;
            });
            Segment_bs/* businessLeadSubmitted */.Fb(segmentTrackFormSubmitSuccess(formValues, false));
            curry._1(setError, function(param) {
                return true;
            });
            Pino_bs/* logger.error */.k.error({
                err: result._0,
                source: "Hubspot Form API"
            }, "error: Could not submit Business Contact Form");
            return Promise.resolve(undefined);
        }, PrezzeePublicClient_bs.businessContact(requestFields));
    }, []);
    var smart_link = block.smart_link;
    var phone = block.phone;
    var phone_icon = block.phone_icon;
    var email = block.email;
    var email_icon = block.email_icon;
    var formFields = belt_Array/* mapWithIndex */.Su(block.fields, function(index, field) {
        var smartLink = field.smartLink;
        var required = field.required;
        var label = field.label;
        var type_ = field.type_;
        var name = field.name;
        var key = index.toString();
        var inputType;
        switch(type_){
            case "email":
                inputType = emailInput;
                break;
            case "tel":
                inputType = phoneInput;
                break;
            default:
                inputType = textInput;
        }
        var errorText = FormHelpers_bs/* getFieldError */.zQ(form$1.errors, name);
        var label_ = required ? label + "*" : label;
        return jsx_runtime.jsx(KontentContextProvider_bs/* make */.S, {
            children: jsx_runtime.jsx(Kontent_bs/* Consumer.make */.$.make, {
                children: jsx_runtime.jsx("div", {
                    children: jsx_runtime.jsx(TextField_bs/* make */.Sy, {
                        className: Cn_bs/* make */.S([
                            "w-full"
                        ]),
                        label: label_,
                        name: name,
                        placeholder: field.placeholder,
                        required: required,
                        type_: type_,
                        error: belt_Option/* isSome */.pC(FormHelpers_bs/* getFieldError */.zQ(form$1.errors, name)),
                        helperText: caml_obj/* equal */.Dg(errorText, "") && type_ === "tel" ? "Please enter a valid phone number" : errorText,
                        inputRef: caml_option/* some */.G(curry._1(form$1.register, curry._2(inputType, field.validation_message, required)))
                    }, key)
                })
            }),
            itemId: smartLink.itemId,
            elementCodename: smartLink.codename
        });
    });
    var ctaButtons = belt_Array/* mapWithIndex */.Su(block.body_ctas, function(i, b) {
        var target = b.open_in_new_window ? "_blank" : "";
        var match = b.smartLink;
        return jsx_runtime.jsx(KontentContextProvider_bs/* make */.S, {
            children: jsx_runtime.jsx(Kontent_bs/* Consumer.make */.$.make, {
                children: jsx_runtime.jsx("div", {
                    children: jsx_runtime.jsx(Button_bs.make, {
                        children: jsx_runtime.jsx((link_default()), {
                            href: b.cta_url,
                            prefetch: false,
                            children: jsx_runtime.jsx("a", {
                                children: jsx_runtime.jsx("button", {
                                    children: b.cta_text
                                }),
                                target: target
                            })
                        }),
                        fill: b.fill,
                        colour: b.colour,
                        variant: b.variant
                    }, String(i))
                })
            }),
            itemId: match.itemId,
            elementCodename: match.codename
        }, String(i));
    });
    var success$1 = jsx_runtime.jsxs("div", {
        children: [
            jsx_runtime.jsx(index_es.FontAwesomeIcon, {
                icon: faCheckCircle/* faCheckCircle */.f8,
                className: success
            }),
            jsx_runtime.jsx("div", {
                children: jsx_runtime.jsx(Text_bs/* make */.S, {
                    children: "Thank you!"
                }),
                className: Theme_Typography_bs/* Styles.style1 */.z.style1
            }),
            jsx_runtime.jsx("p", {
                children: jsx_runtime.jsx(Text_bs/* make */.S, {
                    children: "Your request has been submitted and a team member will contact you shortly."
                })
            })
        ],
        className: postMessageContainer
    });
    var error$1 = jsx_runtime.jsxs("div", {
        children: [
            jsx_runtime.jsx(index_es.FontAwesomeIcon, {
                icon: faExclamationCircle/* faExclamationCircle */.RL,
                className: error
            }),
            jsx_runtime.jsx("div", {
                children: jsx_runtime.jsx(Text_bs/* make */.S, {
                    children: "Failed to send your request"
                }),
                className: Theme_Typography_bs/* Styles.style1 */.z.style1
            }),
            jsx_runtime.jsx("p", {
                children: jsx_runtime.jsx(Text_bs/* make */.S, {
                    children: "Your request has failed to submit, please try again shortly."
                })
            })
        ],
        className: postMessageContainer
    });
    var form$2 = jsx_runtime.jsxs("form", {
        children: [
            formFields,
            jsx_runtime.jsx(Button_bs.make, {
                children: jsx_runtime.jsx("button", {
                    children: jsx_runtime.jsx(Text_bs/* make */.S, {
                        children: match[0] ? "Sending..." : block.submit_cta_text
                    }),
                    type: "submit"
                }),
                colour: /* BusinessPurple */ 3,
                shadow: /* Normal */ 1
            })
        ],
        className: BusinessContactFormSection_bs_form,
        onSubmit: curry._2(form$1.handleSubmit, onSubmit, FormHelpers_bs/* onError */.qQ)
    });
    var emailIcon$1;
    if (email_icon !== undefined) {
        var height = email_icon.height;
        var width = email_icon.width;
        emailIcon$1 = jsx_runtime.jsx("span", {
            children: jsx_runtime.jsx(CmsImage_bs/* make */.S, {
                src: email_icon.url,
                alt: email_icon.description,
                width: width !== 0 ? width : 20,
                height: height !== 0 ? height : 20
            }),
            className: Cn_bs/* make */.S([
                iconContainer,
                emailIcon
            ])
        });
    } else {
        emailIcon$1 = null;
    }
    var phoneIcon$1;
    if (phone_icon !== undefined) {
        var height$1 = phone_icon.height;
        var width$1 = phone_icon.width;
        phoneIcon$1 = jsx_runtime.jsx("span", {
            children: jsx_runtime.jsx(CmsImage_bs/* make */.S, {
                src: phone_icon.url,
                alt: phone_icon.description,
                width: width$1 !== 0 ? width$1 : 20,
                height: height$1 !== 0 ? height$1 : 20
            }),
            className: Cn_bs/* make */.S([
                iconContainer,
                phoneIcon
            ])
        });
    } else {
        phoneIcon$1 = null;
    }
    return jsx_runtime.jsx(KontentContextProvider_bs/* make */.S, {
        children: jsx_runtime.jsx(Kontent_bs/* Consumer.make */.$.make, {
            children: jsx_runtime.jsx("div", {
                children: jsx_runtime.jsxs("div", {
                    children: [
                        jsx_runtime.jsxs("div", {
                            children: [
                                jsx_runtime.jsx("div", {
                                    children: jsx_runtime.jsx(RichText_bs.make, {
                                        children: block.title
                                    }),
                                    className: title
                                }),
                                caml_obj/* notequal */.$k(emailIcon$1, null) ? jsx_runtime.jsx("div", {
                                    children: jsx_runtime.jsxs("a", {
                                        children: [
                                            emailIcon$1,
                                            jsx_runtime.jsx(Text_bs/* make */.S, {
                                                children: email
                                            })
                                        ],
                                        href: "mailto:" + email
                                    }),
                                    className: linkContainer
                                }) : null,
                                caml_obj/* notequal */.$k(phoneIcon$1, null) ? jsx_runtime.jsx("div", {
                                    children: jsx_runtime.jsxs("a", {
                                        children: [
                                            phoneIcon$1,
                                            jsx_runtime.jsx(Text_bs/* make */.S, {
                                                children: phone
                                            })
                                        ],
                                        href: "tel:" + phone
                                    }),
                                    className: linkContainer
                                }) : null,
                                jsx_runtime.jsx(RichText_bs.make, {
                                    children: block.body_text
                                }),
                                jsx_runtime.jsx("div", {
                                    children: ctaButtons,
                                    className: ctaContainer
                                })
                            ]
                        }),
                        jsx_runtime.jsx("div", {
                            children: match$1[0] ? success$1 : match$2[0] ? error$1 : form$2,
                            className: formContainer
                        })
                    ],
                    className: BusinessContactFormSection_bs_wrapper
                }),
                className: IndexStyles_bs/* section */.qi,
                id: "speak-with-our-team"
            })
        }),
        itemId: smart_link.itemId,
        elementCodename: smart_link.codename
    });
}
var BusinessContactFormSection_bs_KontentContextConsumer;
var BusinessContactFormSection_bs_RichText;
var BusinessContactFormSection_bs_make = BusinessContactFormSection;
 /* wrapper Not a pure module */ 

// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/common/OffsetBlocks/OffsetBlocks.bs.js
var OffsetBlocks_bs = __webpack_require__(23462);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/common/OffsetBlocks/OffsetBlocks__Block.bs.js
var OffsetBlocks_Block_bs = __webpack_require__(96532);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/business/SectionHeading/SectionHeading__Business.bs.js
var SectionHeading_Business_bs = __webpack_require__(50103);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/common/OffsetBlocks/OffsetBlocks__BlockContent.bs.js
var OffsetBlocks_BlockContent_bs = __webpack_require__(42163);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/common/OffsetBlocks/OffsetBlocks__BlockHeading.bs.js
var OffsetBlocks_BlockHeading_bs = __webpack_require__(53130);
;// CONCATENATED MODULE: ./src/components/pages/business/WeveGotALotToBeProudAbout.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE




















var WeveGotALotToBeProudAbout_bs_wrapper = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* paddingTop */.odA(BsCss_bs.px(28)),
    tl: {
        hd: BsCss_bs/* paddingBottom */.EtG(BsCss_bs.px(60)),
        tl: {
            hd: BsCss_bs/* media */.BC2(Theme_Responsive_bs/* tabletSmUp */.Uv, {
                hd: BsCss_bs/* paddingTop */.odA(BsCss_bs.px(38)),
                tl: {
                    hd: BsCss_bs/* paddingBottom */.EtG(BsCss_bs.px(23)),
                    tl: /* [] */ 0
                }
            }),
            tl: {
                hd: BsCss_bs/* media */.BC2(Theme_Responsive_bs/* desktop */.gv, {
                    hd: BsCss_bs/* paddingTop */.odA(BsCss_bs.px(65)),
                    tl: {
                        hd: BsCss_bs/* paddingBottom */.EtG(BsCss_bs.px(108)),
                        tl: /* [] */ 0
                    }
                }),
                tl: /* [] */ 0
            }
        }
    }
});
var block = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* important */.efO(BsCss_bs/* flexDirection */.Me8("row")),
    tl: /* [] */ 0
});
var kontentWrapper = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* display */.jfB("flex"),
    tl: {
        hd: BsCss_bs/* width */.bf$(BsCss_bs/* pct */.hdZ(100)),
        tl: {
            hd: BsCss_bs/* flexDirection */.Me8(BsCss_bs/* column */.$QP),
            tl: /* [] */ 0
        }
    }
});
var WeveGotALotToBeProudAbout_bs_heading = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* selector */.nZE("h1, h2, h3, h4, h5, h6", {
        hd: BsCss_bs/* margin3 */.F86("zero", "zero", BsCss_bs.px(24)),
        tl: {
            hd: BsCss_bs/* textAlign */.ydu("center"),
            tl: {
                hd: BsCss_bs/* color */.$_Y(Theme_Color_bs/* Business.charcoal */.e.charcoal),
                tl: {
                    hd: BsCss_bs/* fontSize */.JBY(BsCss_bs.px(32)),
                    tl: {
                        hd: BsCss_bs/* lineHeight */.Nv8(BsCss_bs.px(40)),
                        tl: {
                            hd: BsCss_bs/* media */.BC2(Theme_Responsive_bs/* desktop */.gv, {
                                hd: BsCss_bs/* fontSize */.JBY(BsCss_bs.px(42)),
                                tl: {
                                    hd: BsCss_bs/* lineHeight */.Nv8(BsCss_bs.px(58)),
                                    tl: {
                                        hd: BsCss_bs/* marginBottom */.yl7(BsCss_bs.px(38)),
                                        tl: /* [] */ 0
                                    }
                                }
                            }),
                            tl: /* [] */ 0
                        }
                    }
                }
            }
        }
    }),
    tl: /* [] */ 0
});
var WeveGotALotToBeProudAbout_bs_container = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* maxWidth */.kkr(BsCss_bs.px(768)),
    tl: {
        hd: BsCss_bs/* marginLeft */.oIA("auto"),
        tl: {
            hd: BsCss_bs/* marginRight */.wzR("auto"),
            tl: /* [] */ 0
        }
    }
});
var reviews = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* marginTop */.E9m(BsCss_bs.px(24)),
    tl: {
        hd: BsCss_bs/* marginBottom */.yl7(BsCss_bs.px(7)),
        tl: {
            hd: BsCss_bs/* media */.BC2(Theme_Responsive_bs/* desktop */.gv, {
                hd: BsCss_bs/* marginTop */.E9m(BsCss_bs.px(52)),
                tl: /* [] */ 0
            }),
            tl: /* [] */ 0
        }
    }
});
var WeveGotALotToBeProudAbout_bs_Styles = {
    wrapper: WeveGotALotToBeProudAbout_bs_wrapper,
    block: block,
    kontentWrapper: kontentWrapper,
    heading: WeveGotALotToBeProudAbout_bs_heading,
    container: WeveGotALotToBeProudAbout_bs_container,
    reviews: reviews
};
function WeveGotALotToBeProudAbout_bs_getHeading(str) {
    return jsx_runtime.jsx(SectionHeading_Business_bs/* make */.S, {
        children: jsx_runtime.jsx(RichText_bs.make, {
            children: str
        }),
        className: WeveGotALotToBeProudAbout_bs_heading
    });
}
function getTiles(tiles) {
    var blocks = belt_Array/* mapWithIndex */.Su(tiles, function(idx, tile) {
        var key = String(idx);
        var smartLink = tile.smartLink;
        return jsx_runtime.jsx(OffsetBlocks_Block_bs/* make */.S, {
            children: jsx_runtime.jsx(KontentContextProvider_bs/* make */.S, {
                children: jsx_runtime.jsx(Kontent_bs/* Consumer.make */.$.make, {
                    children: jsx_runtime.jsxs("div", {
                        children: [
                            jsx_runtime.jsx(OffsetBlocks_BlockHeading_bs/* make */.S, {
                                children: jsx_runtime.jsx(RichText_bs.make, {
                                    children: tile.title
                                })
                            }),
                            jsx_runtime.jsx(OffsetBlocks_BlockContent_bs/* make */.S, {
                                children: jsx_runtime.jsx(ImageGrid_bs/* make */.Sy, {
                                    children: ImageCollectionUtil_bs/* Helpers.getImages */.Z.getImages(tile.images),
                                    className: idx === 1 ? reviews : "",
                                    gap: tile.gap_desktop,
                                    gapTablet: tile.gap_tablet,
                                    gapMobile: tile.gap_mobile,
                                    perRow: tile.display_per_row_desktop,
                                    perRowTablet: tile.display_per_row_tablet,
                                    perRowMobile: tile.display_per_row_mobile
                                })
                            })
                        ],
                        className: kontentWrapper
                    })
                }),
                itemId: smartLink.itemId,
                elementCodename: smartLink.codename
            }),
            className: block
        }, key);
    });
    return jsx_runtime.jsx(OffsetBlocks_bs/* make */.Sy, {
        children: blocks
    });
}
var Build = {
    getHeading: WeveGotALotToBeProudAbout_bs_getHeading,
    getTiles: getTiles
};
function WeveGotALotToBeProudAbout(props) {
    var block = props.block;
    var smartLink = block.smartLink;
    var tiles = block.tiles;
    var title = block.title;
    var heading = title === "" ? null : WeveGotALotToBeProudAbout_bs_getHeading(title);
    var bgColourStyle = belt_Option/* mapWithDefault */.k7(block.background_colour, "", function(bg) {
        return curry._1(Css_bs/* style */.oBv, {
            hd: Css_bs/* unsafe */.K47("backgroundColor", bg),
            tl: /* [] */ 0
        });
    });
    var offsetTiles = tiles.length !== 0 ? getTiles(tiles) : null;
    return jsx_runtime.jsx("div", {
        children: jsx_runtime.jsx("div", {
            children: jsx_runtime.jsx(KontentContextProvider_bs/* make */.S, {
                children: jsx_runtime.jsx(Kontent_bs/* Consumer.make */.$.make, {
                    children: jsx_runtime.jsxs("div", {
                        children: [
                            heading,
                            offsetTiles
                        ],
                        className: WeveGotALotToBeProudAbout_bs_container
                    })
                }),
                itemId: smartLink.itemId,
                elementCodename: smartLink.codename
            }),
            className: IndexStyles_bs/* section */.qi
        }),
        className: Cn_bs/* make */.S([
            WeveGotALotToBeProudAbout_bs_wrapper,
            bgColourStyle
        ])
    });
}
var WeveGotALotToBeProudAbout_bs_SectionHeading;
var OffsetBlocks;
var Block;
var WeveGotALotToBeProudAbout_bs_Heading;
var Content;
var WeveGotALotToBeProudAbout_bs_RichText;
var WeveGotALotToBeProudAbout_bs_ImageGrid;
var WeveGotALotToBeProudAbout_bs_KontentContextConsumer;
var WeveGotALotToBeProudAbout_bs_ImageCollectionHelpers;
var WeveGotALotToBeProudAbout_bs_make = WeveGotALotToBeProudAbout;
 /* wrapper Not a pure module */ 

// EXTERNAL MODULE: ./src/components/TrustpilotWidgetSection.bs.js + 2 modules
var TrustpilotWidgetSection_bs = __webpack_require__(22303);
// EXTERNAL MODULE: ./src/components/pages/about/BoardOfDirectorsSection.bs.js
var BoardOfDirectorsSection_bs = __webpack_require__(95853);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/models/Models.bs.js
var Models_bs = __webpack_require__(37698);
// EXTERNAL MODULE: ./src/components/library/SkuCarousel.tsx + 2 modules
var SkuCarousel = __webpack_require__(94257);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/common/Tagline/Tagline.bs.js
var Tagline_bs = __webpack_require__(1552);
// EXTERNAL MODULE: ./src/hooks/useSegment.ts
var useSegment = __webpack_require__(59945);
// EXTERNAL MODULE: ./src/config/Localization.bs.js
var Localization_bs = __webpack_require__(98765);
// EXTERNAL MODULE: ./src/common/util.ts + 3 modules
var util = __webpack_require__(42358);
;// CONCATENATED MODULE: ./src/components/pages/index/ShopBySkuSection.tsx


















var style = {
    carouselPadding: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("margin-top:-1rem;padding-top:1rem;margin-left:-2rem;padding-left:2rem;padding-bottom:3rem;margin-bottom:-1rem;@media ", Theme_Responsive_bs/* mobile */.ai, "{margin-right:-1.25rem;margin-left:-1.25rem;padding-left:1.25rem;}"),
    buttonMargin: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("margin-top:1rem;"),
    wrapper: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("max-width:1440px;margin-left:auto;margin-right:auto;padding-left:1.25rem;padding-right:1.25rem;padding-top:52px;padding-bottom:52px;display:flex;flex-direction:column;.swiper-scrollbar{@media ", Theme_Responsive_bs/* mobile */.ai, "{width:calc(100% - ", 30 * 2, "px);}}.swiper-slide-prev{opacity:0;transition-property:opacity;transition-duration:300;}.swiper-slide:first-child > div{margin-left:0px !important;}.sku-swiper-last-slide .swiper-slide-prev{opacity:0;}@media ", Theme_Responsive_bs/* tabletOrDesktop */.ab, "{padding-left:1.875rem;padding-right:1.875rem;}@media ", Theme_Responsive_bs/* tabletOrMobile */.k$, "{padding-top:42px;padding-bottom:42px;}@media ", Theme_Responsive_bs/* tabletSm */.FV, "{padding-top:32px;padding-bottom:36px;}"),
    bgLilac: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("background-color:#", Theme_Color_bs/* lilac50.VAL */.wD.VAL, ";.carousel-card{background-color:", Theme_Color_bs/* white.VAL */.ix.VAL, ";}.sku-swiper-overlay{background:linear-gradient(-90deg,#", Theme_Color_bs/* lilac50.VAL */.wD.VAL, " 0%,transparent 100%);}"),
    headingWrapper: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("margin-bottom:21px;padding-right:100px;@media ", Theme_Responsive_bs/* tablet */.Mq, "{margin-bottom:30px;}@media ", Theme_Responsive_bs/* desktop */.gv, "{margin-bottom:22px;}@media ", Theme_Responsive_bs/* smallScreenOrMobile */.HH, "{padding-right:0;}"),
    heading: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("font-size:28px;line-height:38px;font-weight:600;margin-bottom:6px;@media ", Theme_Responsive_bs/* tablet */.Mq, "{font-size:32px;line-height:40px;}@media ", Theme_Responsive_bs/* desktop */.gv, "{font-size:40px;line-height:40px;}"),
    subheading: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("color:#", Theme_Color_bs/* Personal.midGrey.VAL */.RL.midGrey.VAL, ";font-size:1rem;line-height:1.5rem;display:none;@media ", Theme_Responsive_bs/* desktop */.gv, "{display:inline-block;}")
};
var getSegmentElementName = function(label) {
    return "".concat(label.replace(Regex_bs/* spaceRegex */.J4, "_").toLowerCase(), "_cta");
};
var ShopBySkuSection = function(param) {
    var block = param.block, inventory = param.inventory, skuDict = param.skuDict;
    var router = (0,next_router.useRouter)();
    var uid = block.uid, title = block.title, button = block.button, subtitle = block.subtitle, description = block.description, background = block.background, skuList = block.skuList, smartLink = block.smartLink;
    var spotlightProps = (0,useSmartLink/* default */.Z)(smartLink);
    var customElementInteraction = (0,useSegment/* default */.Z)().customElementInteraction;
    var cards = inventory ? inventory.skus.map(function(card) {
        return Models_bs/* Card.skuToCard */.Zb.skuToCard(card);
    }) : block.inventory;
    var pinnedSkuList = (0,react.useMemo)(function() {
        return skuList !== "" ? skuList.split(",").map(function(str) {
            return Models_bs/* Card.makeSlug */.Zb.makeSlug(str);
        }) : [];
    }, [
        skuList
    ]);
    var sectionStyle = background === "lilac" ? style.bgLilac : "";
    var noOfCards = block.noOfCards ? block.noOfCards : cards.filter(function(card) {
        if (card.denominations.length) {
            return card.denominations[0].valueCurrency === util/* envUtil.currencyCode */.vK.currencyCode && !card.isSwappable;
        }
    }).length;
    var region = (0,Localization_bs/* getLocalizedString */.Z)("region");
    var cardString = noOfCards >= 10 ? Math.floor(noOfCards / 10) * 10 : noOfCards;
    var parsedSubtitle = subtitle.replace("{0}", region).replace("{1}", "".concat(cardString).concat(noOfCards >= 10 ? "+" : ""));
    (0,react.useEffect)(function() {
        var isCustomList = skuList !== "";
        var featuredCards = isCustomList ? cards : cards.filter(function(card) {
            return card.categories.find(function(category) {
                return category.name === "Featured";
            });
        });
        var products = featuredCards.map(function(card, index) {
            return (0,Segment_bs/* cardToProductWithIndex */.bC)(index, card);
        });
        var list_id = parsedSubtitle.replace(Regex_bs/* spaceRegex */.J4, "_").toLowerCase().slice(0, 20);
        var category = isCustomList ? "Custom" : "Featured";
        (0,Segment_bs/* productListViewed */.ZX)({
            list_id: list_id,
            category: category,
            products: products
        });
    }, []);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("section", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: sectionStyle
    }, spotlightProps), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
            className: style.wrapper,
            children: [
                title !== "" ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Tagline_bs/* make */.S, {
                    children: title
                }) : null,
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                    className: style.headingWrapper,
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("h2", {
                            className: style.heading,
                            children: parsedSubtitle
                        }),
                        description !== "" ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                            className: style.subheading,
                            dangerouslySetInnerHTML: {
                                __html: description
                            }
                        }) : null
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(SkuCarousel/* default */.Z, {
                    className: style.carouselPadding,
                    inventory: inventory,
                    skuDict: skuDict,
                    skuList: pinnedSkuList,
                    uid: uid,
                    cardsList: inventory ? undefined : block.inventory
                }),
                button ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Button_bs.make, {
                    variant: button.variant,
                    colour: button.colour,
                    fill: button.fill,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("button", {
                        onClick: function() {
                            customElementInteraction({
                                element: getSegmentElementName(button.cta_text),
                                journey: "sku_list",
                                element_href: button.cta_url,
                                user_type: "consumer"
                            });
                            router.push(button.cta_url);
                        },
                        children: button.cta_text
                    })
                }) : null
            ]
        })
    }));
};
/* harmony default export */ var index_ShopBySkuSection = (ShopBySkuSection);

;// CONCATENATED MODULE: ./src/components/pages/index/ShopBySkuSection.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

var ShopBySkuSection_bs_make = index_ShopBySkuSection;
var ShopBySkuSection_bs_Button;
var ShopBySkuSection_bs_KontentContextConsumer;
var Link;
 /* make Not a pure module */ 

// EXTERNAL MODULE: ./node_modules/@prezzee/typography/lib/index.js
var lib = __webpack_require__(55489);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
;// CONCATENATED MODULE: ./src/components/pages/basicContent/NarrowBannerFull.tsx







var NarrowBannerFull_classes = {
    root: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)({
        display: "flex",
        flexDirection: "row",
        justifyContent: "center"
    }),
    screen: function(bgColor, alignment, height, width) {
        var defaultWidth = "100%";
        var defaultHeight = "300px";
        return /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)({
            display: "flex",
            height: height ? "".concat(height, "px") : defaultHeight,
            width: width ? "".concat(width, "px") : defaultWidth,
            backgroundColor: bgColor,
            justifyContent: alignment || "center",
            alignItems: "center"
        });
    },
    content: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)({
        display: "flex",
        paddingLeft: "20px",
        paddingRight: "20px",
        flexDirection: "column",
        justifyContent: "center"
    }),
    title: {
        root: function(alignment) {
            return /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)({
                display: "flex",
                justifyContent: alignment,
                paddingBottom: "10px"
            });
        },
        text: function(colour, alignment) {
            return /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)({
                color: "".concat(colour, " !important"),
                textAlign: {
                    left: "start",
                    center: "center",
                    right: "end"
                }[alignment] || "center"
            });
        }
    },
    subtitle: {
        root: function(alignment) {
            return /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)({
                display: "flex",
                justifyContent: alignment
            });
        },
        text: function(colour, alignment) {
            return /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)({
                color: "".concat(colour, " !important"),
                fontSize: "16px !important",
                fontWeight: "".concat(400, " !important"),
                textAlign: {
                    left: "start",
                    center: "center",
                    right: "end"
                }[alignment] || "center"
            });
        }
    }
};
/**
 * Basic Content Narrow banner
 * @constructor
 */ var NarrowBannerFull = function(param) {
    var block = param.block, key = param.key;
    var spotlightProps = (0,useSmartLink/* default */.Z)(block.smartLink);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: NarrowBannerFull_classes.root
    }, spotlightProps), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
            className: NarrowBannerFull_classes.screen(block.banner_colour, block.alignment, block.banner_height, block.width),
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                className: NarrowBannerFull_classes.content,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                        className: NarrowBannerFull_classes.title.root(block.alignment),
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)((lib_default()), {
                            variant: "h1",
                            className: NarrowBannerFull_classes.title.text("#ffffff", block.alignment),
                            children: block.title
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                        className: NarrowBannerFull_classes.subtitle.root(block.alignment),
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)((lib_default()), {
                            variant: "h3",
                            className: NarrowBannerFull_classes.subtitle.text("#ffffff", block.alignment),
                            children: block.subtitle
                        })
                    })
                ]
            })
        })
    }), key);
};

// EXTERNAL MODULE: ./src/components/library/SeoMeta.tsx
var SeoMeta = __webpack_require__(48882);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon-ui/lib/components/Typography/index.js
var Typography = __webpack_require__(43543);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon-ui/lib/theme/foundations/colors.js
var colors = __webpack_require__(85171);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon-ui/lib/theme/foundations/breakpoints.js
var breakpoints = __webpack_require__(72486);
// EXTERNAL MODULE: ./src/components/CmsImage.tsx
var CmsImage = __webpack_require__(73450);
;// CONCATENATED MODULE: ./src/components/library/ProductHeroSection.tsx
















var RetailerListDialog = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6533).then(__webpack_require__.bind(__webpack_require__, 16533));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(16533)
            ];
        }
    }
});
var ProductHeroSection_style = {
    container: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("max-width:1208px;margin:0 auto;padding:65px 32px 56px;display:flex;justify-content:space-between;align-items:flex-start;@media (max-width:", breakpoints["default"].lg, "){padding:23px 32px 48px;}@media ", Theme_Responsive_bs/* tabletSm */.FV, "{flex-direction:column-reverse;padding:16px 0 19px;}"),
    content: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("width:50%;@media ", Theme_Responsive_bs/* tabletSm */.FV, "{width:100%;padding:0 20px 0;}"),
    subtitle: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("margin:11px 0 0;@media (max-width:", breakpoints["default"].lg, "){margin:8px 0 0;}"),
    text: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("font-size:16px;color:", colors["default"].gray[600], ";margin:8px 0 0;ul{list-style:disc;padding-left:28px;margin-top:12px;}a{text-decoration:underline;color:", theme/* Color.Blue500 */.Il.Blue500, ";}@media (max-width:", breakpoints["default"].lg, "){margin:10px 0 0;}"),
    iconsContainer: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("display:flex;margin:19px 0 0;padding:0 0 7px;"),
    icon: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("width:33%;padding:6px;display:flex;flex-flow:column;align-items:center;text-align:center;justify-content:flex-start;margin-right:13px;position:relative;flex:1;&::after{content:'';height:100%;width:1px;background:", colors["default"].gray[300], ";position:absolute;right:-6px;top:7px;border-radius:50%;@media ", Theme_Responsive_bs/* tabletSm */.FV, "{right:0;}}&:last-child{margin:0;&::after{content:none;}}@media ", Theme_Responsive_bs/* tabletSm */.FV, "{flex:1;width:33.3%;margin-right:0;}"),
    iconImage: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("width:50px;@media ", Theme_Responsive_bs/* tabletSm */.FV, "{width:62%;max-width:60px;}"),
    iconText: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("margin:6px 0 0;br{&.desktop{@media ", breakpoints["default"].lg, "{display:none;}}&.tablet{display:none;@media ", breakpoints["default"].lg, "{display:inline;}@media ", Theme_Responsive_bs/* tabletSm */.FV, "{display:none;}}&.mobile{display:none;@media ", Theme_Responsive_bs/* tabletSm */.FV, "{display:inline;}}}"),
    image: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("width:39%;@media (max-width:", breakpoints["default"].lg, "){width:47%;}@media ", Theme_Responsive_bs/* tabletSm */.FV, "{width:100%;margin:21px 0 0;}"),
    additionalDescription: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("padding-top:16px;margin-top:24px;border-top:1px solid ", theme/* Color.Gray300 */.Il.Gray300, ";a{text-decoration:underline;color:", theme/* Color.Blue500 */.Il.Blue500, ";}strong{display:block;font-size:20px;margin-bottom:8px;}@media ", Theme_Responsive_bs/* tabletSm */.FV, "{margin-top:20px;}"),
    btnContainer: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("margin-top:20px;display:flex;align-items:baseline;flex-wrap:wrap;@media ", Theme_Responsive_bs/* tabletSm */.FV, "{flex-direction:column;position:fixed;left:0;right:0;bottom:0;z-index:100;padding:12px 20px 6px;background:#ffffff;box-shadow:0px -6px 42px rgba(0,0,0,0.17);border-radius:4px;align-items:center;}"),
    primaryBtn: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("background:", colors["default"].red[400], ";transition:background-color 200ms;color:#ffffff;font-weight:600;border-radius:4px;height:50px;padding:0;flex-grow:1;white-space:nowrap;flex-basis:48%;&:hover{background:", colors["default"].red[500], ";}@media (max-width:", breakpoints["default"].lg, "){height:auto;padding:13px 45px;}@media ", Theme_Responsive_bs/* tabletSm */.FV, "{width:100%;text-align:center;}"),
    secondaryBtn: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("margin:0 0 0 12px;color:", colors["default"].purple[400], ";font-weight:600;flex-grow:1;height:50px;white-space:nowrap;flex-basis:48%;@media (max-width:", breakpoints["default"].lg, "){margin:12px 0 0;height:auto;padding:13px 45px;}@media ", Theme_Responsive_bs/* tabletSm */.FV, "{width:100%;margin:7px 0 0;}")
};
var emptyCMSContent = "<p><br></p>";
var ProductHeroSection = function(param) {
    var _block = param.block, title = _block.title, subtitle = _block.subtitle, description = _block.description, icons = _block.icons, image = _block.image, primaryButton = _block.primaryButton, secondaryButton = _block.secondaryButton, productSlug = _block.productSlug, additionalDescription = _block.additionalDescription, smartLink = _block.smartLink, retailerList = _block.retailerList;
    var ref = (0,react.useState)(false), retailerListOpen = ref[0], setRetailerListOpen = ref[1];
    var handleRetailerListClose = function() {
        return setRetailerListOpen(false);
    };
    var spotlightProps = (0,useSmartLink/* default */.Z)(smartLink);
    var iconsContainer = icons.length ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
        className: ProductHeroSection_style.iconsContainer,
        children: icons.map(function(param) {
            var _icon = param.icon, url = _icon.url, description = _icon.description, width = _icon.width, height = _icon.height, text = param.text, codename = param.smartLink.codename;
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                className: ProductHeroSection_style.icon,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(CmsImage/* default */.Z, {
                        className: ProductHeroSection_style.iconImage,
                        src: url,
                        alt: description,
                        width: width,
                        height: height,
                        sizes: "60px"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                        className: ProductHeroSection_style.iconText,
                        dangerouslySetInnerHTML: {
                            __html: text
                        }
                    }, smartLink.itemId)
                ]
            }, codename);
        })
    }) : null;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(emotion_react_jsx_runtime_browser_esm.Fragment, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("style", {
                    children: "@media ".concat(Theme_Responsive_bs/* tabletSm */.FV, " {\n            #ada-button-frame {\n              bottom: ").concat(secondaryButton ? "114px" : "70px", " !important;\n            }\n          }")
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                className: ProductHeroSection_style.container
            }, spotlightProps), {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(CmsImage/* default */.Z, {
                        className: ProductHeroSection_style.image,
                        src: image.url,
                        alt: image.description,
                        width: image.width,
                        height: image.height,
                        sizes: "".concat(Theme_Responsive_bs/* tabletSm */.FV, " 100vw, (max-width: ").concat(breakpoints["default"].lg, ") 47vw, 446px")
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                        className: ProductHeroSection_style.content,
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Typography["default"], {
                                variant: "h1",
                                children: title
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Typography["default"], {
                                className: ProductHeroSection_style.subtitle,
                                variant: "subtitle2",
                                children: subtitle
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(RichText_gen/* make */.S, {
                                className: ProductHeroSection_style.text,
                                children: description
                            }),
                            iconsContainer,
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                                className: ProductHeroSection_style.btnContainer,
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)((link_default()), {
                                        href: primaryButton.cta_url,
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("button", {
                                            className: ProductHeroSection_style.primaryBtn,
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("a", {
                                                children: primaryButton.cta_text
                                            })
                                        })
                                    }),
                                    secondaryButton ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("button", {
                                        onClick: function() {
                                            setRetailerListOpen(true);
                                        },
                                        className: ProductHeroSection_style.secondaryBtn,
                                        children: secondaryButton.cta_text
                                    }) : null
                                ]
                            }),
                            additionalDescription && additionalDescription !== emptyCMSContent ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(RichText_gen/* make */.S, {
                                className: ProductHeroSection_style.additionalDescription,
                                children: additionalDescription
                            }) : null
                        ]
                    }),
                    secondaryButton && (retailerList === null || retailerList === void 0 ? void 0 : retailerList.length) > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(RetailerListDialog, {
                        retailerList: retailerList,
                        isOpen: retailerListOpen,
                        handleRetailerListClose: handleRetailerListClose
                    })
                ]
            }))
        ]
    });
};
/* harmony default export */ var library_ProductHeroSection = (ProductHeroSection);

;// CONCATENATED MODULE: ./src/common/highlightText.tsx

var highlightText = function(text) {
    var openBracketIndex = text.indexOf("{");
    var closeBracketIndex = text.indexOf("}");
    var beforeHighlight = text.slice(0, openBracketIndex);
    var highlight = text.slice(openBracketIndex + 1, closeBracketIndex);
    var afterHighlight = text.slice(closeBracketIndex + 1);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(emotion_react_jsx_runtime_browser_esm.Fragment, {
        children: [
            beforeHighlight,
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("span", {
                children: highlight
            }),
            afterHighlight
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/library/SellingPointsSection.tsx













var SellingPointsSection_style = {
    container: function(bgColor) {
        return /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("background-color:", bgColor, ";");
    },
    wrapper: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("max-width:1014px;padding:56px 32px 30px;margin:0 auto;@media (max-width:", breakpoints["default"].lg, "){padding:48px 32px 30px;}@media ", Theme_Responsive_bs/* tabletSm */.FV, "{padding:20px 20px 20px;}"),
    title: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("font-family:'DM Serif Display';font-size:42px;line-height:62px;color:", colors["default"].purple[400], ";margin:0 0 10px;text-align:center;span{font-style:italic;position:relative;white-space:nowrap;&::after{content:'';position:absolute;bottom:0;left:0;transform:translate(0,100%);width:100%;padding-top:7%;background:url('/images/curved_red_underline.svg') center center no-repeat;background-size:contain;}}"),
    item: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("display:flex;align-items:center;justify-content:space-between;margin:60px 0 0;:first-of-type{margin:70px 0 0;}:nth-of-type(even){flex-direction:row-reverse;}@media ", Theme_Responsive_bs/* tabletSm */.FV, "{flex-flow:column-reverse;:nth-of-type(even){flex-flow:column-reverse;}:first-of-type{margin:50px 0 0;}margin:24px 0 0;}"),
    itemContent: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("width:42%;@media (max-width:", breakpoints["default"].lg, "){width:48%;}@media ", Theme_Responsive_bs/* tabletSm */.FV, "{width:100%;margin:24px 0 0;text-align:center;}"),
    itemTitle: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("color:", colors["default"].gray[800], ";font-size:32px;line-height:42px;font-weight:600;span{font-family:'DM Serif Display';color:", colors["default"].purple[400], ";font-style:italic;font-weight:400;}"),
    itemDescription: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("margin:6px 0 0;color:", colors["default"].gray[600], ";"),
    itemImage: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("width:37%;@media ", Theme_Responsive_bs/* tabletSm */.FV, "{width:100%;}")
};
var SellingPointItem = function(param) {
    var image = param.image, title = param.title, description = param.description, video_mp4 = param.video_mp4, video_webm = param.video_webm;
    var isVideo = video_mp4 || video_webm;
    var videoRef = (0,react.useRef)(null);
    var isHighlight = Regex/* curlyBrackets.test */.vL.test(title);
    (0,react.useEffect)(function() {
        if (isVideo && videoRef.current) {
            var sourceElements = Array.from(videoRef.current.children);
            sourceElements.forEach(function(element) {
                if (element.tagName === "SOURCE") {
                    element.src = element.dataset.src;
                }
            });
            videoRef.current.load();
        }
    }, []);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("article", {
        className: SellingPointsSection_style.item,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                className: SellingPointsSection_style.itemContent,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("h3", {
                        className: SellingPointsSection_style.itemTitle,
                        children: isHighlight ? highlightText(title) : title
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                        className: SellingPointsSection_style.itemDescription,
                        children: description
                    })
                ]
            }),
            isVideo ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("video", {
                className: SellingPointsSection_style.itemImage,
                autoPlay: true,
                muted: true,
                loop: true,
                playsInline: true,
                width: image.width,
                height: image.height,
                poster: "".concat(image.url, "?fm=png&auto=format"),
                ref: videoRef,
                children: [
                    video_webm && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("source", {
                        "data-src": video_webm.url,
                        type: "video/webm"
                    }),
                    video_mp4 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("source", {
                        "data-src": video_mp4.url,
                        type: "video/mp4"
                    })
                ]
            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(CmsImage/* default */.Z, {
                src: image.url,
                alt: image.description,
                width: image.width,
                height: image.height,
                sizes: "".concat(Theme_Responsive_bs/* tabletSm */.FV, " 100vw, (max-width: ").concat(breakpoints["default"].lg, ") 47vw, 360px"),
                className: SellingPointsSection_style.itemImage
            })
        ]
    });
};
var SellingPointsSection = function(param) {
    var _block = param.block, smartLink = _block.smartLink, title = _block.title, backgroundColour = _block.backgroundColour, items = _block.items;
    var spotlightProps = (0,useSmartLink/* default */.Z)(smartLink);
    var isHighlightTitle = Regex/* curlyBrackets.test */.vL.test(title);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("section", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: SellingPointsSection_style.container(backgroundColour)
    }, spotlightProps), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
            className: SellingPointsSection_style.wrapper,
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("h2", {
                    className: SellingPointsSection_style.title,
                    children: isHighlightTitle ? highlightText(title) : title
                }),
                items.map(function(item) {
                    return /*#__PURE__*/ (0,react.createElement)(SellingPointItem, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                        key: item.smartLink.codename
                    }));
                })
            ]
        })
    }));
};
/* harmony default export */ var library_SellingPointsSection = (SellingPointsSection);

// EXTERNAL MODULE: ./node_modules/swiper/modules/index.mjs + 26 modules
var modules = __webpack_require__(99304);
// EXTERNAL MODULE: ./src/components/heroBanner/columnBannersShared.tsx
var columnBannersShared = __webpack_require__(62001);
;// CONCATENATED MODULE: ./src/components/heroBanner/N1ColumnBanner.tsx











var N1ColumnBanner_style = {
    container: function(bgColour, isBorderRadius) {
        return /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("display:flex;position:relative;background-color:", bgColour, ";overflow:hidden;", isBorderRadius ? "\n      border-radius: 8px;\n    " : "", ";img{width:100%;}");
    },
    styleSide: function(tabletBreakpoint, isRight, isFullScreen) {
        return /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("align-items:center;justify-content:space-between;flex-direction:", isRight ? "row-reverse" : "row", ";.n1cb-content{padding:", isRight ? "0 72px 0 0" : "0 0 0 72px", ";width:42%;", isFullScreen && !isRight ? "\n        @media (min-width: 1500px) {\n          padding: 0 0 0 calc((100% - 1380px) / 2);\n          width: 48%;\n        }\n      " : "", "}.n1cb-primaryImg{width:44%;}@media ", tabletBreakpoint, "{flex-direction:column-reverse;align-items:flex-start;.n1cb-content{padding:16px 24px 24px;width:60%;}.n1cb-primaryImg{width:100%;}}@media ", Theme_Responsive_bs/* smallScreenOrMobile */.HH, "{.n1cb-content{width:80%;}}@media ", Theme_Responsive_bs/* tabletSm */.FV, "{flex-direction:column-reverse;.n1cb-content{padding:20px;width:100%;}}");
    },
    styleSideBg: function(isRight) {
        return /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)(".n1cb-content{position:absolute;top:0;left:", isRight ? "unset" : "0", ";right:", isRight ? "0" : "unset", ";bottom:0;justify-content:center;}.n1cb-primaryImg{width:100%;}@media ", Theme_Responsive_bs/* tabletSm */.FV, "{flex-direction:column-reverse;}");
    },
    styleCenter: function(tabletBreakpoint, isSecondImageMissing) {
        return /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("flex-direction:row-reverse;justify-content:space-between;.n1cb-content{width:33%;justify-content:center;text-align:center;}.n1cb-primaryImg{width:30%;}.n1cb-secondaryImg{width:30%;}.n1cb-btns{justify-content:center;}@media ", tabletBreakpoint, "{flex-direction:column;align-items:center;", isSecondImageMissing ? "flex-direction: column-reverse;" : "", "      .n1cb-primaryImg,.n1cb-secondaryImg{width:100%;}.n1cb-content{padding:20px;width:60%;}}@media ", Theme_Responsive_bs/* smallScreenOrMobile */.HH, "{.n1cb-content{width:100%;}}@media ", Theme_Responsive_bs/* tabletSm */.FV, "{flex-direction:column-reverse;}");
    },
    styleCenterBg: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)(".n1cb-content{width:40%;position:absolute;top:0;bottom:0;left:50%;transform:translateX(-50%);}.n1cb-primaryImg{width:50%;}.n1cb-secondaryImg{width:50%;}.n1cb-btns{justify-content:center;}@media ", Theme_Responsive_bs/* belowLargeScreen */.Qo, "{.n1cb-primaryImg,.n1cb-secondaryImg{width:100%;}.n1cb-content{width:60%;}}@media ", Theme_Responsive_bs/* smallScreenOrMobile */.HH, "{.n1cb-content{width:100%;}}"),
    content: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("display:flex;flex-flow:column;position:relative;z-index:10;"),
    description: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("margin-top:12px;"),
    btnContainer: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("display:flex;margin-top:24px;div:nth-child(2){margin-left:12px;}"),
    secondaryImageContainer: function(isSecondImg) {
        return /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("display:", isSecondImg ? "block" : "none", ";");
    }
};
var getImageSizes = function(isFullscreen, isBgImage, isSecondImage, tabletBreakpoint) {
    var sizes = "".concat(tabletBreakpoint, " 100vw, (max-width: 1440px) 42vw, 610px");
    var sizesBg = "(max-width: 1440px) 100vw, 1380px";
    var sizesFull = "".concat(tabletBreakpoint, " 100vw, 44vw");
    var sizesBgFull = "100vw";
    var center = "".concat(tabletBreakpoint, " 100vw, (max-width: 1440px) 28vw, 420px");
    var centerBg = "".concat(tabletBreakpoint, " 100vw, (max-width: 1440px) 50vw, 690px");
    var centerFull = "".concat(tabletBreakpoint, " 100vw, 30vw");
    var centerBgFull = "".concat(tabletBreakpoint, " 100vw, 50vw");
    var size = "".concat(+isSecondImage).concat(+isBgImage).concat(+isFullscreen);
    return ({
        "000": sizes,
        "010": sizesBg,
        "001": sizesFull,
        "011": sizesBgFull,
        "100": center,
        "110": centerBg,
        "101": centerFull,
        "111": centerBgFull
    })[size];
};
var N1ColumnBanner = function(param) {
    var smartLink = param.smartLink, isFullScreen = param.isFullScreen, isBorderRadius = param.isBorderRadius, bgColour = param.bgColour, copyBlockAlignment = param.copyBlockAlignment, imageTreatment = param.imageTreatment, title = param.title, highlightTextColour = param.highlightTextColour, titleFont = param.titleFont, titleTextColour = param.titleTextColour, titleFontSize = param.titleFontSize, description = param.description, descriptionTextColour = param.descriptionTextColour, descriptionFontSize = param.descriptionFontSize, buttons = param.buttons, imageDesktop = param.imageDesktop, imageTablet = param.imageTablet, imageMobile = param.imageMobile, imageN2Desktop = param.imageN2Desktop, imageN2Tablet = param.imageN2Tablet, imageN2Mobile = param.imageN2Mobile;
    var isBgImage = imageTreatment === "background";
    var isSecondImage = copyBlockAlignment === "centre";
    var titleSize = (0,columnBannersShared/* getTitleSize */.Ec)(titleFontSize);
    var tabletBreakpoint = isFullScreen ? Theme_Responsive_bs/* tabletOrMobile */.k$ : Theme_Responsive_bs/* belowLargeScreen */.Qo;
    var imgSizes = getImageSizes(isFullScreen, isBgImage, isSecondImage, tabletBreakpoint);
    var spotlightProps = (0,useSmartLink/* default */.Z)(smartLink);
    var isHighlight = Regex/* curlyBrackets.test */.vL.test(title) && (0,columnBannersShared/* isSofiaPro */.al)(titleFont);
    var descriptionStyles = (0,columnBannersShared/* getDescriptionStyles */.UE)(descriptionFontSize);
    var isSecondImageMissing = isSecondImage && !imageN2Tablet;
    var styleClass = {
        left: isBgImage ? (0,emotion_css_esm.cx)(N1ColumnBanner_style.styleSide(tabletBreakpoint, false, isFullScreen), N1ColumnBanner_style.styleSideBg(false)) : N1ColumnBanner_style.styleSide(tabletBreakpoint, false, isFullScreen),
        centre: isBgImage ? (0,emotion_css_esm.cx)(N1ColumnBanner_style.styleCenter(tabletBreakpoint, false), N1ColumnBanner_style.styleCenterBg) : N1ColumnBanner_style.styleCenter(tabletBreakpoint, isSecondImageMissing),
        right: isBgImage ? (0,emotion_css_esm.cx)(N1ColumnBanner_style.styleSide(tabletBreakpoint, true, isFullScreen), N1ColumnBanner_style.styleSideBg(true)) : N1ColumnBanner_style.styleSide(tabletBreakpoint, true, isFullScreen)
    }[copyBlockAlignment];
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: (0,emotion_css_esm.cx)(N1ColumnBanner_style.container(bgColour, isBorderRadius && !isFullScreen), styleClass)
    }, spotlightProps), {
        children: [
            isSecondImage && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                className: "n1cb-secondaryImg",
                children: [
                    imageN2Desktop && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(CmsImage/* default */.Z, {
                        src: imageN2Desktop.url,
                        width: imageN2Desktop.width,
                        height: imageN2Desktop.height,
                        alt: imageN2Desktop.description,
                        sizes: imgSizes,
                        className: columnBannersShared/* sharedStyles.imageDesktop */.FG.imageDesktop(tabletBreakpoint),
                        priority: true
                    }),
                    imageN2Tablet && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(CmsImage/* default */.Z, {
                        src: imageN2Tablet.url,
                        width: imageN2Tablet.width,
                        height: imageN2Tablet.height,
                        alt: imageN2Tablet.description,
                        sizes: imgSizes,
                        className: columnBannersShared/* sharedStyles.imageTablet */.FG.imageTablet(tabletBreakpoint),
                        priority: true
                    }),
                    imageN2Mobile && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(CmsImage/* default */.Z, {
                        src: imageN2Mobile.url,
                        width: imageN2Mobile.width,
                        height: imageN2Mobile.height,
                        alt: imageN2Mobile.description,
                        sizes: imgSizes,
                        className: columnBannersShared/* sharedStyles.imageMobile */.FG.imageMobile,
                        priority: true
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                className: (0,emotion_css_esm.cx)(N1ColumnBanner_style.content, "n1cb-content"),
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("h1", {
                        className: (0,emotion_css_esm.cx)(columnBannersShared/* sharedStyles.title */.FG.title(titleTextColour, titleFont, highlightTextColour, tabletBreakpoint), titleSize),
                        dangerouslySetInnerHTML: {
                            __html: isHighlight ? (0,columnBannersShared/* hightlightTitleAsString */.Fb)(title) : title
                        }
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                        className: (0,emotion_css_esm.cx)(descriptionStyles(descriptionTextColour, tabletBreakpoint), N1ColumnBanner_style.description),
                        dangerouslySetInnerHTML: {
                            __html: description
                        }
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                        className: (0,emotion_css_esm.cx)(N1ColumnBanner_style.btnContainer, "n1cb-btns"),
                        children: buttons.map(function(param) {
                            var cta_text = param.cta_text, cta_url = param.cta_url, variant = param.variant, colour = param.colour, fill = param.fill, smartLink = param.smartLink;
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Button_bs.make, {
                                variant: variant,
                                colour: colour,
                                fill: fill,
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)((link_default()), {
                                    href: cta_url,
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("a", {
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("button", {
                                            children: cta_text
                                        })
                                    })
                                })
                            }, smartLink.codename);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                className: "n1cb-primaryImg",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(CmsImage/* default */.Z, {
                        src: imageDesktop.url,
                        width: imageDesktop.width,
                        height: imageDesktop.height,
                        alt: imageDesktop.description,
                        sizes: imgSizes,
                        className: columnBannersShared/* sharedStyles.imageDesktop */.FG.imageDesktop(tabletBreakpoint),
                        loading: "eager"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(CmsImage/* default */.Z, {
                        src: imageTablet.url,
                        width: imageTablet.width,
                        height: imageTablet.height,
                        alt: imageTablet.description,
                        sizes: imgSizes,
                        className: columnBannersShared/* sharedStyles.imageTablet */.FG.imageTablet(tabletBreakpoint),
                        loading: "eager"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(CmsImage/* default */.Z, {
                        src: imageMobile.url,
                        width: imageMobile.width,
                        height: imageMobile.height,
                        alt: imageMobile.description,
                        sizes: imgSizes,
                        className: columnBannersShared/* sharedStyles.imageMobile */.FG.imageMobile,
                        loading: "eager"
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var heroBanner_N1ColumnBanner = (N1ColumnBanner);

;// CONCATENATED MODULE: ./src/components/heroBanner/N2ColumnBanner.tsx











var N2ColumnBanner_style = {
    container: function(tabletBreakpoint) {
        return /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("display:flex;justify-content:space-between;@media ", tabletBreakpoint, "{flex-direction:column;& > div:first-child{margin:0 0 16px;}}img{width:100%;}");
    },
    rightDescription: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("margin-top:8px;"),
    leftGroup: function(bgColour, isBorderRadius, isBorderRadiusFullscreen, tabletBreakpoint) {
        return /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("display:flex;position:relative;background-color:", bgColour, ";width:65.4285714%;overflow:hidden;", isBorderRadius ? "border-radius: 8px;" : "", " ", isBorderRadiusFullscreen ? "border-radius: 0 8px 8px 0;\n    @media ".concat(tabletBreakpoint, " {\n      border-radius: 0;\n    }") : "", "    .n2cb-leftContent{display:flex;flex-flow:column;}");
    },
    rightGroup: function(bgColour, isBorderRadius, isBorderRadiusFullscreen, tabletBreakpoint) {
        return /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("display:flex;position:relative;background-color:", bgColour, ";width:33.1428571%;overflow:hidden;", isBorderRadius ? "border-radius: 8px;" : "", " ", isBorderRadiusFullscreen ? "border-radius: 8px 0 0 8px;\n    @media ".concat(tabletBreakpoint, " {\n      border-radius: 0;\n    }") : "", "    .n2cb-rightContent{display:flex;flex-flow:column;}");
    },
    groupTablet: function(tabletBreakpoint, contentClassname, imgClassname, isCenter) {
        return /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("@media ", tabletBreakpoint, "{width:100%;flex-direction:column-reverse;align-items:", isCenter ? "center" : "flex-start", ";text-align:", isCenter ? "center" : "left", ";padding:0;.", contentClassname, "{", isCenter ? "align-items: center;" : "", "        padding:16px 0 24px ", isCenter ? "0" : "72px", ";width:", isCenter ? "51%" : "60%", ";position:static;transform:none;}.", imgClassname, "{width:100%;}}@media ", Theme_Responsive_bs/* smallScreenOrMobile */.HH, "{.", contentClassname, "{width:80%;}}@media ", Theme_Responsive_bs/* tabletSm */.FV, "{.", contentClassname, "{padding:20px;width:100%;}}");
    },
    groupTabletBg: function(tabletBreakpoint, contentClassname, isCenter) {
        return /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("@media ", tabletBreakpoint, "{width:100%;.", contentClassname, "{height:100%;padding:0 0 0 ", isCenter ? "0" : "72px", ";left:", isCenter ? "50%" : "0", ";transform:", isCenter ? "translateX(-50%)" : "none", ";width:", isCenter ? "51%" : "60%", ";justify-content:center;}}@media ", Theme_Responsive_bs/* smallScreenOrMobile */.HH, "{.", contentClassname, "{width:80%;}}@media ", Theme_Responsive_bs/* tabletSm */.FV, "{.", contentClassname, "{padding:20px;width:100%;}}");
    },
    rightGroupDesktop: function(isCenter) {
        return /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)(".n2cb-rightContent{position:absolute;top:0;left:50%;bottom:0;width:86%;transform:translateX(-50%);z-index:3;align-items:", isCenter ? "center" : "flex-start", ";justify-content:center;text-align:", isCenter ? "center" : "left", ";}.n2cb-rightImg{width:100%;}");
    },
    leftGroupLeft: function(isFullScreen) {
        return /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("display:flex;align-items:center;justify-content:space-between;.n2cb-leftContent{width:51%;padding:0 0 0 72px;", isFullScreen ? "@media (min-width: 1580px) {\n        padding: 0 0 0 calc(((100% / 0.654285714) - 1380px) / 2);\n        width: 59%;\n      }" : "", "}.n2cb-leftImg{width:39.628821%;}");
    },
    leftGroupLeftBg: function(isFullScreen) {
        return /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)(".n2cb-leftContent{position:absolute;top:0;left:0;right:0;bottom:0;width:58%;padding:0 0 0 72px;z-index:3;justify-content:center;", isFullScreen ? "\n      @media (min-width: 1580px) {\n        padding: 0 0 0 calc(((100% / 0.654285714) - 1380px) / 2);\n        width: 59%;\n      }\n\n      @media (min-width: 2000px) {\n        width: 64%;\n      }\n      " : "", "}.n2cb-leftImg{width:100%;}@media ", Theme_Responsive_bs/* belowLargeScreen */.Qo, "{.n2cb-leftContent{width:68%;}}");
    },
    leftGroupCentre: function(isBg) {
        return /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("padding:", isBg ? "0" : "0 5.1428571%", ";text-align:center;.n2cb-leftContent{position:absolute;top:0;left:50%;transform:translateX(-50%);width:48%;height:100%;z-index:3;align-items:center;justify-content:center;}.n2cb-leftImg{width:100%;}@media ", Theme_Responsive_bs/* belowLargeScreen */.Qo, "{.n2cb-leftContent{width:60%;}}");
    },
    btnContainer: function(tabletBreakpoint) {
        return /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("display:flex;margin:24px 0 0;div:nth-child(2){margin-left:12px;}@media ", tabletBreakpoint, "{margin:'16px 0 0';}");
    }
};
var getTitleClassname = function(param, tabletBreakpoint) {
    var titleFont = param.titleFont, titleFontSize = param.titleFontSize, titleTextColour = param.titleTextColour, highlightTextColour = param.highlightTextColour;
    return (0,emotion_css_esm.cx)(columnBannersShared/* sharedStyles.title */.FG.title(titleTextColour, titleFont, highlightTextColour, tabletBreakpoint), (0,columnBannersShared/* getTitleSize */.Ec)(titleFontSize));
};
var getLeftGroupStyle = function(isLeftStyle, isBackground, isFullScreen) {
    return isLeftStyle ? isBackground ? N2ColumnBanner_style.leftGroupLeftBg(isFullScreen) : N2ColumnBanner_style.leftGroupLeft(isFullScreen) : N2ColumnBanner_style.leftGroupCentre(isBackground);
};
var N2ColumnBanner_getImageSizes = function(isFullscreen, isLeftGroup, isBgImage, tabletBreakpoint) {
    var left = "".concat(tabletBreakpoint, " 100vw, (max-width: 1440px) 24vw, 350px");
    var leftBg = "".concat(tabletBreakpoint, " 100vw, (max-width: 1440px) 62vw, 900px");
    var leftFull = "".concat(tabletBreakpoint, " 100vw, 25vw");
    var leftBgFull = "".concat(tabletBreakpoint, " 100vw, 65vw");
    var right = "".concat(tabletBreakpoint, " 100vw, (max-width: 1440px) 32vw, 462px");
    var rightFull = "".concat(tabletBreakpoint, " 100vw, 33vw");
    var size = "".concat(+isLeftGroup).concat(+isBgImage).concat(+isFullscreen);
    return ({
        "000": left,
        "010": leftBg,
        "001": leftFull,
        "011": leftBgFull,
        "100": right,
        "110": right,
        "101": rightFull,
        "111": rightFull
    })[size];
};
var N2ColumnBanner = function(param) {
    var smartLink = param.smartLink, isFullScreen = param.isFullScreen, isBorderRadius = param.isBorderRadius, leftGroup = param.leftGroup, rightGroup = param.rightGroup;
    var tabletBreakpoint = isFullScreen ? Theme_Responsive_bs/* tabletOrMobile */.k$ : Theme_Responsive_bs/* belowLargeScreen */.Qo;
    var spotlightProps = (0,useSmartLink/* default */.Z)(smartLink);
    var isLeftCenter = leftGroup.copyBlockAlignment === "centre";
    var isLeftBg = leftGroup.imageTreatment === "background";
    var isRightCenter = rightGroup.copyBlockAlignment === "centre";
    var isRightBg = rightGroup.imageTreatment === "background";
    var isHighlightLeft = Regex/* curlyBrackets.test */.vL.test(leftGroup.title) && (0,columnBannersShared/* isSofiaPro */.al)(leftGroup.titleFont);
    var isHighlightRight = Regex/* curlyBrackets.test */.vL.test(rightGroup.title) && (0,columnBannersShared/* isSofiaPro */.al)(rightGroup.titleFont);
    var isRoundedCorners = isBorderRadius && !isFullScreen;
    var isRoundedCornersFullscreen = isBorderRadius && isFullScreen;
    var leftGroupStyle = getLeftGroupStyle(!isLeftCenter, isLeftBg, isFullScreen);
    var leftGroupTablet = isLeftBg ? N2ColumnBanner_style.groupTabletBg(tabletBreakpoint, "n2cb-leftContent", isLeftCenter) : N2ColumnBanner_style.groupTablet(tabletBreakpoint, "n2cb-leftContent", "n2cb-leftImg", isLeftCenter);
    var rightGroupTablet = isRightBg ? N2ColumnBanner_style.groupTabletBg(tabletBreakpoint, "n2cb-rightContent", isRightCenter) : N2ColumnBanner_style.groupTablet(tabletBreakpoint, "n2cb-rightContent", "n2cb-rightImg", isRightCenter);
    var rightGroupStyle = N2ColumnBanner_style.rightGroupDesktop(isLeftCenter);
    var leftImgSizes = N2ColumnBanner_getImageSizes(isFullScreen, true, isLeftBg, tabletBreakpoint);
    var rightImgSizes = N2ColumnBanner_getImageSizes(isFullScreen, false, isRightBg, tabletBreakpoint);
    var leftDescriptionSizes = (0,columnBannersShared/* getDescriptionStyles */.UE)(leftGroup.descriptionFontSize);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: N2ColumnBanner_style.container(tabletBreakpoint)
    }, spotlightProps), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                className: (0,emotion_css_esm.cx)(N2ColumnBanner_style.leftGroup(leftGroup.bgColour, isRoundedCorners, isRoundedCornersFullscreen, tabletBreakpoint), leftGroupStyle, leftGroupTablet),
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                        className: "n2cb-leftContent",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("h1", {
                                className: getTitleClassname(leftGroup, tabletBreakpoint),
                                dangerouslySetInnerHTML: {
                                    __html: isHighlightLeft ? (0,columnBannersShared/* hightlightTitleAsString */.Fb)(leftGroup.title) : leftGroup.title
                                }
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                                className: leftDescriptionSizes(leftGroup.descriptionTextColour, tabletBreakpoint),
                                dangerouslySetInnerHTML: {
                                    __html: leftGroup.description
                                }
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                                className: N2ColumnBanner_style.btnContainer(tabletBreakpoint),
                                children: leftGroup.buttons.map(function(param) {
                                    var cta_text = param.cta_text, cta_url = param.cta_url, variant = param.variant, colour = param.colour, fill = param.fill, smartLink = param.smartLink;
                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Button_bs.make, {
                                        variant: variant,
                                        colour: colour,
                                        fill: fill,
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)((link_default()), {
                                            href: cta_url,
                                            passHref: true,
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("a", {
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("button", {
                                                    children: cta_text
                                                })
                                            })
                                        })
                                    }, smartLink.codename);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                        className: "n2cb-leftImg",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(CmsImage/* default */.Z, {
                                src: leftGroup.imageDesktop.url,
                                width: leftGroup.imageDesktop.width,
                                height: leftGroup.imageDesktop.height,
                                alt: leftGroup.imageDesktop.description,
                                sizes: leftImgSizes,
                                className: columnBannersShared/* sharedStyles.imageDesktop */.FG.imageDesktop(tabletBreakpoint),
                                loading: "eager"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(CmsImage/* default */.Z, {
                                src: leftGroup.imageTablet.url,
                                width: leftGroup.imageTablet.width,
                                height: leftGroup.imageTablet.height,
                                alt: leftGroup.imageTablet.description,
                                sizes: leftImgSizes,
                                className: columnBannersShared/* sharedStyles.imageTablet */.FG.imageTablet(tabletBreakpoint),
                                loading: "eager"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(CmsImage/* default */.Z, {
                                src: leftGroup.imageMobile.url,
                                width: leftGroup.imageMobile.width,
                                height: leftGroup.imageMobile.height,
                                alt: leftGroup.imageMobile.description,
                                sizes: leftImgSizes,
                                className: columnBannersShared/* sharedStyles.imageMobile */.FG.imageMobile,
                                loading: "eager"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                className: (0,emotion_css_esm.cx)(N2ColumnBanner_style.rightGroup(rightGroup.bgColour, isRoundedCorners, isRoundedCornersFullscreen, tabletBreakpoint), rightGroupStyle, rightGroupTablet),
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                        className: "n2cb-rightContent",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("h2", {
                                className: getTitleClassname(rightGroup, tabletBreakpoint),
                                dangerouslySetInnerHTML: {
                                    __html: isHighlightRight ? (0,columnBannersShared/* hightlightTitleAsString */.Fb)(rightGroup.title) : rightGroup.title
                                }
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                                className: columnBannersShared/* sharedStyles.description */.FG.description(rightGroup.descriptionTextColour, tabletBreakpoint),
                                dangerouslySetInnerHTML: {
                                    __html: rightGroup.description
                                }
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                                className: N2ColumnBanner_style.btnContainer(tabletBreakpoint),
                                children: rightGroup.buttons.map(function(param) {
                                    var cta_text = param.cta_text, cta_url = param.cta_url, variant = param.variant, colour = param.colour, fill = param.fill, smartLink = param.smartLink;
                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Button_bs.make, {
                                        variant: variant,
                                        colour: colour,
                                        fill: fill,
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)((link_default()), {
                                            href: cta_url,
                                            passHref: true,
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("a", {
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("button", {
                                                    children: cta_text
                                                })
                                            })
                                        })
                                    }, smartLink.codename);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                        className: "n2cb-rightImg",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(CmsImage/* default */.Z, {
                                src: rightGroup.imageDesktop.url,
                                width: rightGroup.imageDesktop.width,
                                height: rightGroup.imageDesktop.height,
                                alt: rightGroup.imageDesktop.description,
                                sizes: rightImgSizes,
                                className: columnBannersShared/* sharedStyles.imageDesktop */.FG.imageDesktop(tabletBreakpoint),
                                loading: "eager"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(CmsImage/* default */.Z, {
                                src: rightGroup.imageTablet.url,
                                width: rightGroup.imageTablet.width,
                                height: rightGroup.imageTablet.height,
                                alt: rightGroup.imageTablet.description,
                                sizes: rightImgSizes,
                                className: columnBannersShared/* sharedStyles.imageTablet */.FG.imageTablet(tabletBreakpoint),
                                loading: "eager"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(CmsImage/* default */.Z, {
                                src: rightGroup.imageMobile.url,
                                width: rightGroup.imageMobile.width,
                                height: rightGroup.imageMobile.height,
                                alt: rightGroup.imageMobile.description,
                                sizes: rightImgSizes,
                                className: columnBannersShared/* sharedStyles.imageMobile */.FG.imageMobile,
                                loading: "eager"
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var heroBanner_N2ColumnBanner = (N2ColumnBanner);

// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon-ui/lib/hooks/useDisclosure.js
var useDisclosure = __webpack_require__(18500);
// EXTERNAL MODULE: ./src/components/pages/store/zag/ZagExplanationModal.tsx + 1 modules
var ZagExplanationModal = __webpack_require__(78056);
;// CONCATENATED MODULE: ./src/components/heroBanner/HeroBannerBlock.tsx


















var RemoteHeroBanner = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 2030).then(__webpack_require__.bind(__webpack_require__, 82030));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(82030)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("span", {});
    },
    ssr: false
});
var HeroBannerBlock_style = {
    wrapper: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("width:100%;"),
    pagination: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("display:flex;justify-content:center;padding:11px 20px;height:18px;box-sizing:content-box;.bullet{width:18px;height:18px;margin-right:2px;cursor:pointer;position:relative;&:last-child{margin-right:0;}&::after{content:'';display:block;width:8px;height:8px;border-radius:50%;background-color:", colors["default"].purple[100], ";position:absolute;top:5px;left:5px;}}.bullet_active{&::after{background-color:", colors["default"].purple[400], ";}}")
};
var styleGlobal = {
    overlayFullwidth: "\n  .search-bar + .hero-banner {\n    margin-top: -72px;\n  }\n",
    overlayBoxed: "\n  .search-bar > div {\n    margin-left: 12px;\n    margin-right: 12px;\n  }\n  .search-bar + .hero-banner {\n    margin-top: -72px;\n  }\n",
    onlyTablet: function(tabletBreakpoint, styles) {
        return "\n  @media ".concat(tabletBreakpoint, " {\n    ").concat(styles, "\n  }\n");
    }
};
var HeroBanner = function(param) {
    var layerEnabled = param.layerEnabled, block = param.block, _block = param.block, smartLink = _block.smartLink, width = _block.width, isSearchBarOverlay = _block.isSearchBarOverlay, n1ColumnBanners = _block.n1ColumnBanners, n2ColumnBanner = _block.n2ColumnBanner, isBorderRadius = _block.isBorderRadius;
    var isOneColumn = !!n1ColumnBanners.length;
    var isSlider = n1ColumnBanners.length > 1;
    var isFullWidth = width === "full_width";
    var spotlightProps = (0,useSmartLink/* default */.Z)(smartLink);
    var tabletBreakpoint = isFullWidth ? Theme_Responsive_bs/* tabletOrMobile */.k$ : Theme_Responsive_bs/* belowLargeScreen */.Qo;
    var overlayStyles = isFullWidth ? styleGlobal.overlayFullwidth : styleGlobal.overlayBoxed;
    var router = (0,next_router.useRouter)();
    var zagExplanationModal = (0,useDisclosure/* default */.Z)();
    var onClickBannerCta = function(btn) {
        switch(btn.cta_url){
            case "#modal_prezzee-plus-explanation":
                {
                    zagExplanationModal.onOpen();
                    break;
                }
            default:
                {
                    router.push(btn.cta_url);
                }
        }
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("section", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: (0,emotion_css_esm.cx)(HeroBannerBlock_style.wrapper, !isFullWidth && IndexStyles_bs/* fullWidthSection */.wt, "hero-banner")
    }, spotlightProps), {
        children: [
            isSearchBarOverlay && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("style", {
                    children: isOneColumn ? overlayStyles : styleGlobal.onlyTablet(tabletBreakpoint, overlayStyles)
                })
            }),
            isOneColumn && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(emotion_react_jsx_runtime_browser_esm.Fragment, {
                children: [
                    isSlider ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(swiper_react/* Swiper */.tq, {
                        // Ignoring due to these issue with type exports
                        //  - https://github.com/nolimits4web/swiper/issues/6843 & https://github.com/nolimits4web/swiper/issues/6885
                        // @ts-ignore
                        slidesPerView: 1,
                        modules: [
                            modules/* Pagination */.tl,
                            modules/* Autoplay */.pt
                        ],
                        maxBackfaceHiddenSlides: 0,
                        // delay with 24h to prevent autoplay on mobile, setting autoplay to false disable enabling it on breakpoints
                        autoplay: {
                            delay: 24 * 60 * 60 * 1000
                        },
                        pagination: {
                            clickable: true,
                            el: ".hero-banner__pagination",
                            bulletClass: "bullet",
                            bulletActiveClass: "bullet_active"
                        },
                        autoHeight: true,
                        breakpoints: (0,_define_property/* default */.Z)({}, isFullWidth ? 1024 : 1288, {
                            autoplay: {
                                delay: 10000,
                                pauseOnMouseEnter: true,
                                disableOnInteraction: false
                            }
                        }),
                        children: n1ColumnBanners.map(function(columnProps, index) {
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(swiper_react/* SwiperSlide */.o5, {
                                children: layerEnabled ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(emotion_react_jsx_runtime_browser_esm.Fragment, {
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(RemoteHeroBanner, {
                                        data: block,
                                        onClickBannerCta: onClickBannerCta,
                                        carouselIndex: index
                                    })
                                }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(heroBanner_N1ColumnBanner, (0,_object_spread/* default */.Z)({
                                    isFullScreen: isFullWidth,
                                    isBorderRadius: isBorderRadius
                                }, columnProps))
                            }, columnProps.smartLink.codename);
                        })
                    }) : layerEnabled ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(emotion_react_jsx_runtime_browser_esm.Fragment, {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(RemoteHeroBanner, {
                            data: block,
                            onClickBannerCta: onClickBannerCta
                        })
                    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(heroBanner_N1ColumnBanner, (0,_object_spread/* default */.Z)({
                        isFullScreen: isFullWidth,
                        isBorderRadius: isBorderRadius
                    }, n1ColumnBanners[0])),
                    isSlider ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                        className: (0,emotion_css_esm.cx)("hero-banner__pagination", HeroBannerBlock_style.pagination)
                    }) : null
                ]
            }),
            n2ColumnBanner && (layerEnabled ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(emotion_react_jsx_runtime_browser_esm.Fragment, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(RemoteHeroBanner, {
                    data: block,
                    onClickBannerCta: onClickBannerCta
                })
            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(heroBanner_N2ColumnBanner, (0,_object_spread/* default */.Z)({
                isFullScreen: isFullWidth,
                isBorderRadius: isBorderRadius
            }, n2ColumnBanner))),
            layerEnabled && zagExplanationModal.isOpen && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(ZagExplanationModal/* default */.Z, {
                onClose: zagExplanationModal.onClose
            })
        ]
    }));
};
/* harmony default export */ var HeroBannerBlock = (HeroBanner);

// EXTERNAL MODULE: ./src/api/graphql/CmsData.bs.js + 212 modules
var CmsData_bs = __webpack_require__(607);
// EXTERNAL MODULE: ./src/api/queries/modifyBlocks.ts
var queries_modifyBlocks = __webpack_require__(23328);
// EXTERNAL MODULE: ./src/common/util.bs.js
var util_bs = __webpack_require__(7667);
// EXTERNAL MODULE: ./src/common/utils/react.tsx
var utils_react = __webpack_require__(4331);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon-ui/lib/components/Button/index.js
var components_Button = __webpack_require__(43515);
;// CONCATENATED MODULE: ./src/components/library/NarrowCtaSection.tsx










var getBgImage = function(url) {
    return url !== "" ? "url(".concat(url, "?fm=png&auto=format)") : "none";
};
var NarrowCtaSection_style = {
    container: function(bgColor, bgDesktop, bgTablet, bgMobile) {
        return /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("padding:118px 20px 100px;text-align:center;display:flex;flex-direction:column;align-items:center;justify-content:center;background-color:", bgColor, ";background-image:", getBgImage(bgDesktop), ";background-position:center center;background-size:cover;background-repeat:no-repeat;@media (max-width:", breakpoints["default"].lg, "){background-image:", getBgImage(bgTablet), ";}@media ", Theme_Responsive_bs/* tabletSm */.FV, "{background-image:", getBgImage(bgMobile), ";padding:60px 20px 50px;}");
    },
    button: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("margin-top:35px;")
};
var NarrowCTASection = function(param) {
    var _block = param.block, title = _block.title, backgroundColour = _block.backgroundColour, bgImageDesktop = _block.bgImageDesktop, bgImageTablet = _block.bgImageTablet, bgImageMobile = _block.bgImageMobile, cta = _block.cta, smartLink = _block.smartLink;
    var spotlightProps = (0,useSmartLink/* default */.Z)(smartLink);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("section", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: NarrowCtaSection_style.container(backgroundColour, bgImageDesktop.url, bgImageTablet.url, bgImageMobile.url)
    }, spotlightProps), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Typography["default"], {
                variant: "h2",
                children: title
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)((link_default()), {
                href: cta.cta_url,
                passHref: true,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(components_Button["default"], {
                    variant: "secondary",
                    paddingY: "13px",
                    paddingX: "36px",
                    height: "auto",
                    className: NarrowCtaSection_style.button,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("a", {
                        children: cta.cta_text
                    })
                })
            })
        ]
    }));
};
/* harmony default export */ var NarrowCtaSection = (NarrowCTASection);

// EXTERNAL MODULE: ./src/common/constants.ts
var constants = __webpack_require__(50132);
;// CONCATENATED MODULE: ./src/common/basicContent.tsx










































var ContentBlockName;
(function(ContentBlockName) {
    ContentBlockName["EnrichedTextBlock"] = "EnrichedTextBlock";
    ContentBlockName["IconCardBlock"] = "IconCardBlock";
    ContentBlockName["InnovativeWayToGiftBlock"] = "InnovativeWayToGiftBlock";
    ContentBlockName["CategoryTileBlock"] = "CategoryTileBlock";
    ContentBlockName["GiftExperienceBlock"] = "GiftExperienceBlock";
    ContentBlockName["UniqueSellingPointsBlock"] = "UniqueSellingPointsBlock";
    ContentBlockName["FAQBlock"] = "FAQBlock";
    ContentBlockName["FullWidthTextBlock"] = "FullWidthTextBlock";
    ContentBlockName["NarrowBannerFull"] = "NarrowBannerFull";
    ContentBlockName["DownloadAppsBlock"] = "DownloadAppsBlock";
    ContentBlockName["NewsletterBlock"] = "NewsletterBlock";
    ContentBlockName["HeroTileBlock"] = "HeroTileBlock";
    ContentBlockName["PromoTileBlock"] = "PromoTileBlock";
    ContentBlockName["StatsTilesBlock"] = "StatsTilesBlock";
    ContentBlockName["VideoTextPromoBlock"] = "VideoTextPromoBlock";
    ContentBlockName["TeamMembersBlock"] = "TeamMembersBlock";
    ContentBlockName["FullWidthHeroBannerBlock"] = "FullWidthHeroBannerBlock";
    ContentBlockName["AutomateSimplifyBlock"] = "AutomateSimplifyBlock";
    ContentBlockName["TestimonialCarouselBlock"] = "TestimonialCarouselBlock";
    ContentBlockName["BusinessContactFormBlock"] = "BusinessContactFormBlock";
    ContentBlockName["OffsetTilesBlock"] = "OffsetTilesBlock";
    ContentBlockName["TrustpilotWidgetBlock"] = "TrustpilotWidgetBlock";
    ContentBlockName["SkuCarouselBlock"] = "SkuCarouselBlock";
    ContentBlockName["BoardOfDirectorsBlock"] = "BoardOfDirectorsBlock";
    ContentBlockName["ProductHeroBlock"] = "ProductHeroBlock";
    ContentBlockName["SellingPointsBlock"] = "SellingPointsBlock";
    ContentBlockName["NarrowCta"] = "NarrowCta";
    ContentBlockName["HeroBanner"] = "HeroBanner";
})(ContentBlockName || (ContentBlockName = {}));
var ContentLayout;
(function(ContentLayout) {
    ContentLayout["Classic"] = "classic";
    ContentLayout["Business"] = "business";
})(ContentLayout || (ContentLayout = {}));
var _obj;
/**
 * Content block component mapper
 */ var BasicContent = (_obj = {}, (0,_define_property/* default */.Z)(_obj, ContentBlockName.EnrichedTextBlock, function(layout) {
    return function(block, key) {
        var _obj;
        return (_obj = {}, (0,_define_property/* default */.Z)(_obj, ContentLayout.Classic, /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(EnrichedTextSection_bs/* make */.Sy, {
            block: block.VAL
        }, key)), (0,_define_property/* default */.Z)(_obj, ContentLayout.Business, /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(EnrichedTextSection_bs/* make */.Sy, {
            block: block.VAL
        }, key)), _obj)[layout];
    };
}), (0,_define_property/* default */.Z)(_obj, ContentBlockName.IconCardBlock, function(layout) {
    return function(block, key) {
        var _obj;
        return (_obj = {}, (0,_define_property/* default */.Z)(_obj, ContentLayout.Classic, /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(business_IconCardBlockSection, {
            block: block.VAL
        }, key)), (0,_define_property/* default */.Z)(_obj, ContentLayout.Business, /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(business_IconCardBlockSection, {
            block: block.VAL
        }, key)), _obj)[layout];
    };
}), (0,_define_property/* default */.Z)(_obj, ContentBlockName.InnovativeWayToGiftBlock, function(layout) {
    return function(block, key) {
        var _obj;
        return (_obj = {}, (0,_define_property/* default */.Z)(_obj, ContentLayout.Classic, utils_react/* EMPTY_ELEMENT */.O), (0,_define_property/* default */.Z)(_obj, ContentLayout.Business, /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(make, {
            block: block.VAL
        }, key)), _obj)[layout];
    };
}), (0,_define_property/* default */.Z)(_obj, ContentBlockName.CategoryTileBlock, function(layout) {
    return function(block, key) {
        var _obj;
        return (_obj = {}, (0,_define_property/* default */.Z)(_obj, ContentLayout.Classic, /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(CategoryTilesSection/* default */.Z, {
            block: block.VAL
        }, key)), (0,_define_property/* default */.Z)(_obj, ContentLayout.Business, /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(CategoryTilesSection/* default */.Z, {
            block: block.VAL
        }, key)), _obj)[layout];
    };
}), (0,_define_property/* default */.Z)(_obj, ContentBlockName.GiftExperienceBlock, function(layout) {
    return function(block, key) {
        var _obj;
        return (_obj = {}, (0,_define_property/* default */.Z)(_obj, ContentLayout.Classic, utils_react/* EMPTY_ELEMENT */.O), (0,_define_property/* default */.Z)(_obj, ContentLayout.Business, /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(GiftExperienceSection_bs_make, {
            block: block.VAL
        }, key)), _obj)[layout];
    };
}), (0,_define_property/* default */.Z)(_obj, ContentBlockName.UniqueSellingPointsBlock, function(layout) {
    return function(block, key) {
        var _obj;
        return (_obj = {}, (0,_define_property/* default */.Z)(_obj, ContentLayout.Classic, /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(UniqueSellingPointsSection_bs/* make */.Sy, {
            block: block.VAL
        }, key)), (0,_define_property/* default */.Z)(_obj, ContentLayout.Business, /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(UniqueSellingPointsSection_bs/* make */.Sy, {
            block: block.VAL
        }, key)), _obj)[layout];
    };
}), (0,_define_property/* default */.Z)(_obj, ContentBlockName.FAQBlock, function(layout) {
    return function(block, key) {
        var _obj;
        return (_obj = {}, (0,_define_property/* default */.Z)(_obj, ContentLayout.Classic, /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(FAQSection_bs/* make */.Sy, {
            block: block.VAL
        }, key)), (0,_define_property/* default */.Z)(_obj, ContentLayout.Business, /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(FAQSection_bs/* make */.Sy, {
            block: block.VAL
        }, key)), _obj)[layout];
    };
}), (0,_define_property/* default */.Z)(_obj, ContentBlockName.FullWidthTextBlock, function(layout) {
    return function(block, key) {
        var _obj;
        return (_obj = {}, (0,_define_property/* default */.Z)(_obj, ContentLayout.Classic, /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(FullWidthTextSection_bs/* make */.Sy, {
            block: block.VAL
        }, key)), (0,_define_property/* default */.Z)(_obj, ContentLayout.Business, /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(FullWidthTextSection_bs/* make */.Sy, {
            block: block.VAL
        }, key)), _obj)[layout];
    };
}), (0,_define_property/* default */.Z)(_obj, ContentBlockName.NarrowBannerFull, function(layout) {
    return function(block, key) {
        var _obj;
        return (_obj = {}, (0,_define_property/* default */.Z)(_obj, ContentLayout.Classic, /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(NarrowBannerFull, {
            block: block.VAL
        }, key)), (0,_define_property/* default */.Z)(_obj, ContentLayout.Business, /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(NarrowBannerFull, {
            block: block.VAL
        }, key)), _obj)[layout];
    };
}), (0,_define_property/* default */.Z)(_obj, ContentBlockName.DownloadAppsBlock, function(layout) {
    return function(block, key) {
        var _obj;
        return (_obj = {}, (0,_define_property/* default */.Z)(_obj, ContentLayout.Classic, /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(DownloadAppsSection_bs/* make */.Sy, {
            block: block.VAL
        }, key)), (0,_define_property/* default */.Z)(_obj, ContentLayout.Business, /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(DownloadAppsSection_bs/* make */.Sy, {
            block: block.VAL
        }, key)), _obj)[layout];
    };
}), (0,_define_property/* default */.Z)(_obj, ContentBlockName.NewsletterBlock, function(layout) {
    return function(block, key) {
        var _obj;
        return (_obj = {}, (0,_define_property/* default */.Z)(_obj, ContentLayout.Classic, /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(NewsletterSection_bs/* make */.Sy, {
            block: block.VAL
        }, key)), (0,_define_property/* default */.Z)(_obj, ContentLayout.Business, /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(NewsletterSection_bs/* make */.Sy, {
            block: block.VAL,
            store: "business"
        }, key)), _obj)[layout];
    };
}), (0,_define_property/* default */.Z)(_obj, ContentBlockName.HeroTileBlock, function(layout) {
    return function(block, key) {
        var _obj;
        return (_obj = {}, (0,_define_property/* default */.Z)(_obj, ContentLayout.Classic, /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(HeroTileSection_bs/* make */.Sy, {
            block: block.VAL
        }, key)), (0,_define_property/* default */.Z)(_obj, ContentLayout.Business, /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(HeroTileSection_bs/* make */.Sy, {
            block: block.VAL
        }, key)), _obj)[layout];
    };
}), (0,_define_property/* default */.Z)(_obj, ContentBlockName.PromoTileBlock, function(layout) {
    return function(block, key) {
        var _obj;
        return (_obj = {}, (0,_define_property/* default */.Z)(_obj, ContentLayout.Classic, /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(PromoSection_bs/* make */.Sy, {
            block: block.VAL
        }, key)), (0,_define_property/* default */.Z)(_obj, ContentLayout.Business, /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(PromoSection_bs/* make */.Sy, {
            block: block.VAL
        }, key)), _obj)[layout];
    };
}), (0,_define_property/* default */.Z)(_obj, ContentBlockName.StatsTilesBlock, function(layout) {
    return function(block, key) {
        var _obj;
        return (_obj = {}, (0,_define_property/* default */.Z)(_obj, ContentLayout.Classic, /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(StatsTilesSection_bs/* make */.Sy, {
            block: block.VAL
        }, key)), (0,_define_property/* default */.Z)(_obj, ContentLayout.Business, /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(StatsTilesSection_bs/* make */.Sy, {
            block: block.VAL
        }, key)), _obj)[layout];
    };
}), (0,_define_property/* default */.Z)(_obj, ContentBlockName.VideoTextPromoBlock, function(layout) {
    return function(block, key) {
        var _obj;
        return (_obj = {}, (0,_define_property/* default */.Z)(_obj, ContentLayout.Classic, /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(VideoTextPromoSection_bs/* make */.Sy, {
            block: block.VAL
        }, key)), (0,_define_property/* default */.Z)(_obj, ContentLayout.Business, /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(VideoTextPromoSection_bs/* make */.Sy, {
            block: block.VAL
        }, key)), _obj)[layout];
    };
}), (0,_define_property/* default */.Z)(_obj, ContentBlockName.TeamMembersBlock, function(layout) {
    return function(block, key) {
        var _obj;
        return (_obj = {}, (0,_define_property/* default */.Z)(_obj, ContentLayout.Classic, /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(MeetTheTeam_bs/* make */.Sy, {
            block: block.VAL
        }, key)), (0,_define_property/* default */.Z)(_obj, ContentLayout.Business, /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(MeetTheTeam_bs/* make */.Sy, {
            block: block.VAL
        }, key)), _obj)[layout];
    };
}), (0,_define_property/* default */.Z)(_obj, ContentBlockName.AutomateSimplifyBlock, function(layout) {
    return function(block, key) {
        var _obj;
        return (_obj = {}, (0,_define_property/* default */.Z)(_obj, ContentLayout.Classic, utils_react/* EMPTY_ELEMENT */.O), (0,_define_property/* default */.Z)(_obj, ContentLayout.Business, /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(AutomateSimplifySection_bs_make, {
            block: block.VAL
        }, key)), _obj)[layout];
    };
}), (0,_define_property/* default */.Z)(_obj, ContentBlockName.FullWidthHeroBannerBlock, function(layout) {
    return function(block, key) {
        var _obj;
        return (_obj = {}, (0,_define_property/* default */.Z)(_obj, ContentLayout.Classic, /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(LandingPage_FullWidthHero_bs/* make */.Sy, {
            block: block.VAL
        }, key)), (0,_define_property/* default */.Z)(_obj, ContentLayout.Business, /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(BusinessFullWidthHeroSection_bs_make, {
            block: block.VAL
        }, key)), _obj)[layout];
    };
}), (0,_define_property/* default */.Z)(_obj, ContentBlockName.TestimonialCarouselBlock, function(layout) {
    return function(block, key) {
        var _obj;
        return (_obj = {}, (0,_define_property/* default */.Z)(_obj, ContentLayout.Classic, utils_react/* EMPTY_ELEMENT */.O), (0,_define_property/* default */.Z)(_obj, ContentLayout.Business, /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(TestimonialCarouselSection_bs_make, {
            block: block.VAL
        }, key)), _obj)[layout];
    };
}), (0,_define_property/* default */.Z)(_obj, ContentBlockName.BusinessContactFormBlock, function(layout) {
    return function(block, key) {
        var _obj;
        return (_obj = {}, (0,_define_property/* default */.Z)(_obj, ContentLayout.Classic, utils_react/* EMPTY_ELEMENT */.O), (0,_define_property/* default */.Z)(_obj, ContentLayout.Business, /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(BusinessContactFormSection_bs_make, {
            block: block.VAL
        }, key)), _obj)[layout];
    };
}), (0,_define_property/* default */.Z)(_obj, ContentBlockName.OffsetTilesBlock, function(layout) {
    return function(block, key) {
        var _obj;
        return (_obj = {}, (0,_define_property/* default */.Z)(_obj, ContentLayout.Classic, utils_react/* EMPTY_ELEMENT */.O), (0,_define_property/* default */.Z)(_obj, ContentLayout.Business, /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(WeveGotALotToBeProudAbout_bs_make, {
            block: block.VAL
        }, key)), _obj)[layout];
    };
}), (0,_define_property/* default */.Z)(_obj, ContentBlockName.TrustpilotWidgetBlock, function(layout) {
    return function(block, key) {
        var _obj;
        return (_obj = {}, (0,_define_property/* default */.Z)(_obj, ContentLayout.Classic, /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(TrustpilotWidgetSection_bs/* make */.S, {
            block: block.VAL
        }, key)), (0,_define_property/* default */.Z)(_obj, ContentLayout.Business, /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(TrustpilotWidgetSection_bs/* make */.S, {
            block: block.VAL
        }, key)), _obj)[layout];
    };
}), (0,_define_property/* default */.Z)(_obj, ContentBlockName.BoardOfDirectorsBlock, function(layout) {
    return function(block, key) {
        var _obj;
        return (_obj = {}, (0,_define_property/* default */.Z)(_obj, ContentLayout.Classic, /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(BoardOfDirectorsSection_bs/* make */.Sy, {
            block: block.VAL
        }, key)), (0,_define_property/* default */.Z)(_obj, ContentLayout.Business, utils_react/* EMPTY_ELEMENT */.O), _obj)[layout];
    };
}), (0,_define_property/* default */.Z)(_obj, ContentBlockName.SkuCarouselBlock, function(layout, extraProps) {
    return function(block, key) {
        var _obj;
        return (_obj = {}, (0,_define_property/* default */.Z)(_obj, ContentLayout.Classic, /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(ShopBySkuSection_bs_make, (0,_object_spread/* default */.Z)({
            block: block.VAL
        }, extraProps === null || extraProps === void 0 ? void 0 : extraProps.props), key)), (0,_define_property/* default */.Z)(_obj, ContentLayout.Business, /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(ShopBySkuSection_bs_make, (0,_object_spread/* default */.Z)({
            block: block.VAL
        }, extraProps === null || extraProps === void 0 ? void 0 : extraProps.props), key)), _obj)[layout];
    };
}), (0,_define_property/* default */.Z)(_obj, ContentBlockName.ProductHeroBlock, function(layout) {
    return function(block, key) {
        var _obj;
        return (_obj = {}, (0,_define_property/* default */.Z)(_obj, ContentLayout.Classic, /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(library_ProductHeroSection, {
            block: block.VAL
        }, key)), (0,_define_property/* default */.Z)(_obj, ContentLayout.Business, utils_react/* EMPTY_ELEMENT */.O), _obj)[layout];
    };
}), (0,_define_property/* default */.Z)(_obj, ContentBlockName.SellingPointsBlock, function(layout) {
    return function(block, key) {
        var _obj;
        return (_obj = {}, (0,_define_property/* default */.Z)(_obj, ContentLayout.Classic, /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(library_SellingPointsSection, {
            block: block.VAL
        }, key)), (0,_define_property/* default */.Z)(_obj, ContentLayout.Business, utils_react/* EMPTY_ELEMENT */.O), _obj)[layout];
    };
}), (0,_define_property/* default */.Z)(_obj, ContentBlockName.NarrowCta, function(layout) {
    return function(block, key) {
        var _obj;
        return (_obj = {}, (0,_define_property/* default */.Z)(_obj, ContentLayout.Classic, /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(NarrowCtaSection, {
            block: block.VAL
        }, key)), (0,_define_property/* default */.Z)(_obj, ContentLayout.Business, utils_react/* EMPTY_ELEMENT */.O), _obj)[layout];
    };
}), (0,_define_property/* default */.Z)(_obj, ContentBlockName.HeroBanner, function(layout) {
    return function(block, key, flags) {
        var _obj;
        return (_obj = {}, (0,_define_property/* default */.Z)(_obj, ContentLayout.Classic, /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(HeroBannerBlock, {
            block: block.VAL,
            layerEnabled: flags === null || flags === void 0 ? void 0 : flags.layerEnabled
        }, key)), (0,_define_property/* default */.Z)(_obj, ContentLayout.Business, /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(HeroBannerBlock, {
            block: block.VAL
        }, key)), _obj)[layout];
    };
}), _obj);
/**
 * Parses the Page's Seo Meta block
 * @param content
 */ function parseSeoMetadata(content) {
    var ref;
    var meta = (ref = JSON.parse(content).seo_meta) === null || ref === void 0 ? void 0 : ref.VAL;
    return meta ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(SeoMeta/* default */.Z, {
        meta: meta
    }) : utils_react/* EMPTY_ELEMENT */.O;
}
/**
 * Parses the Page Content blocks CMS value
 * @param content
 * @param layout
 * @param extraProps
 */ function parseBasicPageContent(content) {
    var layout = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ContentLayout.Classic, extraProps = arguments.length > 2 ? arguments[2] : void 0, flags = arguments.length > 3 ? arguments[3] : void 0;
    return content.length > 0 ? JSON.parse(content).content_blocks.map(function(block, key) {
        return BasicContent[block.NAME](layout, extraProps && extraProps[block.NAME])(block, key, flags);
    }) : [
        utils_react/* EMPTY_ELEMENT */.O
    ];
}
/**
 * Returns the basic page content
 * @param context
 * @param baseRoute
 */ function getBasicPageContentServerProps(context, baseRoute, isPid) {
    return _getBasicPageContentServerProps.apply(this, arguments);
}
function _getBasicPageContentServerProps() {
    _getBasicPageContentServerProps = _async_to_generator(function(context, baseRoute, isPid) {
        var ref, ref1, ref2, language, isPreview, slug, slugParam, url, content, _tmp, _tmp1, error;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        3,
                        ,
                        4
                    ]);
                    language = EnvUtil.getCmsLanguage();
                    isPreview = !!((ref = context.query) === null || ref === void 0 ? void 0 : ref.preview);
                    slug = isPid ? (ref1 = context.query) === null || ref1 === void 0 ? void 0 : ref1.pid : (ref2 = context.query) === null || ref2 === void 0 ? void 0 : ref2.slug;
                    slugParam = slug && "".concat(typeof slug === "string" ? slug : slug.join("/"), "/");
                    url = "/".concat(baseRoute, "/").concat(slugParam || "");
                    return [
                        4,
                        getPageContent(language, isPreview, url)
                    ];
                case 1:
                    content = _state.sent();
                    if (!isPreview) {
                        context.res.setHeader("Cache-Control", SSR_PAGE_CACHE);
                    }
                    _tmp = {};
                    _tmp1 = {};
                    return [
                        4,
                        modifyBlocks(JSON.stringify(content.content), isPreview, language)
                    ];
                case 2:
                    return [
                        2,
                        (_tmp.props = (_tmp1.content = _state.sent(), _tmp1), _tmp)
                    ];
                case 3:
                    error = _state.sent();
                    logger.error({
                        err: error,
                        journey: "Page Content",
                        source: "CMS"
                    }, "error: Failed to fetch ".concat(baseRoute, " page data"));
                    // 404 Not Found page redirect for non-existing basic content pages
                    context.res.setHeader("location", "/404/");
                    context.res.setHeader("Cache-Control", NO_CACHE);
                    context.res.statusCode = 404;
                    context.res.end();
                    return [
                        2,
                        {
                            redirect: {
                                permanent: false,
                                destination: "/404"
                            }
                        }
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return _getBasicPageContentServerProps.apply(this, arguments);
}


/***/ }),

/***/ 62001:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BN": function() { return /* binding */ getFontFamily; },
/* harmony export */   "Ec": function() { return /* binding */ getTitleSize; },
/* harmony export */   "FG": function() { return /* binding */ sharedStyles; },
/* harmony export */   "Fb": function() { return /* binding */ hightlightTitleAsString; },
/* harmony export */   "UE": function() { return /* binding */ getDescriptionStyles; },
/* harmony export */   "al": function() { return /* binding */ isSofiaPro; }
/* harmony export */ });
/* unused harmony exports isDmSerif, highligtTitle */
/* harmony import */ var _emotion_css__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97133);
/* harmony import */ var _prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70965);



var Fonts;
(function(Fonts) {
    Fonts["sofia_pro"] = "sofia-pro, sans-serif";
    Fonts["dm_serif"] = "DM Serif Display, sans-serif";
})(Fonts || (Fonts = {}));
var getFontFamily = function(codename) {
    return Fonts[codename];
};
var isSofiaPro = function(codename) {
    return codename === "sofia_pro";
};
var isDmSerif = function(codename) {
    return codename === "dm_serif";
};
var sharedStyles = {
    container: function(bgColour) {
        return /*#__PURE__*/ (0,_emotion_css__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)("display:flex;position:relative;background-color:", bgColour, ";");
    },
    title: function(colour, fontFamily, highlighedColour, tabletBreakpoint) {
        return /*#__PURE__*/ (0,_emotion_css__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)("color:", colour, ";font-family:", getFontFamily(fontFamily), ";font-weight:", isDmSerif(fontFamily) ? 400 : 600, ";span{font-family:", Fonts.dm_serif, ";font-style:italic;color:", highlighedColour, ";font-weight:400;}br{&.desktop{@media ", tabletBreakpoint, "{display:none;}}&.tablet{display:none;@media ", tabletBreakpoint, "{display:inline;}@media ", _prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .tabletSm */ .FV, "{display:none;}}&.mobile{display:none;@media ", _prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .tabletSm */ .FV, "{display:inline;}}}");
    },
    titleSize: {
        xxl: /*#__PURE__*/ (0,_emotion_css__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)("font-size:62px;line-height:72px;@media ", _prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .belowLargeScreen */ .Qo, "{font-size:52px;line-height:62px;}@media ", _prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .tabletSm */ .FV, "{font-size:46px;line-height:56px;}"),
        xl: /*#__PURE__*/ (0,_emotion_css__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)("font-size:52px;line-height:62px;@media ", _prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .belowLargeScreen */ .Qo, "{font-size:42px;line-height:50px;}@media ", _prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .tabletSm */ .FV, "{font-size:42px;line-height:52px;}"),
        l: /*#__PURE__*/ (0,_emotion_css__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)("font-size:42px;line-height:50px;@media ", _prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .belowLargeScreen */ .Qo, "{font-size:36px;line-height:44px;}"),
        m: /*#__PURE__*/ (0,_emotion_css__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)("font-size:36px;line-height:44px;@media ", _prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .belowLargeScreen */ .Qo, "{font-size:32px;line-height:40px;}")
    },
    description: function(colour, tabletBreakpoint) {
        return /*#__PURE__*/ (0,_emotion_css__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)("color:", colour, ";margin-top:12px;font-size:16px;line-height:24px;font-weight:400;@media ", tabletBreakpoint, "{margin-top:8px;}br{&.desktop{@media ", tabletBreakpoint, "{display:none;}}&.tablet{display:none;@media ", tabletBreakpoint, "{display:inline;}@media ", _prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .tabletSm */ .FV, "{display:none;}}&.mobile{display:none;@media ", _prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .tabletSm */ .FV, "{display:inline;}}}");
    },
    descriptionLarge: /*#__PURE__*/ (0,_emotion_css__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)("font-size:22px;line-height:30px;font-weight:400;@media ", _prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .tabletSm */ .FV, "{font-size:18px;line-height:20px;}"),
    imageDesktop: function(tabletBreakpoint) {
        return /*#__PURE__*/ (0,_emotion_css__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)("display:block;@media ", tabletBreakpoint, "{display:none;}");
    },
    imageTablet: function(tabletBreakpoint) {
        return /*#__PURE__*/ (0,_emotion_css__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)("display:none;@media ", tabletBreakpoint, "{display:block;}@media ", _prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .tabletSm */ .FV, "{display:none;}");
    },
    imageMobile: /*#__PURE__*/ (0,_emotion_css__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)("display:none;@media ", _prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .tabletSm */ .FV, "{display:block;}")
};
var descriptionSizes = {
    regular: sharedStyles.description,
    large: function(colour, tabletBreakpoint) {
        return (0,_emotion_css__WEBPACK_IMPORTED_MODULE_0__.cx)(sharedStyles.description(colour, tabletBreakpoint), sharedStyles.descriptionLarge);
    }
};
var getTitleSize = function(size) {
    return sharedStyles.titleSize[size];
};
var getDescriptionStyles = function(size) {
    return descriptionSizes[size];
};
var highligtTitle = function(title) {
    var openBracketIndex = title.indexOf("{");
    var closeBracketIndex = title.indexOf("}");
    var beforeHighlight = title.slice(0, openBracketIndex);
    var highlight = title.slice(openBracketIndex + 1, closeBracketIndex);
    var afterHighlight = title.slice(closeBracketIndex + 1);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            beforeHighlight,
            /*#__PURE__*/ _jsx("span", {
                children: highlight
            }),
            afterHighlight
        ]
    });
};
var hightlightTitleAsString = function(title) {
    return title.replace("{", "<span>").replace("}", "</span>");
};


/***/ }),

/***/ 94257:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ library_SkuCarousel; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/css/dist/emotion-css.esm.js
var emotion_css_esm = __webpack_require__(97133);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/theme/Theme__Color.bs.js
var Theme_Color_bs = __webpack_require__(17845);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/theme/Theme__Responsive.bs.js
var Theme_Responsive_bs = __webpack_require__(70965);
// EXTERNAL MODULE: ./src/models/Models.bs.js
var Models_bs = __webpack_require__(37698);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon-ui/lib/components/Box/index.js
var Box = __webpack_require__(18636);
// EXTERNAL MODULE: ./node_modules/swiper/swiper-react.mjs + 2 modules
var swiper_react = __webpack_require__(48929);
// EXTERNAL MODULE: ./node_modules/swiper/modules/index.mjs + 26 modules
var modules = __webpack_require__(99304);
// EXTERNAL MODULE: ./node_modules/rescript-classnames/src/Cn.bs.js
var Cn_bs = __webpack_require__(20859);
// EXTERNAL MODULE: ./src/components/library/Button.bs.js
var Button_bs = __webpack_require__(59037);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/belt_Option.js
var belt_Option = __webpack_require__(72491);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(67814);
;// CONCATENATED MODULE: ./src/components/library/RibbonNavgationArrows.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE





function RibbonNavgationArrows(props) {
    return jsx_runtime.jsx("div", {
        children: jsx_runtime.jsxs("div", {
            children: [
                jsx_runtime.jsx("button", {
                    children: jsx_runtime.jsx(index_es.FontAwesomeIcon, {
                        icon: [
                            "fas",
                            "chevron-left"
                        ],
                        className: ""
                    }),
                    className: Cn_bs/* make */.S([
                        Button_bs/* redCircleStyle */.Gx,
                        props.prevArrowClass,
                        "h-8 w-8 text-white flex items-center justify-center mr-3 transition-all duration-300 ease-in-out hover:shadow-md shadow-xl"
                    ]),
                    onClick: function onClick(e) {
                        e.preventDefault();
                    }
                }),
                jsx_runtime.jsx("button", {
                    children: jsx_runtime.jsx(index_es.FontAwesomeIcon, {
                        icon: [
                            "fas",
                            "chevron-right"
                        ],
                        className: ""
                    }),
                    className: Cn_bs/* make */.S([
                        Button_bs/* redCircleStyle */.Gx,
                        props.nextArrowClass,
                        "h-8 w-8 text-white flex items-center justify-center ml-3 transition-all duration-300 ease-in-out hover:shadow-md shadow-xl"
                    ]),
                    onClick: function onClick(e) {
                        e.preventDefault();
                    }
                })
            ],
            className: "flex"
        }),
        className: belt_Option/* getWithDefault */.tj(props.className, "absolute top-0 left-0 ml-10 z-10 pl-10")
    });
}
var make = RibbonNavgationArrows;
 /* Button Not a pure module */ 

// EXTERNAL MODULE: ./src/hooks/useSegment.ts
var useSegment = __webpack_require__(59945);
// EXTERNAL MODULE: ./src/bindings/Segment.bs.js + 1 modules
var Segment_bs = __webpack_require__(73840);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/contexts/ConfigProvider.tsx
var ConfigProvider = __webpack_require__(33162);
// EXTERNAL MODULE: ./src/components/CardZoomAnimation.bs.js
var CardZoomAnimation_bs = __webpack_require__(12054);
// EXTERNAL MODULE: ./src/common/util.bs.js
var util_bs = __webpack_require__(7667);
// EXTERNAL MODULE: ./src/bindings/BsCss.bs.js + 1 modules
var BsCss_bs = __webpack_require__(71863);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/curry.js
var curry = __webpack_require__(92592);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/js_dict.js
var js_dict = __webpack_require__(43437);
// EXTERNAL MODULE: ./src/components/CmsImage.bs.js
var CmsImage_bs = __webpack_require__(34442);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/caml_array.js
var caml_array = __webpack_require__(46150);
// EXTERNAL MODULE: ./node_modules/bs-css/src/Css_Legacy_Core.bs.js
var Css_Legacy_Core_bs = __webpack_require__(68364);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/common/Tag/Tag.bs.js
var Tag_bs = __webpack_require__(22492);
;// CONCATENATED MODULE: ./src/components/library/CarouselCard.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE













var tagline = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* marginBottom */.yl7(BsCss_bs.px(12)),
    tl: {
        hd: BsCss_bs/* marginLeft */.oIA(BsCss_bs.px(12)),
        tl: {
            hd: BsCss_bs/* marginRight */.wzR(BsCss_bs.px(12)),
            tl: {
                hd: BsCss_bs/* media */.BC2("(min-width: 768px)", {
                    hd: BsCss_bs/* marginLeft */.oIA(BsCss_bs.px(16)),
                    tl: {
                        hd: BsCss_bs/* marginRight */.wzR(BsCss_bs.px(16)),
                        tl: /* [] */ 0
                    }
                }),
                tl: /* [] */ 0
            }
        }
    }
});
var card = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* position */.FKU("relative"),
    tl: {
        hd: BsCss_bs/* overflow */.txR("hidden"),
        tl: {
            hd: BsCss_bs/* borderRadius */.E0l(BsCss_bs.px(8)),
            tl: {
                hd: BsCss_bs/* boxShadow */.Wnp(Css_Legacy_Core_bs/* Shadow.box */.jXB.box(BsCss_bs.px(0), BsCss_bs.px(10), BsCss_bs.px(30), undefined, undefined, BsCss_bs/* rgba */.m4f(209, 213, 223, BsCss_bs/* pct */.hdZ(50.0)))),
                tl: /* [] */ 0
            }
        }
    }
});
var Styles = {
    tagline: tagline,
    card: card
};
function CarouselCard(props) {
    var card$1 = props.card;
    var hasPromos = card$1.promos.length !== 0;
    var skuData = js_dict/* get */.U2(belt_Option/* getWithDefault */.tj(props.skuDict, {}), card$1.cmsId);
    var imageUrl = skuData !== undefined && skuData.themes.length !== 0 ? belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(caml_array/* get */.U2(skuData.themes, 0), function(a) {
        return a.image.url;
    }), card$1.imgUrl) : card$1.imgUrl;
    var promoIcon_src = __webpack_require__(92441);
    return jsx_runtime.jsxs("div", {
        children: [
            hasPromos ? jsx_runtime.jsx(CmsImage_bs/* make */.S, {
                src: promoIcon_src,
                alt: "Promo icon",
                width: 30,
                height: 79,
                className: "absolute top-0 left-0 z-10"
            }) : null,
            jsx_runtime.jsx((link_default()), {
                href: "/store/" + card$1.slug,
                prefetch: false,
                children: jsx_runtime.jsxs("a", {
                    children: [
                        jsx_runtime.jsx(CmsImage_bs/* make */.S, {
                            src: imageUrl,
                            alt: card$1.name,
                            width: 452,
                            height: 280,
                            className: "rounded-t-lg",
                            sizes: "(max-width: 600px) 72vw, (max-width: 900px) 40vw, (max-width: 1200px) 28vw, (max-width: 1440px) 17vw, 246px",
                            priority: props.preload
                        }),
                        jsx_runtime.jsxs("div", {
                            children: [
                                jsx_runtime.jsx("h3", {
                                    children: card$1.isSwappable ? util_bs/* ReactStuff.s */.p_.s(card$1.displayName) : util_bs/* ReactStuff.s */.p_.s(card$1.name),
                                    className: "font-semibold sm:text-17px leading-5 px-3 md:px-4 mb-2 mt-3"
                                }),
                                card$1.tagline.length > 0 ? jsx_runtime.jsx(Tag_bs.make, {
                                    children: util_bs/* ReactStuff.s */.p_.s(card$1.tagline),
                                    className: tagline
                                }) : jsx_runtime.jsx("p", {
                                    children: util_bs/* ReactStuff.s */.p_.s(card$1.priceRange),
                                    className: "text-mid-gray px-3 md:px-4 text-sm leading-4 md:pb-3"
                                })
                            ],
                            className: "h-23"
                        })
                    ],
                    title: card$1.name,
                    onClick: function onClick(param) {
                        Segment_bs/* productClicked */.rC(Object.assign(Segment_bs/* cardToProduct */.Op(card$1), {
                            position: 0
                        }));
                    }
                })
            })
        ],
        className: Cn_bs/* make */.S([
            card,
            "carousel-card"
        ])
    });
}
var Link$1;
var Img;
var Tag;
var SkuPresentation;
var CarouselCard_bs_make = CarouselCard;
 /* tagline Not a pure module */ 

;// CONCATENATED MODULE: ./src/components/library/SkuCarousel.tsx



















var style = {
    arrows: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("position:absolute;top:-36px;right:0;z-index:10;"),
    swiperOverlay: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("position:absolute;bottom:0;right:0;z-index:3;width:80px;background-color:#", Theme_Color_bs/* Personal.charcoal.VAL */.RL.charcoal.VAL, ";background:linear-gradient(-90deg,#fff 0%,transparent 100%);height:95%;@media ", Theme_Responsive_bs/* mobile */.ai, "{display:none;}"),
    swiperOverlayHidden: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("display:none;"),
    swiper: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("/* styles to display slides before swiper initialized to prevent layout shift */\n    .swiper-slide{width:83.256%;margin-right:2px;height:auto;@media (min-width:600px){width:43.024%;}@media (min-width:900px){width:28.568%;}@media (min-width:1200px){width:18.913%;margin-right:5px;}}")
};
// @ts-ignore
var RemoteSkuTile = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 263).then(__webpack_require__.t.bind(__webpack_require__, 20263, 23));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(20263)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("span", {});
    },
    ssr: false
});
var SkuTileContainer = dynamic_default()(function() {
    return(// @ts-ignore using HeroBannerContainer from consumer_woc to provide theme to SkuTile as it does the stuff we want. TODO: Fix this, consumer-ui to be it's own MFE
    __webpack_require__.e(/* import() */ 9963).then(__webpack_require__.t.bind(__webpack_require__, 89963, 23)).then(function(m) {
        return m.HeroBannerContainer;
    }));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(89963)
            ];
        }
    },
    ssr: false
});
var getUniqueClass = function(classname, uid) {
    return uid !== "" ? "".concat(classname, "-").concat(uid) : classname;
};
var getCardPosition = function(card) {
    var featuredCategory = card.categories.find(function(card) {
        return card.slug === "featured";
    });
    return featuredCategory ? featuredCategory.skuPosition : 0;
};
var SkuCarousel = function(param) {
    var className = param.className, _inventory = param.inventory, inventory = _inventory === void 0 ? {
        skus: []
    } : _inventory, skuDict = param.skuDict, _skuList = param.skuList, skuList = _skuList === void 0 ? [] : _skuList, _uid = param.uid, uid = _uid === void 0 ? "" : _uid, _cardsList = param.cardsList, cardsList = _cardsList === void 0 ? [] : _cardsList;
    var isLastSlide = (0,react.useRef)(false);
    var config = (0,ConfigProvider/* useConfig */.ZR)();
    var ref = (0,react.useState)(true), isDesktopOrTablet = ref[0], setIsDesktopOrTablet = ref[1];
    var ref1 = (0,react.useState)(false), isClient = ref1[0], setIsClient = ref1[1];
    var customElementInteraction = (0,useSegment/* default */.Z)().customElementInteraction;
    (0,react.useEffect)(function() {
        setIsClient("object" !== "undefined");
    }, []);
    (0,react.useEffect)(function() {
        var handleWindowResize = function() {
            setIsDesktopOrTablet(window.innerWidth >= 768);
        };
        window.addEventListener("resize", handleWindowResize);
        return function() {
            window.removeEventListener("resize", handleWindowResize);
        };
    }, []);
    var currentCards = (0,react.useMemo)(function() {
        var cards = inventory.skus.length ? inventory.skus.map(function(sku) {
            return Models_bs/* Card.skuToCard */.Zb.skuToCard(sku);
        }) : cardsList;
        var pinnedCards = skuList.length !== 0 ? cards.filter(function(card) {
            return skuList.includes(card.slug);
        }).sort(function(a, b) {
            return skuList.indexOf(a.slug) - skuList.indexOf(b.slug);
        }) : [];
        var list = pinnedCards.length !== 0 ? pinnedCards : cards.filter(function(card) {
            return card.categories.find(function(category) {
                return category.name === "Featured";
            });
        }).sort(function(a, b) {
            return getCardPosition(a) - getCardPosition(b);
        });
        return list;
    }, [
        inventory.skus,
        skuList,
        cardsList
    ]);
    var onSlideChange = function(swiper) {
        isLastSlide.current = swiper.isEnd;
    };
    return(// @ts-ignore
    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(SkuTileContainer, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(Box["default"], {
            position: "relative",
            marginTop: "-36px",
            paddingTop: "36px",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(swiper_react/* Swiper */.tq, {
                    // Ignoring due to these issue with type exports
                    //  - https://github.com/nolimits4web/swiper/issues/6843 & https://github.com/nolimits4web/swiper/issues/6885
                    // @ts-ignore
                    modules: [
                        modules/* Pagination */.tl,
                        modules/* Navigation */.W_,
                        modules/* Scrollbar */.LW
                    ],
                    scrollbar: {
                        hide: isDesktopOrTablet
                    },
                    onSlideChange: onSlideChange,
                    spaceBetween: 50,
                    slidesPerView: 7,
                    className: (0,emotion_css_esm.cx)(style.swiper, className),
                    breakpoints: {
                        0: {
                            slidesPerView: 1.2,
                            spaceBetween: 2,
                            slidesPerGroup: 1
                        },
                        600: {
                            slidesPerView: 2.2,
                            spaceBetween: 2,
                            slidesPerGroup: 2
                        },
                        900: {
                            slidesPerView: 3.2,
                            spaceBetween: 2,
                            slidesPerGroup: 3
                        },
                        1200: {
                            slidesPerView: 5.2,
                            spaceBetween: 5,
                            slidesPerGroup: 5
                        }
                    },
                    grabCursor: true,
                    freeMode: true,
                    navigation: {
                        nextEl: getUniqueClass(".navigation-next", uid),
                        prevEl: getUniqueClass(".navigation-prev", uid),
                        disabledClass: "btn-disabled"
                    },
                    onSlideNextTransitionStart: function() {
                        customElementInteraction((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, Segment_bs/* userType */.AW), {
                            element: "list_scroll_forward",
                            journey: "sku_list"
                        }));
                    },
                    onSlidePrevTransitionStart: function() {
                        customElementInteraction((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, Segment_bs/* userType */.AW), {
                            element: "list_scroll_backward",
                            journey: "sku_list"
                        }));
                    },
                    children: currentCards.map(function(card, index) {
                        var ref, ref1, ref2;
                        var href = "/store/".concat(card.slug, "/");
                        var imgSrc = (ref = card.themes) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.image;
                        var hasPromos = (ref2 = card.promos) === null || ref2 === void 0 ? void 0 : ref2.some(function(promo) {
                            return promo.enabled;
                        });
                        var tags = card.tagline ? [
                            card.tagline
                        ] : [];
                        var title = card.displayName;
                        var banner;
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(swiper_react/* SwiperSlide */.o5, {
                            children: (config === null || config === void 0 ? void 0 : config.featureLayerBuyingWeb) ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Box["default"], {
                                transition: "transform 0.3s ease",
                                _hover: {
                                    transform: "scale(1.05)"
                                },
                                mx: 2,
                                height: "100%",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(RemoteSkuTile, {
                                    // @ts-ignore
                                    title: title,
                                    imgSrc: imgSrc,
                                    imgAlt: title,
                                    href: href,
                                    ribbon: hasPromos,
                                    tags: tags,
                                    height: "100%",
                                    banner: banner
                                })
                            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(CardZoomAnimation_bs/* make */.S, {
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(CarouselCard_bs_make, {
                                    card: card,
                                    skuDict: skuDict,
                                    preload: isClient
                                })
                            })
                        }, card.uid);
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                    className: (0,emotion_css_esm.cx)(style.swiperOverlay, "sku-swiper-overlay", isLastSlide.current ? style.swiperOverlayHidden : "")
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(make, {
                    className: (0,emotion_css_esm.cx)("mb-30px invisible md:visible", style.arrows),
                    prevArrowClass: getUniqueClass("navigation-prev", uid),
                    nextArrowClass: getUniqueClass("navigation-next", uid)
                })
            ]
        })
    }));
};
/* harmony default export */ var library_SkuCarousel = (SkuCarousel);


/***/ }),

/***/ 95853:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sy": function() { return /* binding */ make; }
/* harmony export */ });
/* unused harmony exports Link, BoardOfDirectorsCard, BoardOfDirectorsCarousel, BoardOfDirectorsList, SwiperSlide, KontentConsumer, Styles */
/* harmony import */ var _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71863);
/* harmony import */ var _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(92592);
/* harmony import */ var _bindings_Fresnel_bs_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7545);
/* harmony import */ var _CmsImage_bs_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34442);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(96533);
/* harmony import */ var _index_IndexStyles_bs_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(28848);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(48929);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85893);
/* harmony import */ var _prezzee_ribbon_src_components_personal_Kontent_Kontent_bs_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(72721);
/* harmony import */ var _index_KontentContextProvider_bs_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26396);
/* harmony import */ var _prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(70965);
/* harmony import */ var _prezzee_ribbon_src_components_personal_BoardOfDirectors_BoardOfDirectorsCard_bs_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(44599);
/* harmony import */ var _prezzee_ribbon_src_components_personal_BoardOfDirectors_BoardOfDirectorsList_bs_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(57458);
/* harmony import */ var _prezzee_ribbon_src_components_personal_BoardOfDirectors_BoardOfDirectorsCarousel_bs_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(96705);
// Generated by ReScript, PLEASE EDIT WITH CARE















var outerContainer = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_13__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv, {
    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .position */ .FKU("relative"),
    tl: {
        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .marginTop */ .E9m(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .rem */ .hOB(5)),
        tl: /* [] */ 0
    }
});
var container = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_13__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .merge */ .TSy, {
    hd: _index_IndexStyles_bs_js__WEBPACK_IMPORTED_MODULE_4__/* .section */ .qi,
    tl: {
        hd: _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_13__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv, {
            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .maxWidth */ .kkr(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(1240)),
            tl: {
                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .marginTop */ .E9m(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(100)),
                tl: {
                    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .paddingLeft */ .rv2(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(20)),
                    tl: {
                        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .paddingRight */ .WLm(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(20)),
                        tl: {
                            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .media */ .BC2(_prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_9__/* .belowLargeScreen */ .Qo, {
                                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .paddingLeft */ .rv2(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(20)),
                                tl: {
                                    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .paddingRight */ .WLm(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(20)),
                                    tl: /* [] */ 0
                                }
                            }),
                            tl: /* [] */ 0
                        }
                    }
                }
            }
        }),
        tl: /* [] */ 0
    }
});
var heading = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_13__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv, {
    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontSize */ .JBY(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(40)),
    tl: {
        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontWeight */ .Ue2({
            NAME: "num",
            VAL: 600
        }),
        tl: {
            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .lineHeight */ .Nv8(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(50)),
            tl: {
                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .marginBottom */ .yl7(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .rem */ .hOB(1.25)),
                tl: /* [] */ 0
            }
        }
    }
});
var arrowStyles = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_13__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv, {
    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .top */ .wey("zero"),
    tl: {
        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .right */ .F2z(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(30)),
        tl: {
            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .position */ .FKU("absolute"),
            tl: {
                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .zIndex */ .W5D(10),
                tl: /* [] */ 0
            }
        }
    }
});
var cardGutter = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_13__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv, {
    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .marginRight */ .wzR(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .rem */ .hOB(0.5)),
    tl: {
        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .marginBottom */ .yl7(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(7)),
        tl: {
            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .media */ .BC2(_prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_9__/* .smallScreenOrMobile */ .HH, {
                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .marginRight */ .wzR(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .rem */ .hOB(0)),
                tl: /* [] */ 0
            }),
            tl: /* [] */ 0
        }
    }
});
var listItem = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_13__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv, {
    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .maxWidth */ .kkr(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(650)),
    tl: {
        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .marginLeft */ .oIA("auto"),
        tl: {
            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .marginRight */ .wzR("auto"),
            tl: /* [] */ 0
        }
    }
});
var Styles = {
    outerContainer: outerContainer,
    container: container,
    heading: heading,
    arrowStyles: arrowStyles,
    cardGutter: cardGutter,
    listItem: listItem
};
function BoardOfDirectorsSection(props) {
    var block = props.block;
    var smartLink = block.smartLink;
    var title = block.title;
    var blockTitle = title === "" ? null : react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx("div", {
        children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx("h2", {
            children: title,
            className: heading
        }),
        className: container
    });
    var boardOfDirectorsCards = _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_14__/* .map */ .UI(block.board_of_directors_cards, function(param) {
        var smartLink = param.smartLink;
        var link = param.link;
        var title = param.title;
        var name = param.name;
        var photo = param.photo;
        var img = react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx(_CmsImage_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .make */ .S, {
            src: photo.url,
            alt: name,
            width: photo.width,
            height: photo.height,
            sizes: "" + _prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_9__/* .smallScreenOrMobile */ .HH + " 100vw, " + _prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_9__/* .tabletOrMobile */ .k$ + " 255px, 425px"
        });
        var card = link !== undefined ? react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
            href: link,
            prefetch: false,
            children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx("a", {
                children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx(_prezzee_ribbon_src_components_personal_BoardOfDirectors_BoardOfDirectorsCard_bs_js__WEBPACK_IMPORTED_MODULE_10__/* .make */ .S, {
                    name: name,
                    title: title,
                    photo: img
                })
            })
        }) : react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx(_prezzee_ribbon_src_components_personal_BoardOfDirectors_BoardOfDirectorsCard_bs_js__WEBPACK_IMPORTED_MODULE_10__/* .make */ .S, {
            name: name,
            title: title,
            photo: img
        });
        return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx(_index_KontentContextProvider_bs_js__WEBPACK_IMPORTED_MODULE_8__/* .make */ .S, {
            children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx("div", {
                children: card,
                className: cardGutter
            }),
            itemId: smartLink.itemId,
            elementCodename: smartLink.codename
        });
    });
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx(_index_KontentContextProvider_bs_js__WEBPACK_IMPORTED_MODULE_8__/* .make */ .S, {
        children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx(_prezzee_ribbon_src_components_personal_Kontent_Kontent_bs_js__WEBPACK_IMPORTED_MODULE_7__/* .Consumer.make */ .$.make, {
            children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs("div", {
                children: [
                    blockTitle,
                    react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.Fragment, {
                        children: [
                            react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx(_bindings_Fresnel_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .Media.make */ .pU.make, {
                                lessThan: "md",
                                children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx(_prezzee_ribbon_src_components_personal_BoardOfDirectors_BoardOfDirectorsList_bs_js__WEBPACK_IMPORTED_MODULE_11__/* .make */ .S, {
                                    children: _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_14__/* .mapWithIndex */ .Su(boardOfDirectorsCards, function(idx, card) {
                                        var key = String(idx);
                                        return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx("div", {
                                            children: card,
                                            className: listItem
                                        }, key);
                                    })
                                })
                            }),
                            react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx(_bindings_Fresnel_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .Media.make */ .pU.make, {
                                greaterThanOrEqual: "md",
                                children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx(_prezzee_ribbon_src_components_personal_BoardOfDirectors_BoardOfDirectorsCarousel_bs_js__WEBPACK_IMPORTED_MODULE_12__/* .make */ .Sy, {
                                    children: _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_14__/* .mapWithIndex */ .Su(boardOfDirectorsCards, function(idx, card) {
                                        var key = String(idx);
                                        return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx(swiper_react__WEBPACK_IMPORTED_MODULE_5__/* .SwiperSlide */ .o5, {
                                            children: card
                                        }, key);
                                    }),
                                    arrowStyles: arrowStyles
                                })
                            })
                        ]
                    })
                ],
                className: outerContainer
            })
        }),
        itemId: smartLink.itemId,
        elementCodename: smartLink.codename
    });
}
var Link$1;
var BoardOfDirectorsCard;
var BoardOfDirectorsCarousel;
var BoardOfDirectorsList;
var SwiperSlide;
var KontentConsumer;
var make = BoardOfDirectorsSection;
 /* outerContainer Not a pure module */ 


/***/ }),

/***/ 41653:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sy": function() { return /* binding */ make; }
/* harmony export */ });
/* unused harmony exports KontentContextConsumer, Styles */
/* harmony import */ var rescript_classnames_src_Cn_bs_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(20859);
/* harmony import */ var _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71863);
/* harmony import */ var _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(92592);
/* harmony import */ var _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(96533);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _prezzee_ribbon_src_components_personal_Text_Text_bs_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(25519);
/* harmony import */ var _prezzee_ribbon_src_bindings_Vimeo_bs_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51741);
/* harmony import */ var _prezzee_ribbon_src_components_personal_Kontent_Kontent_bs_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72721);
/* harmony import */ var _index_KontentContextProvider_bs_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26396);
/* harmony import */ var _prezzee_ribbon_src_components_personal_RichText_RichText_bs_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(78078);
/* harmony import */ var _prezzee_ribbon_src_components_personal_Accordion_Accordion_bs_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(34891);
/* harmony import */ var _prezzee_ribbon_src_theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(17845);
/* harmony import */ var _prezzee_ribbon_src_components_personal_Accordion_Accordion_Panel_bs_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(23864);
/* harmony import */ var _prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(70965);
/* harmony import */ var _prezzee_ribbon_src_theme_Theme_Typography_bs_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(32567);
/* harmony import */ var _prezzee_ribbon_src_components_personal_Accordion_Accordion_Heading_bs_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(50700);
/* harmony import */ var _prezzee_ribbon_src_components_personal_Accordion_Accordion_Trigger_bs_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(75421);
/* harmony import */ var _prezzee_ribbon_src_components_personal_VimeoPlayer_VimeoPlayer_Video_bs_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(99956);
/* harmony import */ var _prezzee_ribbon_src_components_personal_VimeoPlayer_VimeoPlayer_Player_bs_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(64797);
// Generated by ReScript, PLEASE EDIT WITH CARE



















var wrapper = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_15__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv, {
    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .paddingTop */ .odA(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(100)),
    tl: {
        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .paddingBottom */ .EtG(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(100)),
        tl: {
            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .backgroundColor */ .Czw(_prezzee_ribbon_src_theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_7__/* .Business.stone */ .e.stone),
            tl: {
                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .media */ .BC2(_prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_9__/* .mobile */ .ai, {
                    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .paddingTop */ .odA(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(50)),
                    tl: {
                        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .paddingBottom */ .EtG(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(50)),
                        tl: /* [] */ 0
                    }
                }),
                tl: /* [] */ 0
            }
        }
    }
});
var container = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_15__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv, {
    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .maxWidth */ .kkr(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(650)),
    tl: {
        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .padding2 */ .BLt(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .zero */ .bMI, _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(20)),
        tl: {
            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .margin2 */ .h9x(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .zero */ .bMI, "auto"),
            tl: /* [] */ 0
        }
    }
});
var blockTitle = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_15__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .merge */ .TSy, {
    hd: _prezzee_ribbon_src_theme_Theme_Typography_bs_js__WEBPACK_IMPORTED_MODULE_10__/* .Styles.style1 */ .z.style1,
    tl: {
        hd: _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_15__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv, {
            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .color */ .$_Y(_prezzee_ribbon_src_theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_7__/* .Business.charcoal */ .e.charcoal),
            tl: {
                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .media */ .BC2(_prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_9__/* .mobile */ .ai, {
                    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .important */ .efO(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontSize */ .JBY(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(24))),
                    tl: {
                        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .important */ .efO(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .lineHeight */ .Nv8(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(40))),
                        tl: /* [] */ 0
                    }
                }),
                tl: {
                    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .selector */ .nZE("strong", {
                        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .color */ .$_Y(_prezzee_ribbon_src_theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_7__/* .Business.prezzeePurple */ .e.prezzeePurple),
                        tl: /* [] */ 0
                    }),
                    tl: /* [] */ 0
                }
            }
        }),
        tl: /* [] */ 0
    }
});
var section = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_15__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv, {
    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .paddingTop */ .odA(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(50)),
    tl: {
        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .paddingBottom */ .EtG(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(50)),
        tl: {
            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .media */ .BC2(_prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_9__/* .mobile */ .ai, {
                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .paddingTop */ .odA(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(20)),
                tl: {
                    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .paddingBottom */ .EtG(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(20)),
                    tl: /* [] */ 0
                }
            }),
            tl: {
                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .lastChild */ .QOo({
                    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .paddingBottom */ .EtG(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .zero */ .bMI),
                    tl: /* [] */ 0
                }),
                tl: /* [] */ 0
            }
        }
    }
});
var sectionTitle = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_15__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .merge */ .TSy, {
    hd: _prezzee_ribbon_src_theme_Theme_Typography_bs_js__WEBPACK_IMPORTED_MODULE_10__/* .Styles.style2 */ .z.style2,
    tl: {
        hd: _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_15__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv, {
            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .color */ .$_Y(_prezzee_ribbon_src_theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_7__/* .Business.charcoal */ .e.charcoal),
            tl: {
                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .important */ .efO(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .marginBottom */ .yl7(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(20))),
                tl: {
                    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .media */ .BC2(_prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_9__/* .mobile */ .ai, {
                        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .important */ .efO(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontSize */ .JBY(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(20))),
                        tl: {
                            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .important */ .efO(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .lineHeight */ .Nv8(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(20))),
                            tl: /* [] */ 0
                        }
                    }),
                    tl: /* [] */ 0
                }
            }
        }),
        tl: /* [] */ 0
    }
});
var accordion = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_15__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv, {
    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .marginBottom */ .yl7(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(20)),
    tl: {
        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .lastChild */ .QOo({
            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .marginBottom */ .yl7(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .zero */ .bMI),
            tl: /* [] */ 0
        }),
        tl: /* [] */ 0
    }
});
var accordionTitle = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_15__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv, {
    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .color */ .$_Y(_prezzee_ribbon_src_theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_7__/* .Business.charcoal */ .e.charcoal),
    tl: /* [] */ 0
});
var videoContainer = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_15__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv, {
    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .margin2 */ .h9x(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .rem */ .hOB(1), "zero"),
    tl: {
        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .position */ .FKU("relative"),
        tl: {
            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .paddingTop */ .odA(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .pct */ .hdZ(360 / 510 * 100)),
            tl: {
                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .selector */ .nZE("iframe", {
                    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .position */ .FKU("absolute"),
                    tl: {
                        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .left */ .t$v("zero"),
                        tl: {
                            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .top */ .wey("zero"),
                            tl: {
                                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .width */ .bf$(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .pct */ .hdZ(100)),
                                tl: {
                                    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .height */ .Cb8(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .pct */ .hdZ(100)),
                                    tl: /* [] */ 0
                                }
                            }
                        }
                    }
                }),
                tl: /* [] */ 0
            }
        }
    }
});
var richText = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_15__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv, {
    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .selector */ .nZE("a", {
        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .color */ .$_Y({
            NAME: "hex",
            VAL: "1E54B7"
        }),
        tl: {
            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .textDecoration */ .QXS("underline"),
            tl: /* [] */ 0
        }
    }),
    tl: {
        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .selector */ .nZE("ul", {
            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .listStyleType */ .jZR("disc"),
            tl: {
                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .paddingLeft */ .rv2(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(28)),
                tl: /* [] */ 0
            }
        }),
        tl: {
            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .selector */ .nZE("ol", {
                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .listStyleType */ .jZR("decimal"),
                tl: {
                    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .paddingLeft */ .rv2(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(28)),
                    tl: /* [] */ 0
                }
            }),
            tl: {
                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .selector */ .nZE("p + ul, p + ol", {
                    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .marginTop */ .E9m(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(12)),
                    tl: /* [] */ 0
                }),
                tl: /* [] */ 0
            }
        }
    }
});
var additionalContent = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_15__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv, {
    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .marginTop */ .E9m(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(32)),
    tl: {
        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .media */ .BC2(_prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_9__/* .mobile */ .ai, {
            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .marginTop */ .E9m(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(16)),
            tl: /* [] */ 0
        }),
        tl: /* [] */ 0
    }
});
var Styles = {
    wrapper: wrapper,
    container: container,
    blockTitle: blockTitle,
    section: section,
    sectionTitle: sectionTitle,
    accordion: accordion,
    accordionTitle: accordionTitle,
    videoContainer: videoContainer,
    richText: richText,
    additionalContent: additionalContent
};
function FAQSection(props) {
    var block = props.block;
    var blockSmartLink = block.smart_link;
    var additionalContent$1 = block.additionalContent;
    var playerOptions = _prezzee_ribbon_src_bindings_Vimeo_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Player.options */ .J.options(undefined, false, undefined, undefined, undefined, true, undefined, false, false, undefined, undefined, undefined, true, undefined, undefined, undefined, undefined, undefined, undefined);
    var sections = _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_16__/* .mapWithIndex */ .Su(block.faq_sections, function(index, section$1) {
        var sectionSmartLink = section$1.smart_link;
        var sectionTitle$1 = section$1.title;
        var key = index.toString();
        var items = _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_16__/* .mapWithIndex */ .Su(section$1.faq_items, function(idx, item) {
            var itemSmartLink = item.smart_link;
            var body_content = item.body_content;
            var itemKey = idx.toString();
            var bodyContent = body_content.length !== 0 ? _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_16__/* .mapWithIndex */ .Su(body_content, function(bcIdx, bc) {
                var bcKey = bcIdx.toString();
                return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx("div", {
                    children: bc.NAME === "RichText" ? react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx(_prezzee_ribbon_src_components_personal_RichText_RichText_bs_js__WEBPACK_IMPORTED_MODULE_5__.make, {
                        children: bc.VAL,
                        className: richText
                    }) : react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx("div", {
                        children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx(_prezzee_ribbon_src_components_personal_VimeoPlayer_VimeoPlayer_Video_bs_js__WEBPACK_IMPORTED_MODULE_13__/* .make */ .S, {
                            videoUrl: bc.VAL,
                            children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx(_prezzee_ribbon_src_components_personal_VimeoPlayer_VimeoPlayer_Player_bs_js__WEBPACK_IMPORTED_MODULE_14__/* .make */ .Sy, {
                                id: bcKey + "--video",
                                playerOptions: playerOptions
                            })
                        }),
                        className: videoContainer
                    })
                }, bcKey);
            }) : react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx(_prezzee_ribbon_src_components_personal_RichText_RichText_bs_js__WEBPACK_IMPORTED_MODULE_5__.make, {
                children: item.body_text,
                className: richText
            });
            return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx(_index_KontentContextProvider_bs_js__WEBPACK_IMPORTED_MODULE_4__/* .make */ .S, {
                children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx(_prezzee_ribbon_src_components_personal_Kontent_Kontent_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .Consumer.make */ .$.make, {
                    children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx("div", {
                        children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs(_prezzee_ribbon_src_components_personal_Accordion_Accordion_bs_js__WEBPACK_IMPORTED_MODULE_6__.make, {
                            children: [
                                react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx(_prezzee_ribbon_src_components_personal_Accordion_Accordion_Heading_bs_js__WEBPACK_IMPORTED_MODULE_11__.make, {
                                    children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx(_prezzee_ribbon_src_components_personal_Accordion_Accordion_Trigger_bs_js__WEBPACK_IMPORTED_MODULE_12__.make, {
                                        children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx(_prezzee_ribbon_src_components_personal_Text_Text_bs_js__WEBPACK_IMPORTED_MODULE_17__/* .make */ .S, {
                                            children: item.title
                                        })
                                    }),
                                    className: accordionTitle
                                }),
                                react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx(_prezzee_ribbon_src_components_personal_Accordion_Accordion_Panel_bs_js__WEBPACK_IMPORTED_MODULE_8__.make, {
                                    children: bodyContent
                                })
                            ],
                            colour: /* White */ 2,
                            shadow: /* Normal */ 1
                        }),
                        className: accordion
                    })
                }),
                itemId: itemSmartLink.itemId,
                elementCodename: itemSmartLink.codename
            }, itemKey);
        });
        return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx(_index_KontentContextProvider_bs_js__WEBPACK_IMPORTED_MODULE_4__/* .make */ .S, {
            children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx(_prezzee_ribbon_src_components_personal_Kontent_Kontent_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .Consumer.make */ .$.make, {
                children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs("div", {
                    children: [
                        sectionTitle$1 !== "" ? react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx("h2", {
                            children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx(_prezzee_ribbon_src_components_personal_Text_Text_bs_js__WEBPACK_IMPORTED_MODULE_17__/* .make */ .S, {
                                children: sectionTitle$1
                            }),
                            className: sectionTitle
                        }) : null,
                        items,
                        react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx(_prezzee_ribbon_src_components_personal_RichText_RichText_bs_js__WEBPACK_IMPORTED_MODULE_5__.make, {
                            children: additionalContent$1,
                            className: rescript_classnames_src_Cn_bs_js__WEBPACK_IMPORTED_MODULE_18__/* .make */ .S([
                                richText,
                                additionalContent
                            ])
                        })
                    ],
                    className: section
                })
            }),
            itemId: sectionSmartLink.itemId,
            elementCodename: sectionSmartLink.codename
        }, key);
    });
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx(_index_KontentContextProvider_bs_js__WEBPACK_IMPORTED_MODULE_4__/* .make */ .S, {
        children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx(_prezzee_ribbon_src_components_personal_Kontent_Kontent_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .Consumer.make */ .$.make, {
            children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx("div", {
                children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs("div", {
                    children: [
                        react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx("div", {
                            children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx(_prezzee_ribbon_src_components_personal_RichText_RichText_bs_js__WEBPACK_IMPORTED_MODULE_5__.make, {
                                children: block.title
                            }),
                            className: blockTitle
                        }),
                        sections
                    ],
                    className: container
                }),
                className: wrapper
            })
        }),
        itemId: blockSmartLink.itemId,
        elementCodename: blockSmartLink.codename
    });
}
var KontentContextConsumer;
var make = FAQSection;
 /* wrapper Not a pure module */ 


/***/ }),

/***/ 78056:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ zag_ZagExplanationModal; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon-ui/lib/components/Modal/index.js
var Modal = __webpack_require__(15115);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon-ui/lib/components/Typography/index.js
var Typography = __webpack_require__(43543);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon-ui/lib/components/Button/index.js
var Button = __webpack_require__(43515);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon-ui/lib/components/Box/index.js
var Box = __webpack_require__(18636);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon-ui/lib/components/Stack/index.js
var Stack = __webpack_require__(72406);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon-ui/lib/hooks/useDisclosure.js
var useDisclosure = __webpack_require__(18500);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon-ui/lib/components/icons/ChevronLeftIcon.js
var ChevronLeftIcon = __webpack_require__(50256);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/pages/store/RetailerListModal.tsx
var RetailerListModal = __webpack_require__(99725);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useQuery.mjs + 6 modules
var useQuery = __webpack_require__(67848);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./src/api/helpers.ts + 72 modules
var helpers = __webpack_require__(60693);
;// CONCATENATED MODULE: ./src/api/queries/zagInfoModal.ts



var zagInfoModal = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(language, isPreview) {
        var client, data;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    client = (0,helpers/* createDeliveryClient */.As)(language, isPreview);
                    return [
                        4,
                        client.item("zag_explanation_modal").toPromise()
                    ];
                case 1:
                    return [
                        4,
                        _state.sent().data
                    ];
                case 2:
                    data = _state.sent();
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function zagInfoModal(language, isPreview) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var queries_zagInfoModal = (zagInfoModal);

// EXTERNAL MODULE: ./src/common/util.bs.js
var util_bs = __webpack_require__(7667);
// EXTERNAL MODULE: ./node_modules/react-html-parser/lib/index.js
var lib = __webpack_require__(30653);
;// CONCATENATED MODULE: ./src/components/pages/store/zag/ZagExplanationModal.tsx
















var ZagExplanationModal = function(param) {
    var sku = param.sku, onClose = param.onClose;
    var ref, ref1, ref2;
    var retailerListDialog = (0,useDisclosure/* default */.Z)();
    var ref3 = (0,useQuery/* useQuery */.a)([
        "zagInfoModal"
    ], function() {
        return queries_zagInfoModal(util_bs/* EnvUtil.getCmsLanguageFromRegion */.i3.getCmsLanguageFromRegion(), false);
    }), data = ref3.data, isError = ref3.isError, isLoading = ref3.isLoading;
    var desktopScreen = window.matchMedia("(min-width: 577px)");
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(react.Fragment, {
        children: [
            !retailerListDialog.isOpen && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(Modal/* Modal */.u_, {
                isOpen: true,
                onClose: onClose,
                isCentered: true,
                size: desktopScreen.matches ? "md" : "xs",
                scrollBehavior: "inside",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Modal/* ModalOverlay */.ZA, {}),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(Modal/* ModalContent */.hz, {
                        maxWidth: "800px",
                        margin: "20px",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Modal/* ModalHeader */.xB, {
                                pb: 0,
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Typography["default"], {
                                    variant: "h2",
                                    color: "gray.800",
                                    fontSize: "24",
                                    fontWeight: "bold",
                                    children: "Prezzee Plus eGift Card"
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Modal/* ModalCloseButton */.ol, {
                                mt: 3
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(Modal/* ModalBody */.fe, {
                                children: [
                                    isLoading && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Box["default"], {
                                        display: "flex",
                                        justifyContent: "center",
                                        children: "Loading"
                                    }),
                                    isError && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Box["default"], {
                                        display: "flex",
                                        justifyContent: "center",
                                        children: "Failed to fetch data, please try again later"
                                    }),
                                    data && (0,lib/* default */.ZP)(data.item.elements.content.value, {
                                        transform: function(node) {
                                            var ref;
                                            // Should move this to util package when we have the chance
                                            if ((node === null || node === void 0 ? void 0 : node.type) === "tag" && (node === null || node === void 0 ? void 0 : node.name) === "a") {
                                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Button["default"], (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                                    as: "a",
                                                    variant: "link",
                                                    textDecoration: "underline",
                                                    fontSize: "sm"
                                                }, node.attribs), {
                                                    children: node === null || node === void 0 ? void 0 : node.children.map(function(child) {
                                                        if (child.type === "text") {
                                                            return child.data;
                                                        }
                                                        return null;
                                                    })
                                                }));
                                            }
                                            if ((node === null || node === void 0 ? void 0 : node.type) === "text" && (node === null || node === void 0 ? void 0 : (ref = node.data) === null || ref === void 0 ? void 0 : ref.includes("{0}"))) {
                                                var ref1;
                                                var tempStrArr = node === null || node === void 0 ? void 0 : (ref1 = node.data) === null || ref1 === void 0 ? void 0 : ref1.split("{0}");
                                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(emotion_react_jsx_runtime_browser_esm.Fragment, {
                                                    children: [
                                                        tempStrArr === null || tempStrArr === void 0 ? void 0 : tempStrArr[0],
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Button["default"], {
                                                            variant: "link",
                                                            onClick: retailerListDialog.onOpen,
                                                            fontSize: "md",
                                                            textDecoration: "underline",
                                                            mb: "4",
                                                            children: data.item.elements.participating_brands_link.value
                                                        })
                                                    ]
                                                });
                                            }
                                        }
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Stack.VStack, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, buttonStackStyles), {
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Button["default"], {
                                            variant: "primary",
                                            onClick: onClose,
                                            width: "full",
                                            children: data === null || data === void 0 ? void 0 : (ref = data.item) === null || ref === void 0 ? void 0 : (ref1 = ref.elements) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.cta_text) === null || ref2 === void 0 ? void 0 : ref2.value
                                        })
                                    }))
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(RetailerListModal/* default */.Z, {
                showDefaultStore: true,
                isOpen: retailerListDialog.isOpen,
                onClose: function() {
                    retailerListDialog.onClose();
                    onClose();
                },
                uid: sku === null || sku === void 0 ? void 0 : sku.uid,
                title: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(emotion_react_jsx_runtime_browser_esm.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Button["default"], {
                            leftIcon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Box["default"], {
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(ChevronLeftIcon/* default */.Z, {})
                            }),
                            variant: "unstyled",
                            onClick: retailerListDialog.onClose,
                            children: "Back"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("br", {}),
                        "Available brands"
                    ]
                })
            })
        ]
    });
};
var buttonStackStyles = {
    justifyContent: "flex-start",
    alignItems: "flex-start",
    mb: 4
};
/* harmony default export */ var zag_ZagExplanationModal = (ZagExplanationModal);


/***/ }),

/***/ 50247:
/***/ (function() {

/* (ignored) */

/***/ })

}]);